(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Tab') {
      document.documentElement.classList.add('keyboard-navigation');
    }
  }, true);

  document.addEventListener('pointerdown', () => {
    document.documentElement.classList.remove('keyboard-navigation');
  }, true);

  const money = (cents) => {
    const minorUnits = Number(cents) || 0;
    const hasFraction = Math.abs(minorUnits) % 100 !== 0;
    const fractionDigits = hasFraction ? 2 : 0;

    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR',
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }).format(minorUnits / 100);
  };

  // Shared active campaign prices for Home, Shop and the product page.
  const activePriceAmount = (cents) => {
    const parts = new Intl.NumberFormat(
      document.documentElement.lang || 'en',
      {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    ).formatToParts((Number(cents) || 0) / 100);

    const currency = parts
      .filter((part) => part.type === 'currency')
      .map((part) => part.value)
      .join('');
    const whole = parts
      .filter((part) => ['integer', 'group'].includes(part.type))
      .map((part) => part.value)
      .join('');
    const centsText = parts.find((part) => part.type === 'fraction')?.value || '00';

    return `
      <span class="ia-active-price__amount">
        <span class="sr-only">${money(cents)}</span>
        <span class="ia-active-price__amount-visual" aria-hidden="true">
          <span class="ia-active-price__currency">${currency}</span>
          <span class="ia-active-price__whole">${whole}</span>
          <sup class="ia-active-price__cents">${centsText}</sup>
        </span>
      </span>
    `;
  };

  const activeCompareAmount = (cents) =>
    new Intl.NumberFormat(
      document.documentElement.lang || 'en',
      { maximumFractionDigits: 2 }
    ).format((Number(cents) || 0) / 100);

  const activePriceMarkup = (ctaType = 'link') => {
    const publicSaving = Number(earlyAccess.savingPercentage) || 0;
    const subscriberSaving = Number(earlyAccess.subscriberSavingPercentage) || 0;
    const subscriberPrice = Number(earlyAccess.subscriberPrice) || 0;
    const hasSubscriberOffer = subscriberSaving > publicSaving && subscriberPrice > 0;
    const confirmed = hasSubscriberOffer && (
      earlyAccess.customerEmailSubscribed === true ||
      earlyAccess.unlocked === true ||
      isSubscriberEmailVisitor
    );
    const regularPrice = Number(earlyAccess.rrp) || 0;
    const arrow = document.querySelector('.inline-arrow')?.outerHTML ||
      '<svg class="inline-arrow" viewBox="0 0 18 18" aria-hidden="true" focusable="false"><path d="M4 14 14 4"/><path d="M6 4h8v8"/></svg>';
    const signupCta = ctaType === 'button'
      ? `<button type="button" class="ia-active-price__cta" data-pdp-active-subscriber-cta><span>get subscriber price</span>${arrow}</button>`
      : `<a class="ia-active-price__cta" href="${earlyAccess.product.url}?subscriber_offer=1"><span>get subscriber price</span>${arrow}</a>`;

    return `
      <div class="ia-active-price${confirmed || !hasSubscriberOffer ? ' ia-active-price--single' : ''}">
      ${confirmed ? '' : `
        <div class="ia-active-price__panel ia-active-price__panel--public">
          <div class="ia-active-price__header">
            <span class="ia-active-price__label"><strong>PUBLIC</strong> OFFER</span>
            <span class="ia-active-price__badge" aria-label="${publicSaving}% off">${publicSaving}%</span>
          </div>
          <div class="ia-active-price__values">
            ${activePriceAmount(earlyAccess.publicPrice)}
            ${regularPrice > 0 ? `
              <span class="ia-active-price__comparison">
                <span class="sr-only">Regular price ${money(regularPrice)}</span>
                <s aria-hidden="true">${activeCompareAmount(regularPrice)}</s>
              </span>
            ` : ''}
          </div>
        </div>
      `}
      ${hasSubscriberOffer ? `
        <div class="ia-active-price__panel ia-active-price__panel--subscriber">
          <div class="ia-active-price__header">
            <span class="ia-active-price__label"><strong>SUBSCRIBER</strong> OFFER</span>
            <span class="ia-active-price__badge" aria-label="${subscriberSaving}% off">${subscriberSaving}%</span>
          </div>
          <div class="ia-active-price__subscriber-bottom">
            <div class="ia-active-price__values">
              ${activePriceAmount(subscriberPrice)}
              ${regularPrice > 0 ? `
                <span class="ia-active-price__comparison">
                  <span class="sr-only">Regular price ${money(regularPrice)}</span>
                  <s aria-hidden="true">${activeCompareAmount(regularPrice)}</s>
                </span>
              ` : ''}
            </div>
            ${confirmed ? '' : signupCta}
          </div>
        </div>
      ` : ''}
      </div>
    `;
  };


  // Home and Shop use the same active product banner on the join page.
  const activeShopBannerMarkup = (priceCtaType = 'link') => {
    const featureArrowMarkup =
      document.querySelector('.inline-arrow')?.outerHTML || '';
    return `
    <div class="ea-shop-feature-visual">
      <img alt="" hidden>
    </div>

    <a
      class="ea-shop-feature-link"
      href="#"
    ></a>

    <div class="ea-shop-feature-content">
      <div class="ea-shop-feature-copy">
        <div class="pdp-ea-status">
          <span>${
            earlyAccess.product?.isNew
              ? 'new · intro offer'
              : 'intro offer'
          }</span>
          <span aria-hidden="true">·</span>
          <strong></strong>
        </div>

        <strong class="ea-shop-feature-heading"></strong>
        <span class="ea-shop-feature-meta"></span>
      </div>

      <div class="ea-shop-feature-bottom">
        ${activePriceMarkup(priceCtaType)}

        <span
          class="home-ea-hero__primary ea-shop-feature-cta"
          aria-hidden="true"
        >
          <span>view ${earlyAccess.product.title}</span>

          <span
            class="home-route-arrow ea-shop-feature-cta-arrow"
          >
            ${featureArrowMarkup}
          </span>
        </span>
      </div>
    </div>
  `;
  };

  const getReadableTextColour = (hex) => {
    const value =
      String(hex || '')
        .replace('#', '')
        .trim();

    if (!/^[0-9a-f]{6}$/i.test(value)) {
      return '#1c1a18';
    }

    const getLuminance = (colour) => {
      const channels =
        [0, 2, 4].map((index) => {
          const channel =
            parseInt(
              colour.slice(index, index + 2),
              16
            ) / 255;

          return channel <= 0.03928
            ? channel / 12.92
            : Math.pow(
                (channel + 0.055) / 1.055,
                2.4
              );
        });

      return (
        0.2126 * channels[0] +
        0.7152 * channels[1] +
        0.0722 * channels[2]
      );
    };

    const contrastRatio = (a, b) =>
      (Math.max(a, b) + 0.05) /
      (Math.min(a, b) + 0.05);

    const background =
      getLuminance(value);

    const ink =
      getLuminance('1c1a18');

    const paper =
      getLuminance('e7e7e7');

    return contrastRatio(
      background,
      paper
    ) >
      contrastRatio(
        background,
        ink
      )
      ? '#e7e7e7'
      : '#1c1a18';
  };

  const unlockKey = 'inlet-freebies-unlocked';
  const storefrontRoot = window.Inlet?.routes?.root || '/';

  const subscriberVisitKey =
    'inlet-subscriber-email-visit';

  const isSubscriberEmailLink =
    new URLSearchParams(
      window.location.search
    ).get('ia_subscriber') === '1';

  if (isSubscriberEmailLink) {
    sessionStorage.setItem(
      subscriberVisitKey,
      'true'
    );
  }

  let isSubscriberEmailVisitor =
    isSubscriberEmailLink ||
    sessionStorage.getItem(
      subscriberVisitKey
    ) === 'true';

  const earlyAccessDataNode =
    $('#InletEarlyAccessData');

  let earlyAccess = {
    state: 'none',
    unlocked: false
  };

  if (earlyAccessDataNode) {
    try {
      const data = JSON.parse(
        earlyAccessDataNode.textContent
      );

      if (data.product?.id && data.endUnix) {
        const now = Date.now();

        const preStart =
          Number(data.preStartUnix) * 1000;

        const start =
          Number(data.startUnix) * 1000;

        const end =
          Number(data.endUnix) * 1000;

        let state = 'ended';

        if (
          data.previewState === 'pre' ||
          data.previewState === 'active'
        ) {
          state = data.previewState;
        } else if (
          preStart > 0 &&
          now < preStart
        ) {
          state = 'none';
        } else if (now < start) {
          state = 'pre';
        } else if (now < end) {
          state = 'active';
        }

        const browserUnlockKey =
          `inlet-ea-unlocked-${data.product.id}-${data.endUnix}`;

        let unlocked = false;

        try {
          unlocked =
            state === 'active' &&
            localStorage.getItem(
              browserUnlockKey
            ) === 'true';
        } catch (error) {
          unlocked = false;
        }

        earlyAccess = {
          ...data,
          state,
          unlocked,
          browserUnlockKey
        };
      }
    } catch (error) {
      console.warn(
        'Unable to read Early Access campaign.',
        error
      );
    }
  }

  window.Inlet = window.Inlet || {};
  window.Inlet.earlyAccess = earlyAccess;

  if (
    typeof earlyAccess.customerEmailSubscribed === 'boolean'
  ) {
    isSubscriberEmailVisitor =
      earlyAccess.customerEmailSubscribed;

    if (!isSubscriberEmailVisitor) {
      sessionStorage.removeItem(
        subscriberVisitKey
      );
    }
  }

  const scheduleEarlyAccessBoundaryReload = () => {
    if (!earlyAccess.product?.id) return;

    const boundaryUnix =
      earlyAccess.state === 'none'
        ? Number(earlyAccess.preStartUnix)
        : earlyAccess.state === 'pre'
          ? Number(earlyAccess.startUnix)
          : earlyAccess.state === 'active'
            ? Number(earlyAccess.endUnix)
            : 0;

    if (!boundaryUnix) return;

    const delay =
      boundaryUnix * 1000 - Date.now();

    if (delay <= 0) return;

    window.setTimeout(
      () => {
        window.location.reload();
      },
      Math.min(
        delay + 250,
        2147483000
      )
    );
  };

  scheduleEarlyAccessBoundaryReload();

  // Track submissions from the Join the List page.
  const joinSignupPendingKey = 'inlet-join-signup-pending';
  const joinSignupForm = $('.signup-page .signup-form');

  if (joinSignupForm) {
    joinSignupForm.addEventListener('submit', () => {
      try {
        sessionStorage.setItem(joinSignupPendingKey, String(Date.now()));
      } catch (_) {}
    });
  }

  const joinSignupConfirmed =
    new URLSearchParams(window.location.search).get('customer_posted') === 'true';

  let recentlySubmittedJoinForm = false;

  try {
    const submittedAt = Number(
      sessionStorage.getItem(joinSignupPendingKey)
    );

    recentlySubmittedJoinForm =
      submittedAt > 0 &&
      Date.now() - submittedAt < 10 * 60 * 1000;
  } catch (_) {}

  if (joinSignupConfirmed && recentlySubmittedJoinForm) {
    try {
      sessionStorage.removeItem(joinSignupPendingKey);

      if (earlyAccess.state === 'active' && earlyAccess.browserUnlockKey) {
        localStorage.setItem(earlyAccess.browserUnlockKey, 'true');
        earlyAccess.unlocked = true;
      }
    } catch (_) {}

    if (!joinSignupForm) {
      window.location.replace(
        `${storefrontRoot}pages/join-the-list?customer_posted=true#signup-form`
      );
      return;
    }
  }

  const applyEarlyAccessJoinPage = () => {
    const page = $('.signup-page');

    if (
      !page ||
      earlyAccess.state !== 'active' ||
      !earlyAccess.product?.id
    ) {
      return;
    }

    page.classList.add(
      'is-pre-early-access'
    );

    if ($('.signup-success', page) && earlyAccess.browserUnlockKey) {
      try {
        localStorage.setItem(earlyAccess.browserUnlockKey, 'true');
        earlyAccess.unlocked = true;
      } catch (_) {}
    }

    const title =
      earlyAccess.product.title ||
      'this release';

    const descriptor =
      earlyAccess.product.descriptor || '';

    const productUrl =
      earlyAccess.product.url ||
      `${storefrontRoot}collections/instruments`;

    const subscriberSaving =
      Number(
        earlyAccess.subscriberSavingPercentage
      ) || 0;

    const remaining =
      Number(earlyAccess.endUnix) * 1000 -
      Date.now();

    const day =
      24 * 60 * 60 * 1000;

    const hour =
      60 * 60 * 1000;

    let timeRemaining = '';

    if (remaining > 2 * day) {
      const days =
        Math.ceil(remaining / day);

      timeRemaining =
        `${days} ${
          days === 1 ? 'day' : 'days'
        } left`;
    } else if (remaining > 0) {
      const hours =
        Math.max(
          1,
          Math.ceil(remaining / hour)
        );

      timeRemaining =
        `${hours} ${
          hours === 1 ? 'hour' : 'hours'
        } left`;
    }



    const summary =
      $('.signup-summary', page);

    if (summary) {
      summary.classList.remove(
        'signup-summary--ea',
        'signup-summary--ea-product'
      );
      summary.classList.add('signup-summary--ea-banner');

      const banner = document.createElement('div');
      banner.className = 'ea-shop-feature signup-ea-active-preview';
      banner.style.setProperty(
        '--ea-accent', earlyAccess.accentColour || '#d3f986'
      );
      banner.style.setProperty(
        '--ea-accent-text',
        getReadableTextColour(earlyAccess.accentColour || '#d3f986')
      );
      banner.style.setProperty(
        '--ea-soft', earlyAccess.softColour || '#e7e7e7'
      );
      banner.style.setProperty(
        '--ea-deep', earlyAccess.deepColour || '#1c1a18'
      );
      banner.innerHTML = activeShopBannerMarkup();

      const image = $('img', banner);
      if (image && earlyAccess.shopImage) {
        image.src = earlyAccess.shopImage;
        image.hidden = false;
      }

      const productLink = $('.ea-shop-feature-link', banner);
      productLink.href = productUrl;
      productLink.setAttribute(
        'aria-label', `View full ${title} product page`
      );

      $('.pdp-ea-status > strong', banner).textContent = timeRemaining;
      $('.ea-shop-feature-heading', banner).textContent = title;
      const descriptorNode = $('.ea-shop-feature-meta', banner);
      descriptorNode.textContent = descriptor;
      descriptorNode.hidden = !descriptor;
      summary.replaceChildren(banner);
    }

    const formLabel =
      $('.signup-card-heading .section-label', page);

    if (formLabel) {
      formLabel.textContent =
        'subscriber intro price';
    }

    const formHeading =
      $('.signup-card-heading h2', page);

    if (formHeading) {
      formHeading.textContent =
        subscriberSaving
          ? `Get ${subscriberSaving}% off ${title}.`
          : `Get the ${title} subscriber intro price.`;

      const formBridge =
        document.createElement('p');

      formBridge.className =
        'signup-ea-form-bridge';

      formBridge.textContent =
        'Join the list to unlock the subscriber intro price. It will be applied automatically at checkout.';

      formHeading.after(
        formBridge
      );
    }

    const consent =
      $('.signup-consent span', page);

    if (consent) {
      consent.textContent =
        `I’d like the subscriber intro price for ${title} and Inlet Audio emails about new releases and offers.`;
    }

    const submit =
      $('.signup-submit', page);

    if (submit) {
      const arrow =
        $('svg', submit)?.outerHTML ||
        '↗';

      submit.innerHTML =
        `get subscriber intro price ${arrow}`;
    }





    const success =
      $('.signup-success', page);

    if (!success) return;

    const successLabel =
      $('.section-label', success);

    const successHeading =
      $('h2', success);

    const successCopy =
      $('.signup-success > div > p:not(.section-label)', page);

    const successLink =
      $('a', success);

    if (successLabel) {
      successLabel.textContent =
        'subscriber intro price unlocked';
    }

    if (successHeading) {
      successHeading.textContent =
        subscriberSaving
          ? `You’ve unlocked ${subscriberSaving}% off ${title}.`
          : `Your ${title} subscriber price is unlocked.`;
    }

    if (successCopy) {
      successCopy.textContent =
        'Your subscriber intro price will be applied automatically at checkout. Welcome to the list!';
    }

    if (successLink) {
      const arrow =
        $('svg', successLink)?.outerHTML ||
        '↗';

      successLink.href =
        productUrl;

      successLink.innerHTML =
        `get ${title} ${arrow}`;
    }
  };

  const applyPreEarlyAccessJoinPage = () => {
    const page = $('.signup-page');

    if (
      !page ||
      earlyAccess.state !== 'pre' ||
      !earlyAccess.product?.id
    ) {
      return;
    }

    page.classList.add(
      'is-pre-early-access'
    );

    const title =
      earlyAccess.product.title ||
      'this release';

    const descriptor =
      earlyAccess.preLaunchSlogan ||
      earlyAccess.product.descriptor ||
      earlyAccess.product.summary ||
      '';

    const publicSaving =
      Number(
        earlyAccess.savingPercentage
      ) || 0;

    const subscriberSaving =
      Number(
        earlyAccess.subscriberSavingPercentage
      ) || 0;

    const launchDate =
      new Date(Number(earlyAccess.startUnix) * 1000);

    const preLaunchTime =
      Number.isNaN(launchDate.getTime())
        ? ''
        : new Intl.DateTimeFormat('en-GB', {
            day: 'numeric',
            month: 'short'
          }).format(launchDate);

    const kicker =
      $('.hero-kicker', page);

    if (kicker) {
      kicker.textContent =
        'more for subscribers';
    }

    const summary =
      $('.signup-summary', page);

    if (summary) {
      summary.classList.remove(
        'signup-summary--ea',
        'signup-summary--ea-product'
      );

      summary.classList.add(
        'signup-summary--ea-banner'
      );

      const banner =
        document.createElement('div');

      banner.className =
        'ea-shop-feature is-pre-early-access signup-ea-shop-preview';

      const accentColour =
        earlyAccess.accentColour || '#d3f986';

      banner.style.setProperty(
        '--ea-soft',
        earlyAccess.softColour || '#e7e7e7'
      );
      banner.style.setProperty(
        '--ea-deep',
        earlyAccess.deepColour || '#1c1a18'
      );
      banner.style.setProperty('--ea-accent', accentColour);
      banner.style.setProperty(
        '--ea-accent-text',
        getReadableTextColour(accentColour)
      );

      banner.innerHTML = `
        <div class="ea-shop-feature-visual">
          <img alt="" hidden>
        </div>
        <a
          class="ea-shop-feature-link"
          href=""
          tabindex="-1"
          aria-hidden="true"
        ></a>
        <div class="ea-shop-feature-content">
          <div class="ea-shop-feature-copy">
            <div class="ea-shop-feature-status-row">
              <div class="pdp-ea-status">
                <span></span>
              </div>
            </div>
            <strong class="ea-shop-feature-heading"></strong>
            <span class="ea-shop-feature-meta"></span>
          </div>
          <div class="ea-shop-feature-bottom">
            <div class="home-pre-ea-offer ea-shop-feature-offer">
              <span>subscribers save more</span>
              <div class="home-pre-ea-offer-price">
                <strong></strong>
              </div>
              <small hidden></small>
            </div>
            <a
              class="home-pre-ea-offer-trigger ea-shop-feature-cta"
              href=""
            >
              <span></span>
            </a>
          </div>
        </div>
      `;

      const image = $('img', banner);
      if (earlyAccess.shopImage) {
        image.src = earlyAccess.shopImage;
        image.hidden = false;
      }

      $('.pdp-ea-status span', banner).textContent =
        preLaunchTime
          ? `coming soon · ${preLaunchTime}`
          : 'coming soon';
      $('.ea-shop-feature-heading', banner).textContent =
        title;
      const descriptorNode = $('.ea-shop-feature-meta', banner);
      descriptorNode.textContent = descriptor;
      descriptorNode.hidden = !descriptor;

      $('.home-pre-ea-offer-price strong', banner).textContent =
        subscriberSaving
          ? `${subscriberSaving}% off at launch`
          : 'subscriber launch offer';

      const publicOffer = $('.ea-shop-feature-offer small', banner);
      publicOffer.textContent =
        publicSaving ? `public launch offer: ${publicSaving}% off` : '';
      publicOffer.hidden = !publicSaving;

      const previewLink = $('a.ea-shop-feature-cta', banner);
      previewLink.href =
        earlyAccess.product.url ||
        `${storefrontRoot}collections/instruments`;
      $('span', previewLink).textContent = `preview ${title}`;
      $('.ea-shop-feature-link', banner).href = previewLink.href;

      summary.replaceChildren(banner);
    }

    const formLabel =
      $('.signup-card-heading .section-label', page);

    if (formLabel) {
      formLabel.textContent =
        'get the subscriber offer';

      formLabel.classList.add(
        'signup-card-offer-label'
      );
    }

    const formHeading =
      $('.signup-card-heading h2', page);

    if (formHeading) {
      formHeading.textContent =
        subscriberSaving
          ? `Get ${subscriberSaving}% off ${title}.`
          : `Get the ${title} subscriber offer.`;

      const formBridge =
        document.createElement('p');

      formBridge.className =
        'signup-ea-form-bridge signup-ea-form-bridge--prelaunch';

      formBridge.textContent =
        `Join the list and we’ll email you when ${title} goes live. `;

      const welcomePerk =
        document.createElement('span');

      welcomePerk.className =
        'signup-ea-form-bridge__perk';

      welcomePerk.textContent =
        'Plus, get 10% off your first paid order.';

      formBridge.appendChild(welcomePerk);

      formHeading.after(
        formBridge
      );
    }

    const consent =
      $('.signup-consent span', page);

    if (consent) {
      consent.textContent =
        `I’d like the subscriber offer for ${title} and Inlet Audio emails about new releases and offers.`;
    }

    const submit =
      $('.signup-submit', page);

    if (submit) {
      const arrow =
        $('svg', submit)?.outerHTML ||
        '';

      submit.innerHTML =
        subscriberSaving
          ? `get ${subscriberSaving}% off ${title} ${arrow}`
          : `get the subscriber offer ${arrow}`;
    }

    const benefitsHeading =
      $('.signup-benefits-heading h2', page);

    if (benefitsHeading) {
      benefitsHeading.textContent =
        'Three reasons to join.';
    }

    const benefits =
      $$('.signup-benefit-grid article', page);

    if (benefits[1]) {
      const heading =
        $('h3', benefits[1]);

      const copy =
        $('p', benefits[1]);

      if (heading) {
        heading.textContent =
          'Better launch offers.';
      }

      if (copy) {
        copy.textContent =
          'Subscribers get a deeper intro offer on selected new releases.';
      }
    }

    if (benefits[2]) {
      const heading =
        $('h3', benefits[2]);

      const copy =
        $('p', benefits[2]);

      if (heading) {
        heading.textContent =
          'First looks at new releases.';
      }

      if (copy) {
        copy.textContent =
          'Get release news and previews in your inbox.';
      }
    }

    const success =
      $('.signup-success', page);

    if (!success) return;

    const successLabel =
      $('.section-label', success);

    const successHeading =
      $('h2', success);

    const successCopy =
      $('.signup-success > div > p:not(.section-label)', page);

    if (successLabel) {
      successLabel.textContent =
        'you’re on the list';
    }

    if (successHeading) {
      successHeading.textContent =
        'Your subscriber offer is secured.';
    }

    if (successCopy) {
      successCopy.textContent =
        `We’ll email you when ${title} launches. You're on the list!`;
    }
  };

  applyPreEarlyAccessJoinPage();
  applyEarlyAccessJoinPage();

  const addCampaignMobileWelcomeBenefit = () => {
    const page = $('.signup-page');

    if (
      !page ||
      earlyAccess.state !== 'active'
    ) {
      return;
    }

    const signupCard =
      $('.signup-card', page);

    if (!signupCard) return;

    const existingMobilePerk =
      $('.signup-mobile-welcome-perk', page);

    if (existingMobilePerk) {
      existingMobilePerk.remove();
    }

    const existingPerk =
      $('.signup-pre-ea-perk', page);

    const perk =
      existingPerk
        ? existingPerk.cloneNode(true)
        : document.createElement('div');

    perk.classList.add(
      'signup-pre-ea-perk',
      'signup-mobile-welcome-perk'
    );

    if (!existingPerk) {
      perk.innerHTML = `
        <span class="signup-pre-ea-perk__label">
          welcome benefit
        </span>

        <strong class="signup-pre-ea-perk__title">
          10% off
        </strong>

        <span class="signup-pre-ea-perk__copy">
          your first paid order.
        </span>

        <span class="signup-pre-ea-perk__note">
          First paid order? Your 10% code will arrive in your welcome email.
        </span>
      `;
    }

    signupCard.insertAdjacentElement(
      'afterend',
      perk
    );
  };

  addCampaignMobileWelcomeBenefit();

  const applyEarlyAccessCards = () => {
  if (!earlyAccess.product?.id) {
    return;
  }

  $$('[data-product-card]').forEach((card) => {
    if (
      String(card.dataset.productId) !==
      String(earlyAccess.product.id)
    ) {
      return;
    }

    if (earlyAccess.state === 'pre') {
      card.hidden = true;
      return;
    }

    card.hidden = false;

    if (earlyAccess.state !== 'active') {
      return;
    }

    card.classList.add('is-early-access');

    const cardAccentColour =
      earlyAccess.accentColour ||
        '#d3f986';

    card.style.setProperty(
      '--intro-card-accent',
      cardAccentColour
    );

    card.style.setProperty(
      '--intro-card-accent-text',
      getReadableTextColour(
        cardAccentColour
      )
    );

    const libraryGrid = card.closest(
      '[data-product-grid="libraries"]'
    );

    if (libraryGrid) {
      libraryGrid.prepend(card);
    }

    const imageWrap = $('.image-wrap', card);

    if (!imageWrap) return;

    let badge = $('.product-badge', imageWrap);

    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'product-badge';
      imageWrap.appendChild(badge);
    }

    badge.classList.add(
      'early-access-card-badge'
    );

    const badgeWasNew =
      badge.textContent
        .trim()
        .toLowerCase() === 'new';

    badge.textContent =
      badgeWasNew
        ? 'new · intro offer'
        : 'intro offer';

    const cardPrice =
      $('.price', card);

    if (cardPrice) {
      const publicSaving =
        Number(
          earlyAccess.savingPercentage
        ) || 0;

      const subscriberSaving =
        Number(
          earlyAccess.subscriberSavingPercentage
        ) || 0;

      const subscriberPrice =
        Number(
          earlyAccess.subscriberPrice
        ) || 0;

      cardPrice.classList.add(
        'intro-card-pricing'
      );

      cardPrice.innerHTML = `
        <span class="intro-card-price-row">
          <s>${money(earlyAccess.rrp)}</s>
          <strong>${money(earlyAccess.publicPrice)}</strong>
          <small>${publicSaving}% off</small>
        </span>

        ${
          subscriberSaving > publicSaving &&
          subscriberPrice > 0
            ? `
                <span class="intro-card-subscriber-row">
                <span>subscribers</span>
                <strong>${money(subscriberPrice)}</strong>
                <small>${subscriberSaving}% off</small>
              </span>
            `
            : ''
        }
      `;
    }
  });
};

applyEarlyAccessCards();

const formatEarlyAccessTime = (endUnix) => {
  const remaining =
    Number(endUnix) * 1000 - Date.now();

  if (remaining <= 0) return '';

  const day =
    24 * 60 * 60 * 1000;

  const hour =
    60 * 60 * 1000;

  if (remaining > 2 * day) {
    const days =
      Math.ceil(remaining / day);

    return `${days} ${
      days === 1 ? 'day' : 'days'
    } left`;
  }

  const hours =
    Math.max(
      1,
      Math.ceil(remaining / hour)
    );

  return `${hours} ${
    hours === 1 ? 'hour' : 'hours'
  } left`;
};

const applyEarlyAccessCartLines = () => {
  if (
    earlyAccess.state !== 'active' ||
    !earlyAccess.product?.id
  ) {
    return;
  }

  $$(
    '.inlet-bag-line[data-product-id]'
  ).forEach((line) => {
    if (
      String(line.dataset.productId) !==
      String(earlyAccess.product.id)
    ) {
      return;
    }

    const copy =
      $('.inlet-bag-line__copy > div:first-child', line);

    if (copy) {
      let status =
        $('.inlet-bag-line__ea-status', line);

      if (!status) {
        status =
          document.createElement('p');

        status.className =
          'inlet-bag-line__ea-status';

        copy.appendChild(status);
      }

      status.textContent =
        `intro offer · ${formatEarlyAccessTime(
          earlyAccess.endUnix
        )}`;
    }

    const price =
      $('.inlet-bag-line__price', line);

    const quantity =
      Number(
        $('[data-cart-quantity]', line)?.value
      ) || 1;

    if (
      price &&
      Number(
        earlyAccess.product.compareAtPrice
      ) >
      Number(
        earlyAccess.product.price
      )
    ) {
      let compare =
        $('.inlet-bag-line__ea-compare', price);

      if (!compare) {
        compare =
          document.createElement('s');

        compare.className =
          'inlet-bag-line__ea-compare';

        price.prepend(compare);
      }

      compare.textContent =
        money(
          Number(
            earlyAccess.product.compareAtPrice
          ) * quantity
        );
    }
  });
};

const renderEarlyAccessShopFeature = () => {
  const feature = $('[data-ea-shop-feature]');

  if (!feature) return;

  const shouldShow =
    earlyAccess.state === 'active' &&
    earlyAccess.shopFeaturedModule === true &&
    earlyAccess.product?.id;

  feature.hidden = !shouldShow;

  if (!shouldShow) {
    feature.replaceChildren();
    return;
  }

  const remaining =
    Number(earlyAccess.endUnix) * 1000 - Date.now();

  const day = 24 * 60 * 60 * 1000;
  const hour = 60 * 60 * 1000;

  const timeRemaining =
    remaining <= 0
      ? ''
      : remaining > 2 * day
        ? `${Math.ceil(remaining / day)} ${
            Math.ceil(remaining / day) === 1
              ? 'day'
              : 'days'
          } left`
        : `${Math.max(1, Math.ceil(remaining / hour))} ${
            Math.max(1, Math.ceil(remaining / hour)) === 1
              ? 'hour'
              : 'hours'
          } left`;

  feature.innerHTML = activeShopBannerMarkup();

  const image = $('img', feature);

  if (earlyAccess.shopImage) {
    image.src = earlyAccess.shopImage;
    image.hidden = false;
  }

  const productCard =
    document.querySelector(
      `[data-product-card][data-product-id="${earlyAccess.product.id}"]`
    );

  const quickView =
    productCard
      ? $('[data-quick-view]', productCard)
      : null;

  const quickViewTemplate =
    quickView?.dataset.quickView
      ? document.getElementById(
          quickView.dataset.quickView
        )
      : null;

  const productData =
    quickViewTemplate?.content
      ?.firstElementChild
      ?.dataset;

  if (productData?.soft) {
    feature.style.setProperty(
      '--ea-soft',
      productData.soft
    );
  }

  if (productData?.deep) {
    feature.style.setProperty(
      '--ea-deep',
      productData.deep
    );
  }

  const accentColour =
    earlyAccess.accentColour ||
      '#d3f986';

  const getRelativeLuminance = (hex) => {
    const value =
      String(hex)
        .replace('#', '')
        .trim();

    if (!/^[0-9a-f]{6}$/i.test(value)) {
      return null;
    }

    const channels =
      [0, 2, 4].map((index) => {
        const channel =
          parseInt(
            value.slice(index, index + 2),
            16
          ) / 255;

        return channel <= 0.03928
          ? channel / 12.92
          : Math.pow(
              (channel + 0.055) / 1.055,
              2.4
            );
      });

    return (
      0.2126 * channels[0] +
      0.7152 * channels[1] +
      0.0722 * channels[2]
    );
  };

  const contrastRatio = (a, b) =>
    (Math.max(a, b) + 0.05) /
    (Math.min(a, b) + 0.05);

  const accentLuminance =
    getRelativeLuminance(accentColour);

  const inkLuminance =
    getRelativeLuminance('#1c1a18');

  const whiteLuminance =
    getRelativeLuminance('#e7e7e7');

  const accentTextColour =
    accentLuminance !== null &&
    contrastRatio(
      accentLuminance,
      whiteLuminance
    ) >
      contrastRatio(
        accentLuminance,
        inkLuminance
      )
      ? '#e7e7e7'
      : '#1c1a18';

  feature.style.setProperty(
    '--ea-accent',
    accentColour
  );

  feature.style.setProperty(
    '--ea-accent-text',
    accentTextColour
  );

  const productLink =
    $('.ea-shop-feature-link', feature);

  productLink.href =
    earlyAccess.product.url || '#';

  productLink.setAttribute(
    'aria-label',
    `View full ${earlyAccess.product.title} product page`
  );

  $('.pdp-ea-status > strong', feature)
    .textContent = timeRemaining;

  $('.ea-shop-feature-heading', feature)
    .textContent =
      earlyAccess.product.title;

  $('.ea-shop-feature-meta', feature)
    .textContent =
      earlyAccess.product.descriptor || '';

  const ctaTitle =
    $('[data-ea-shop-feature-cta-title]', feature);

  if (ctaTitle) {
    ctaTitle.textContent =
      earlyAccess.product.title || '';
  }

};

renderEarlyAccessShopFeature();

const showPreLaunchPreviewLink = (root, triggerSelector) => {
  if (isSubscriberEmailVisitor) {
    const offerLabel = $('.home-pre-ea-offer > span', root);

    if (offerLabel) {
      offerLabel.textContent =
        earlyAccess.customerEmailSubscribed === true
          ? 'your subscriber offer'
          : 'subscriber offer';
    }
  }

  const button = $(triggerSelector, root);

  if (!button) return;

  const link = document.createElement('a');
  link.className = button.className;
  link.href =
    earlyAccess.product.url ||
    `${storefrontRoot}collections/instruments`;
  link.innerHTML = button.innerHTML;

  const label = $('span', link);

  if (label) {
    label.textContent =
      `preview ${earlyAccess.product.title}`;
  }

  button.replaceWith(link);

  const panelLink =
    $('.ea-shop-feature-link, .home-pre-ea-hit', root);

  if (panelLink) {
    panelLink.href = link.href;
  }
};

const renderPreEarlyAccessShopFeature = () => {
  const feature =
    $('[data-ea-shop-feature]');

  if (
    !feature ||
    earlyAccess.state !== 'pre' ||
    earlyAccess.shopFeaturedModule !== true ||
    !earlyAccess.product?.id
  ) {
    return;
  }

  const featureArrowMarkup =
    document.querySelector('.inline-arrow')
      ?.outerHTML || '';

  const publicSaving =
    Number(
      earlyAccess.savingPercentage
    ) || 0;

  const subscriberSaving =
    Number(
      earlyAccess.subscriberSavingPercentage
    ) || 0;

  const formatPreLaunchTime = (startUnix) => {
    const launchDate =
      new Date(
        Number(startUnix) * 1000
      );

    if (
      Number.isNaN(
        launchDate.getTime()
      )
    ) {
      return '';
    }

    return new Intl.DateTimeFormat(
      'en-GB',
      {
        day: 'numeric',
        month: 'short'
      }
    ).format(launchDate);
  };

  const preLaunchTime =
    formatPreLaunchTime(
      earlyAccess.startUnix
    );

  const accentColour =
    earlyAccess.accentColour ||
      '#d3f986';

  const getRelativeLuminance = (hex) => {
    const value =
      String(hex)
        .replace('#', '')
        .trim();

    if (!/^[0-9a-f]{6}$/i.test(value)) {
      return null;
    }

    const channels =
      [0, 2, 4].map((index) => {
        const channel =
          parseInt(
            value.slice(index, index + 2),
            16
          ) / 255;

        return channel <= 0.03928
          ? channel / 12.92
          : Math.pow(
              (channel + 0.055) / 1.055,
              2.4
            );
      });

    return (
      0.2126 * channels[0] +
      0.7152 * channels[1] +
      0.0722 * channels[2]
    );
  };

  const contrastRatio = (a, b) =>
    (Math.max(a, b) + 0.05) /
    (Math.min(a, b) + 0.05);

  const accentLuminance =
    getRelativeLuminance(accentColour);

  const inkLuminance =
    getRelativeLuminance('#1c1a18');

  const whiteLuminance =
    getRelativeLuminance('#e7e7e7');

  const accentTextColour =
    accentLuminance !== null &&
    contrastRatio(
      accentLuminance,
      whiteLuminance
    ) >
      contrastRatio(
        accentLuminance,
        inkLuminance
      )
      ? '#e7e7e7'
      : '#1c1a18';

  feature.hidden = false;

  feature.classList.add(
    'is-pre-early-access'
  );

  feature.style.setProperty(
    '--ea-soft',
    earlyAccess.softColour ||
      '#e7e7e7'
  );

  feature.style.setProperty(
    '--ea-deep',
    earlyAccess.deepColour ||
      '#1c1a18'
  );

  feature.style.setProperty(
    '--ea-accent',
    accentColour
  );

  feature.style.setProperty(
    '--ea-accent-text',
    accentTextColour
  );

  feature.innerHTML = `
    <div class="ea-shop-feature-visual">
      <img alt="" hidden>
    </div>

    <a
      class="ea-shop-feature-link"
      href=""
      tabindex="-1"
      aria-hidden="true"
    ></a>

    <div class="ea-shop-feature-content">
      <div class="ea-shop-feature-copy">
        <div class="ea-shop-feature-status-row">
          <div class="pdp-ea-status">
            <span>
              coming soon${preLaunchTime ? ` · ${preLaunchTime}` : ''}
            </span>
          </div>
        </div>

        <strong
          class="ea-shop-feature-heading"
        ></strong>

        <span
          class="ea-shop-feature-meta"
        ></span>
      </div>

      <div class="ea-shop-feature-bottom">
        <div class="home-pre-ea-offer ea-shop-feature-offer">
          <span>subscribers save more</span>

          <div class="home-pre-ea-offer-price">
            <strong>
              ${
                subscriberSaving
                  ? `${subscriberSaving}% off at launch`
                  : 'subscriber launch offer'
              }
            </strong>
          </div>

          ${
            publicSaving
              ? `
                <small>
                  public launch offer: ${publicSaving}% off
                </small>
              `
              : ''
          }
        </div>

        <button
          class="home-pre-ea-offer-trigger ea-shop-feature-cta"
          type="button"
          data-shop-pre-ea-offer-trigger
        >
          <span>get the subscriber offer</span>
          ${featureArrowMarkup}
        </button>
      </div>
    </div>
  `;

  const image =
    $('img', feature);

  if (earlyAccess.shopImage) {
    image.src =
      earlyAccess.shopImage;

    image.hidden = false;
  }

  $('.ea-shop-feature-heading', feature)
    .textContent =
      earlyAccess.product.title || '';

  $('.ea-shop-feature-meta', feature)
    .textContent =
      earlyAccess.preLaunchSlogan ||
      earlyAccess.product.descriptor || '';

  showPreLaunchPreviewLink(
    feature,
    '[data-shop-pre-ea-offer-trigger]'
  );
};

renderPreEarlyAccessShopFeature();

applyEarlyAccessCartLines();

const applyPreEarlyAccessHomeHero = () => {
  const homePage = $('.home-page');

  if (
    !homePage ||
    earlyAccess.state !== 'pre' ||
    earlyAccess.homepageLaunchTreatment !== true ||
    !earlyAccess.product?.id
  ) {
    return;
  }

  const art =
    $('.home-hero-art', homePage);

  if (!art) return;

  const escapeHtml = (value = '') =>
    String(value).replace(
      /[&<>"']/g,
      (character) =>
        ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#039;'
        })[character]
    );

  const title =
    escapeHtml(
      earlyAccess.product.title ||
        'coming soon'
    );

  const descriptorText =
    earlyAccess.preLaunchSlogan ||
    earlyAccess.product.descriptor || '';

  const summaryText =
    earlyAccess.product.summary || '';

  const descriptor =
    escapeHtml(descriptorText);

  const summary =
    summaryText &&
    summaryText !== descriptorText
      ? escapeHtml(summaryText)
      : '';

  const mediaUrl =
    escapeHtml(
      earlyAccess.homepageImage ||
        earlyAccess.shopImage ||
        ''
    );

  const arrowMarkup =
    $('.home-primary-cta svg', homePage)
      ?.outerHTML || '↗';

  const publicSaving =
    Number(
      earlyAccess.savingPercentage
    ) || 0;

  const subscriberSaving =
    Number(
      earlyAccess.subscriberSavingPercentage
    ) || 0;

  const formatPreLaunchTime = (startUnix) => {
    const launchDate =
      new Date(
        Number(startUnix) * 1000
      );

    const now =
      new Date();

    const remaining =
      launchDate.getTime() -
      now.getTime();

    if (remaining <= 0) {
      return '';
    }

    const day =
      24 * 60 * 60 * 1000;

    const hour =
      60 * 60 * 1000;

    if (remaining > 7 * day) {
      return new Intl.DateTimeFormat(
        'en-GB',
        {
          day: 'numeric',
          month: 'long'
        }
      ).format(launchDate);
    }

    const tomorrow =
      new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1
      );

    const launchDay =
      new Date(
        launchDate.getFullYear(),
        launchDate.getMonth(),
        launchDate.getDate()
      );

    if (
      launchDay.getTime() ===
      tomorrow.getTime()
    ) {
      return 'tomorrow';
    }

    if (remaining >= day) {
      const days =
        Math.ceil(
          remaining / day
        );

      return `${days} days to launch`;
    }

    const hours =
      Math.max(
        1,
        Math.ceil(
          remaining / hour
        )
      );

    return `${hours} ${
      hours === 1 ? 'hour' : 'hours'
    } to launch`;
  };

  const preLaunchTime =
    formatPreLaunchTime(
      earlyAccess.startUnix
    );

  homePage.classList.add(
    'is-pre-early-access'
  );

  if (
    window.matchMedia(
      '(max-width: 780px)'
    ).matches
  ) {
    const hero =
      $('.home-hero', homePage);

    const featured =
      $('.home-featured', homePage);

    const bestseller =
      $('.home-feature', homePage);

    const routes =
      $('.home-routes', homePage);

    const instruments =
      $('.home-instruments', homePage);

    if (hero && featured) {
      hero.after(featured);
    }

    if (featured && bestseller) {
      featured.after(bestseller);
    }

    if (bestseller && routes) {
      bestseller.after(routes);
    }

    if (routes && instruments) {
      routes.after(instruments);
    }
  }

  art.classList.add(
    'is-pre-early-access-home-hero'
  );

  art.style.setProperty(
    '--pre-ea-deep',
    earlyAccess.deepColour ||
      '#1c1a18'
  );

  const accentColour =
    earlyAccess.accentColour ||
      '#d3f986';

  const getRelativeLuminance = (hex) => {
    const value =
      String(hex)
        .replace('#', '')
        .trim();

    if (!/^[0-9a-f]{6}$/i.test(value)) {
      return null;
    }

    const channels =
      [0, 2, 4].map((index) => {
        const channel =
          parseInt(
            value.slice(index, index + 2),
            16
          ) / 255;

        return channel <= 0.03928
          ? channel / 12.92
          : Math.pow(
              (channel + 0.055) / 1.055,
              2.4
            );
      });

    return (
      0.2126 * channels[0] +
      0.7152 * channels[1] +
      0.0722 * channels[2]
    );
  };

  const contrastRatio = (a, b) =>
    (Math.max(a, b) + 0.05) /
    (Math.min(a, b) + 0.05);

  const accentLuminance =
    getRelativeLuminance(accentColour);

  const inkLuminance =
    getRelativeLuminance('#1c1a18');

  const whiteLuminance =
    getRelativeLuminance('#e7e7e7');

  const accentTextColour =
    accentLuminance !== null &&
    contrastRatio(
      accentLuminance,
      whiteLuminance
    ) >
      contrastRatio(
        accentLuminance,
        inkLuminance
      )
      ? '#e7e7e7'
      : '#1c1a18';

  art.style.setProperty(
    '--pre-ea-accent',
    accentColour
  );

  art.style.setProperty(
    '--pre-ea-accent-text',
    accentTextColour
  );

  art.style.setProperty(
    '--pre-ea-soft',
    earlyAccess.softColour ||
      '#e7e7e7'
  );

  art.innerHTML = `
    <a
      class="home-pre-ea-hit"
      href=""
      tabindex="-1"
      aria-hidden="true"
    ></a>
    ${
      mediaUrl
        ? `
          <img
            class="home-pre-ea-media"
            src="${mediaUrl}"
            alt=""
            aria-hidden="true"
          >
        `
        : ''
    }

    <div class="home-pre-ea-status">
      <span class="home-art-label">
        coming soon${preLaunchTime ? ` · ${preLaunchTime}` : ''}
      </span>
    </div>

    <div class="home-pre-ea-lockup">
      <h2>${title}</h2>

      ${
        descriptor
          ? `
            <p class="home-pre-ea-descriptor">
              ${descriptor}
            </p>
          `
          : ''
      }

      ${
        summary
          ? `
            <p class="home-pre-ea-summary">
              ${summary}
            </p>
          `
          : ''
      }
    </div>

    <div class="home-pre-ea-signup-panel">
      <div class="home-pre-ea-offer">
        <span>subscribers save more</span>

        <div class="home-pre-ea-offer-price">
          <strong>
            ${
              subscriberSaving
                ? `${subscriberSaving}% off at launch`
                : 'subscriber launch offer'
            }
          </strong>
        </div>

        ${
          publicSaving
            ? `
              <small>
                public launch offer: ${publicSaving}% off
              </small>
            `
            : ''
        }
      </div>

      <button
        class="home-pre-ea-offer-trigger"
        type="button"
        data-home-pre-ea-offer-trigger
      >
        <span>get the subscriber offer</span>
        ${arrowMarkup}
      </button>
    </div>
  `;

  showPreLaunchPreviewLink(
    art,
    '[data-home-pre-ea-offer-trigger]'
  );
};

applyPreEarlyAccessHomeHero();

const applyEarlyAccessHomeHero = () => {
  const homePage = $('.home-page');

  if (
    !homePage ||
    earlyAccess.state !== 'active' ||
    earlyAccess.homepageLaunchTreatment !== true ||
    !earlyAccess.product?.id
  ) {
    return;
  }

  const hero =
    $('.home-hero', homePage);

  if (!hero) return;

  const originalPrimaryCta =
    $('.home-primary-cta', hero);

  const shopUrl =
    originalPrimaryCta?.getAttribute('href') ||
    `${storefrontRoot}collections/instruments`;

  const arrowMarkup =
    originalPrimaryCta
      ? $('svg', originalPrimaryCta)?.outerHTML || ''
      : '';

  const escapeHtml = (value = '') =>
    String(value).replace(
      /[&<>"']/g,
      (character) =>
        ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#039;'
        })[character]
    );

  const formatHeroTime = (endUnix) => {
    const remaining =
      Number(endUnix) * 1000 -
      Date.now();

    if (remaining <= 0) return '';

    const day =
      24 * 60 * 60 * 1000;

    const hour =
      60 * 60 * 1000;

    if (remaining > 2 * day) {
      const days =
        Math.ceil(remaining / day);

      return `${days} ${
        days === 1 ? 'day' : 'days'
      } left`;
    }

    const hours =
      Math.max(
        1,
        Math.ceil(remaining / hour)
      );

    return `${hours} ${
      hours === 1 ? 'hour' : 'hours'
    } left`;
  };

  const timeRemaining =
    formatHeroTime(
      earlyAccess.endUnix
    );

  const title =
    escapeHtml(
      earlyAccess.product.title
    );

  const descriptorText =
    earlyAccess.product.descriptor || '';

  const summaryText =
    earlyAccess.product.summary || '';

  const descriptor =
    escapeHtml(
      descriptorText || summaryText
    );

  const summary =
    descriptorText &&
    summaryText &&
    summaryText !== descriptorText
      ? escapeHtml(summaryText)
      : '';

  const productUrl =
    escapeHtml(
      earlyAccess.product.url || '#'
    );

  const posterUrl =
    escapeHtml(
      earlyAccess.homepageImage || ''
    );

  const videoUrl =
    escapeHtml(
      earlyAccess.homepageVideo || ''
    );

  homePage.classList.add(
    'is-early-access-active'
  );

  hero.classList.add(
    'is-early-access-home'
  );

  hero.style.setProperty(
    '--ea-deep',
    earlyAccess.deepColour ||
      '#1c1a18'
  );

  hero.style.setProperty(
    '--ea-accent',
    earlyAccess.accentColour ||
      '#d3f986'
  );

  hero.style.setProperty(
    '--ea-soft',
    earlyAccess.softColour ||
      '#e7e7e7'
  );

  const posterMarkup =
    posterUrl
      ? `
        <img
          class="home-ea-hero__poster"
          src="${posterUrl}"
          alt=""
          aria-hidden="true"
        >
      `
      : '';

  const videoMarkup =
    videoUrl
      ? `
        <video
          class="home-ea-hero__video"
          muted
          loop
          playsinline
          preload="metadata"
          ${posterUrl
            ? `poster="${posterUrl}"`
            : ''}
          aria-hidden="true"
        >
          <source
            src="${videoUrl}"
            type="video/mp4"
          >
        </video>
      `
      : '';

  const mediaControls =
    videoUrl
      ? `
        <div
          class="home-ea-hero__media-controls"
          data-home-ea-media-controls
        >
          <button
            type="button"
            class="home-ea-hero__media-control"
            data-home-ea-sound
            aria-label="Turn sound on"
            aria-pressed="false"
          >
            <span class="home-ea-hero__control-circle">
              <svg
                class="home-ea-hero__sound-icon"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  d="M4 9h4l5-4v14l-5-4H4z"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linejoin="round"
                />

                <g class="home-ea-hero__sound-muted-mark">
                  <path
                    d="M17 9l4 4M21 9l-4 4"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                  />
                </g>

                <g class="home-ea-hero__sound-waves">
                  <path
                    d="M16 9.5c1.3 1.4 1.3 3.6 0 5M18.7 7c2.8 2.9 2.8 7.1 0 10"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                  />
                </g>
              </svg>
            </span>
          </button>

          <button
            type="button"
            class="home-ea-hero__media-control"
            data-home-ea-pause
            aria-label="Pause video"
            aria-pressed="false"
          >
            <span class="home-ea-hero__control-circle">
              <span
                class="play-symbol pause-symbol"
                data-home-ea-playback-icon
                aria-hidden="true"
              ></span>
            </span>
          </button>
        </div>
      `
      : '';

  hero.innerHTML = `
    <div class="home-ea-hero">
      <div
        class="home-ea-hero__media"
        aria-hidden="true"
      >
        ${posterMarkup}
        ${videoMarkup}
      </div>

      <a
        class="home-ea-hero__panel-link"
        href="${productUrl}"
        tabindex="-1"
        aria-hidden="true"
      ></a>

      <div class="home-ea-hero__copy">
        <p class="home-ea-hero__status">
          ${
            earlyAccess.product?.isNew
              ? 'new · intro offer'
              : 'intro offer'
          }${
            timeRemaining
              ? ` · ${escapeHtml(
                  timeRemaining
                )}`
              : ''
          }
        </p>

        <div class="home-ea-hero__lockup">
          <h1 id="home-title">
            ${title}
          </h1>

          <p class="home-ea-hero__descriptor">
            ${descriptor}
          </p>

          ${
            summary
              ? `
                <p class="home-ea-hero__summary">
                  ${summary}
                </p>
              `
              : ''
          }

          ${activePriceMarkup('link')}

          <div class="home-ea-hero__actions">
            <a
              class="home-ea-hero__primary"
              href="${productUrl}"
              aria-label="view ${title}"
            >
              <span>view ${title}</span>
              ${arrowMarkup}
            </a>
          </div>
        </div>
      </div>

      ${mediaControls}
    </div>
  `;

  const routes =
    $('.home-routes', homePage);

  const featured =
    $('.home-featured', homePage);

  const instruments =
    $('.home-instruments', homePage);

  const bestseller =
    $('.home-feature', homePage);

  if (hero && featured) {
    hero.after(featured);
  }

  if (featured && bestseller) {
    featured.after(bestseller);
  }

  if (bestseller && routes) {
    bestseller.after(routes);
  }

  if (routes && instruments) {
    routes.after(instruments);
  }

  const video =
    $('.home-ea-hero__video', hero);

  const soundButton =
    $('[data-home-ea-sound]', hero);

  const pauseButton =
    $('[data-home-ea-pause]', hero);

  const playbackIcon =
    $('[data-home-ea-playback-icon]', hero);

  if (!video) return;

  const reducedMotion =
    window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

  const updateSoundState = () => {
    if (!soundButton) return;

    soundButton.setAttribute(
      'aria-label',
      video.muted
        ? 'Turn sound on'
        : 'Turn sound off'
    );

    soundButton.setAttribute(
      'aria-pressed',
      video.muted
        ? 'false'
        : 'true'
    );
  };

  const updatePlaybackState = () => {
    if (!playbackIcon) return;

    playbackIcon.classList.toggle(
      'pause-symbol',
      !video.paused
    );

    if (pauseButton) {
      pauseButton.setAttribute(
        'aria-label',
        video.paused
          ? 'Play video'
          : 'Pause video'
      );

      pauseButton.setAttribute(
        'aria-pressed',
        video.paused
          ? 'true'
          : 'false'
      );
    }
  };

  updateSoundState();
  updatePlaybackState();

  video.addEventListener(
    'play',
    updatePlaybackState
  );

  video.addEventListener(
    'pause',
    updatePlaybackState
  );

  if (!reducedMotion) {
    video
      .play()
      .then(updatePlaybackState)
      .catch(updatePlaybackState);
  }

  soundButton?.addEventListener(
    'click',
    () => {
      video.muted = !video.muted;

      updateSoundState();
    }
  );

  pauseButton?.addEventListener(
    'click',
    () => {
      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    }
  );
};

applyEarlyAccessHomeHero();

  const cartEndpoint = `${storefrontRoot}cart.js`;
const addEndpoint = `${storefrontRoot}cart/add.js`;
let lastFocus = null;
let cartSnapshot = null;

const getCartQuantity = (variantId, cart = cartSnapshot) => {
  if (!cart?.items) return 0;

  return cart.items.reduce((total, item) => {
    const itemVariantId = Number(item.variant_id || item.id);

    return itemVariantId === Number(variantId)
      ? total + (Number(item.quantity) || 0)
      : total;
  }, 0);
};

const updateCount = async () => {
  const response = await fetch(cartEndpoint, { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Unable to update the bag count. Please refresh and try again.');
  const cart = await response.json();
  cartSnapshot = cart;
  $$('[data-cart-count]').forEach((node) => { node.textContent = `(${cart.item_count})`; });
  $$('[data-cart-link]').forEach((link) => {
    link.setAttribute('aria-label', `Shopping bag with ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`);
  });
  return cart;
};

// Apply the SEVER subscriber code for recognised guest visitors.
// Shopify verifies subscriber eligibility at checkout.
const applySeverSubscriberCode = async (cart) => {
  if (
    earlyAccess.state !== 'active' ||
    earlyAccess.product?.handle !== 'sever' ||
    earlyAccess.customerEmailSubscribed === true ||
    !(isSubscriberEmailVisitor || earlyAccess.unlocked === true) ||
    !cart?.items?.some((item) =>
      String(item.product_id) === String(earlyAccess.product.id)
    )
  ) {
    return null;
  }

  // Preserve other discount codes reported as applied to the bag.
  const discountApplications = [
    ...(cart.cart_level_discount_applications || []),
    ...(cart.items || []).flatMap((item) =>
      (item.line_level_discount_allocations || []).map(
        (allocation) => allocation.discount_application
      )
    )
  ];

  const existingCodes = [...new Set(
    discountApplications
      .filter((application) =>
        application?.type === 'discount_code' && application.title
      )
      .map((application) => application.title)
  )];

  if (existingCodes.some((code) =>
    code.toUpperCase() === 'SEVER-SUB-30'
  )) {
    return null;
  }

  const response = await fetch(`${storefrontRoot}cart/update.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      discount: [...existingCodes, 'SEVER-SUB-30'].join(',')
    })
  });

  if (!response.ok) {
    throw new Error('Could not apply the subscriber discount.');
  }

  const updatedCart = await response.json();

  const codeApplied = (updatedCart.items || []).some((item) =>
    (item.line_level_discount_allocations || []).some(
      (allocation) =>
        allocation.discount_application?.title?.toUpperCase() ===
        'SEVER-SUB-30'
    )
  );

  return codeApplied ? updatedCart : null;
};

const addItems = async (items) => {
  const preEarlyAccessVariantId =
    (
      earlyAccess.state === 'pre' ||
      (
        earlyAccess.state === 'none' &&
        earlyAccess.pdpPreviewMode === true
      )
    )
      ? Number(
          earlyAccess.product?.variantId
        )
      : 0;

  if (
    preEarlyAccessVariantId &&
    items.some(
      (item) =>
        Number(item.id) ===
        preEarlyAccessVariantId
    )
  ) {
    throw new Error(
      'This product hasn’t launched yet.'
    );
  }

  const cart = await updateCount();
  const occupiedVariantIds = new Set(
    (cart.items || []).map((item) =>
      Number(item.variant_id || item.id)
    )
  );

  const itemsToAdd = items.filter((item) => {
    const variantId = Number(item.id);

    if (occupiedVariantIds.has(variantId)) return false;

    occupiedVariantIds.add(variantId);
    return true;
  });

  if (!itemsToAdd.length) {
    return {
      alreadyInBag: true,
      cart
    };
  }

  const response = await fetch(addEndpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({ items: itemsToAdd })
  });

  const result = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(
      result.description ||
      result.message ||
      'Unable to add this item. Please try again.'
    );
  }

  let updatedCart = await updateCount();

  try {
    updatedCart = await applySeverSubscriberCode(updatedCart) || updatedCart;
    cartSnapshot = updatedCart;
  } catch (error) {
    console.warn('Could not apply SEVER subscriber code.', error);
  }

  return {
    alreadyInBag: false,
    cart: updatedCart,
    result
  };
};
  const openLayer = (layer, trigger) => {
    lastFocus = trigger || document.activeElement;
    layer.hidden = false;
    document.body.classList.add('overlay-open');
    requestAnimationFrame(() => ($('button, [href], input, select, textarea', layer) || layer).focus());
  };
  const closeLayer = (layer) => {
    layer.hidden = true;
    document.body.classList.remove('overlay-open');
    if (lastFocus?.focus) lastFocus.focus();
  };
  const trap = (event, layer) => {
    if (event.key === 'Escape') return closeLayer(layer);
    if (event.key !== 'Tab') return;
    const focusable = $$('button:not([disabled]), [href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', layer).filter((node) => !node.hidden);
    if (!focusable.length) return;
    const first = focusable[0]; const last = focusable.at(-1);
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  };

    const searchPanel = $('[data-search-panel]');
  const searchToggle = $('[data-search-toggle]');
  const searchInput = $('[data-search-input]');
  const searchClear = $('[data-search-clear]');

  const updateSearchClear = () => {
    if (searchClear) searchClear.hidden = !searchInput?.value.trim();
  };

  const setSearch = (open) => {
  if (!searchPanel) return;

  searchPanel.hidden = !open;

  searchToggle?.setAttribute(
    'aria-expanded',
    String(open)
  );

  if (open) {
    updateSearchClear();

    requestAnimationFrame(() => {
      searchInput?.focus();

      const shopViews = $('#shop-views');

      if (!shopViews) return;

      const panelRect =
        searchPanel.getBoundingClientRect();

      const viewsRect =
        shopViews.getBoundingClientRect();

      const desiredTop =
        panelRect.bottom + 18;

      if (viewsRect.top < desiredTop) {
        window.scrollBy({
          top: viewsRect.top - desiredTop,
          behavior: 'smooth'
        });
      }
    });
  } else if (searchPanel.contains(document.activeElement)) {
    searchToggle?.focus();
  }
};

  searchToggle?.addEventListener('click', () => setSearch(searchPanel.hidden));

document.addEventListener('pointerdown', (event) => {
  if (
    searchPanel &&
    !searchPanel.hidden &&
    !searchPanel.contains(event.target) &&
    !searchToggle?.contains(event.target)
  ) {
    setSearch(false);
  }
});
  $('[data-search-close]')?.addEventListener('click', () => setSearch(false));
  searchInput?.addEventListener('input', updateSearchClear);
  searchClear?.addEventListener('click', () => { searchInput.value = ''; searchInput.dispatchEvent(new Event('input')); searchInput.focus(); });

  const footerSignupForm = $('#FooterSignupForm');

  if (footerSignupForm) {
    const footerSignupPendingKey =
      'inlet-footer-signup-pending';

    const showFooterSignupSuccess = () => {
      footerSignupForm.innerHTML = `
        <p class="footer-signup-success" role="status">
          you're in. welcome to inlet.
        </p>
      `;
    };

    const existingSuccess = $(
      '.footer-signup-success',
      footerSignupForm
    );

    const existingErrors = $(
      '.footer-signup-errors',
      footerSignupForm
    );

    if (existingSuccess) {
      sessionStorage.removeItem(
        footerSignupPendingKey
      );
    } else if (existingErrors) {
      sessionStorage.removeItem(
        footerSignupPendingKey
      );
    } else if (
      location.hash === '#FooterSignupForm' &&
      sessionStorage.getItem(
        footerSignupPendingKey
      ) === 'true'
    ) {
      sessionStorage.removeItem(
        footerSignupPendingKey
      );

      showFooterSignupSuccess();
    }

    footerSignupForm.addEventListener(
      'submit',
      () => {
        sessionStorage.setItem(
          footerSignupPendingKey,
          'true'
        );
      }
    );
  }

  const productForms = $$('form.product-form');

productForms.forEach((form) => {
  const button = $('button[type="submit"]', form);

  if (!button) return;

  const label = $('span', button);

  button.dataset.originalDisabled = String(button.disabled);
  button.dataset.defaultLabel = label?.textContent || 'add to bag';

  const showInBagAction = () => {
    if (button.dataset.inBag !== 'true' || !label) return;
    label.textContent = 'view bag';
  };

  const showInBagStatus = () => {
    if (button.dataset.inBag !== 'true' || !label) return;
    label.textContent = 'already in bag';
  };

  button.addEventListener('mouseenter', showInBagAction);
  button.addEventListener('mouseleave', showInBagStatus);
  button.addEventListener('focus', showInBagAction);
  button.addEventListener('blur', showInBagStatus);
});

const setProductButtons = (label, disabled = false) => {
  productForms.forEach((form) => {
    const button = $('button[type="submit"]', form);

    if (!button) return;

    const text = $('span', button);

    if (text) text.textContent = label;
    button.disabled = disabled;
  });
};

const syncProductFormsWithCart = (cart) => {
  productForms.forEach((form) => {
    const button = $('button[type="submit"]', form);

    if (!button) return;

    const text = $('span', button);
    const variantId = Number(
      $('input[name="id"]', form)?.value
    );
    const viewBag = $('[data-product-view-bag]', form);

    if (!variantId) return;

    const inBag = getCartQuantity(variantId, cart) > 0;

    if (inBag) {
      if (text) text.textContent = 'already in bag';
      button.dataset.inBag = 'true';
      button.disabled = false;
      button.setAttribute(
        'aria-label',
        'Already in bag. View bag'
      );
      if (viewBag) viewBag.hidden = false;
      return;
    }

    if (text) {
      text.textContent = button.dataset.defaultLabel;
    }

    button.dataset.inBag = 'false';
    button.removeAttribute('aria-label');

    button.disabled =
      button.dataset.originalDisabled === 'true';

    if (viewBag) viewBag.hidden = true;
  });
};

productForms.forEach((form) => form.addEventListener('submit', async (event) => {
  event.preventDefault(); const button = $('button[type="submit"]', form); const status = $('.product-form-status', form);

  if (button.dataset.inBag === 'true') {
    window.location.href = `${storefrontRoot}cart`;
    return;
  }

  button.disabled = true; if (status) status.hidden = true;
  try {
const variantId = Number(new FormData(form).get('id'));
const result = await addItems([
  {
    id: variantId,
    quantity: 1
  }
]);

if (result?.alreadyInBag) {
  productForms.forEach((form) => {
    const productButton = $('button[type="submit"]', form);

    if (productButton) {
      productButton.dataset.inBag = 'true';
      productButton.setAttribute(
        'aria-label',
        'Already in bag. View bag'
      );
    }
  });
}

setProductButtons(
  result?.alreadyInBag
    ? 'already in bag'
    : 'yay, added to bag',
  !result?.alreadyInBag
);

$$('[data-product-view-bag]').forEach((link) => {
  link.hidden = false;
});
}
  catch (error) { if (status) { status.textContent = error.message; status.hidden = false; } else button.setAttribute('aria-label', error.message); setProductButtons('add to bag', false); }
}));

if (productForms.length) {
  const refreshProductFormState = () => {
    updateCount()
      .then(syncProductFormsWithCart)
      .catch(() => {});
  };

  refreshProductFormState();
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refreshProductFormState();
  });
}
    const cartForm = $('[data-cart-form]');

  if (cartForm) {
    updateCount()
      .then(applySeverSubscriberCode)
      .then((updatedCart) => {
        if (updatedCart) window.location.reload();
      })
      .catch((error) => {
        console.warn('Could not apply SEVER subscriber code.', error);
      });

    let cartUpdateTimer = null;

    const updateStatus = $(
      '[data-cart-update-status]',
      cartForm
    );

    const consent = $(
      '[data-checkout-consent]',
      cartForm
    );

    const checkoutButton = $(
      '[data-checkout-button]',
      cartForm
    );

    const checkoutLabel = $(
      '[data-checkout-button-label]',
      cartForm
    );

    const consentStatus = $(
      '[data-checkout-consent-status]',
      cartForm
    );

    const syncQuantityControl = (input) => {
  const control = input.closest(
    '[data-cart-quantity-control]'
  );
  const decrease = $(
    '[data-cart-quantity-step="-1"]',
    control
  );
  const value = Math.max(
    1,
    Number.parseInt(input.value, 10) || 1
  );

  if (decrease) decrease.disabled = value <= 1;
};

const scheduleCartUpdate = (input) => {
  clearTimeout(cartUpdateTimer);
  syncQuantityControl(input);

  if (updateStatus) {
    updateStatus.textContent = 'Updating bag…';
    updateStatus.hidden = false;
  }

  cartUpdateTimer = setTimeout(() => {
    cartForm.requestSubmit();
  }, 700);
};

$$('[data-cart-quantity]', cartForm).forEach(
  (input) => {
    syncQuantityControl(input);

    input.addEventListener('input', () => {
      scheduleCartUpdate(input);
    });
  }
);

$$('[data-cart-quantity-step]', cartForm).forEach(
  (button) => {
    button.addEventListener('click', () => {
      const control = button.closest(
        '[data-cart-quantity-control]'
      );
      const input = $('[data-cart-quantity]', control);

      if (!input) return;

      const current = Math.max(
        1,
        Number.parseInt(input.value, 10) || 1
      );
      const delta = Number(button.dataset.cartQuantityStep);
      const next = Math.max(1, current + delta);

      if (next === current) return;

      input.value = String(next);
      input.dispatchEvent(
        new Event('input', { bubbles: true })
      );
    });
  }
);

    cartForm.addEventListener('submit', async (event) => {
      clearTimeout(cartUpdateTimer);

      const isCheckout =
        event.submitter?.name === 'checkout';

      if (!isCheckout) return;

      event.preventDefault();

      if (!consent?.checked) {
  if (consentStatus) {
    consentStatus.textContent =
      'Tick the box to continue to checkout.';
    consentStatus.hidden = false;
  }

  consent?.focus();
  return;
}

if (consentStatus) {
  consentStatus.textContent = '';
  consentStatus.hidden = true;
}

      const timestamp = new Date().toISOString();

      const consentText =
        'Customer expressly consented to immediate digital delivery before the end of the 14-day withdrawal period and acknowledged that the statutory right of withdrawal is lost once delivery begins.';

      checkoutButton.disabled = true;

      if (checkoutLabel) {
        checkoutLabel.textContent = 'one moment…';
      }

      if (consentStatus) {
        consentStatus.hidden = true;
        consentStatus.textContent = '';
      }

      try {
        const response = await fetch(
          `${storefrontRoot}cart/update.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              attributes: {
                'Checkout Consent': consentText,
                'Checkout Consent Timestamp (UTC)':
                  timestamp,
                'Checkout Consent Version': 'v2'
              }
            })
          }
        );

        const cart = await response.json();

        const consentSaved =
          response.ok &&
          cart.attributes?.['Checkout Consent'] ===
            consentText &&
          cart.attributes?.[
            'Checkout Consent Timestamp (UTC)'
          ] === timestamp &&
          cart.attributes?.[
            'Checkout Consent Version'
          ] === 'v2';

        if (!consentSaved) {
          throw new Error(
            'Your consent could not be saved. Please try again.'
          );
        }

        window.location.href = `${storefrontRoot}checkout`;
      } catch (error) {
        checkoutButton.disabled = false;

        if (checkoutLabel) {
          checkoutLabel.textContent = 'checkout';
        }

        if (consentStatus) {
          consentStatus.textContent = error.message;
          consentStatus.hidden = false;
        }
      }
    });
  }
  const formatAudioTime = (seconds) => {
    if (!Number.isFinite(seconds)) return '-';
    return `${Math.floor(seconds / 60)}:${String(Math.floor(seconds % 60)).padStart(2, '0')}`;
  };
  const initAudio = (root) => {
    const player =
      $('audio', root) ||
      document.createElement('audio');

    if (!player.parentNode) {
      root.append(player);
    }

    let active = null;

    const trackNotes =
      $$('.pdp-track-title small', root);

    trackNotes.forEach((note) => {
      const text =
        note.textContent.trim();

      if (!text) return;

      const inner =
        document.createElement('span');

      inner.textContent = text;
      note.replaceChildren(inner);
    });

    const updateTrackNotes = () => {
      trackNotes.forEach((note) => {
        const inner =
          $('span', note);

        const row =
          note.closest('.pdp-track');

        if (!inner || !row) return;

        const overflow =
          Math.max(
            0,
            inner.scrollWidth -
              note.clientWidth
          );

        const shouldScroll =
          overflow > 2;

        row.classList.toggle(
          'has-scrolling-note',
          shouldScroll
        );

        row.style.setProperty(
          '--note-scroll-distance',
          `${overflow}px`
        );

        row.style.setProperty(
          '--note-scroll-duration',
          `${Math.max(
            3,
            1.5 + overflow / 45
          )}s`
        );

        if (shouldScroll) {
          note.title =
            inner.textContent;
        } else {
          note.removeAttribute('title');
        }
      });
    };

    requestAnimationFrame(
      updateTrackNotes
    );

    window.addEventListener(
      'resize',
      updateTrackNotes
    );

    const resetRow = (row) => {
      if (!row) return;

      row.classList.remove('active');

      row.style.setProperty(
        '--track-progress',
        '0%'
      );

      $('.play-symbol', row)
        ?.classList.remove(
          'pause-symbol'
        );

      const time =
        $('.pdp-track-time', row);

      if (time) {
        time.textContent =
          time.dataset.audioDuration ||
          '-';
      }
    };

    $$('[data-audio-src]', root).forEach(
      (button) =>
        button.addEventListener(
          'click',
          () => {
            const row =
              button.closest(
                '.pdp-track'
              ) || button;

            const source =
              button.dataset.audioSrc;

            if (!source) return;

            if (
              active === row &&
              !player.paused
            ) {
              return player.pause();
            }

            if (active !== row) {
              resetRow(active);

              active = row;

              row.classList.add(
                'active'
              );

              player.src = source;
            }

            player.play();
          }
        )
    );

    player.addEventListener(
      'play',
      () => {
        const icon =
          $('.play-symbol', active);

        icon?.classList.add(
          'pause-symbol'
        );
      }
    );

    player.addEventListener(
      'pause',
      () => {
        const icon =
          $('.play-symbol', active);

        icon?.classList.remove(
          'pause-symbol'
        );
      }
    );

    player.addEventListener(
      'timeupdate',
      () => {
        if (
          !active ||
          !player.duration
        ) {
          return;
        }

        active.style.setProperty(
          '--track-progress',
          `${
            (
              player.currentTime /
              player.duration
            ) * 100
          }%`
        );

        const time =
          $('.pdp-track-time', active);

        if (time) {
          time.textContent =
            `${formatAudioTime(
              player.currentTime
            )} / ${formatAudioTime(
              player.duration
            )}`;
        }
      }
    );

    player.addEventListener(
      'ended',
      () => {
        player.currentTime = 0;
        resetRow(active);
        active = null;
      }
    );
  };
  $$('[data-audio-player]').forEach(initAudio);

  const initProgressiveVideo = (wrap) => {
    const button = $('button[data-video-id]', wrap);

    if (
      !button ||
      button.dataset.progressiveVideoBound === 'true'
    ) {
      return;
    }

    button.dataset.progressiveVideoBound = 'true';

    button.addEventListener('click', (event) => {
      const trigger = event.currentTarget;

      const host =
        trigger.dataset.videoType === 'vimeo'
          ? `https://player.vimeo.com/video/${trigger.dataset.videoId}?autoplay=1`
          : `https://www.youtube-nocookie.com/embed/${trigger.dataset.videoId}?rel=0&autoplay=1`;

      const frame = document.createElement('iframe');

      frame.src = host;
      frame.title = trigger.getAttribute('aria-label');
      frame.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      frame.allowFullscreen = true;

      wrap.replaceChildren(frame);
    });
  };

  $$('[data-progressive-video]').forEach(
    initProgressiveVideo
  );

  $$('[data-listen-switcher]').forEach((switcher) => {
    const controls = $$(
      '[data-listen-select]',
      switcher
    );

    const panels = $$(
      '[data-listen-panel]',
      switcher
    );

    if (!controls.length || !panels.length) return;

    const reducedMotion = matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

    const desktopPointer = matchMedia(
      '(hover: hover) and (pointer: fine) and (min-width: 750px)'
    );

    const originalVideoMarkup = new Map();

    $$(
      '[data-progressive-video]',
      switcher
    ).forEach((wrap) => {
      originalVideoMarkup.set(
        wrap,
        wrap.innerHTML
      );
    });

    let active =
      controls.find(
        (button) =>
          button.getAttribute('aria-pressed') === 'true'
      )?.dataset.listenSelect ||
      controls[0].dataset.listenSelect;

    let manuallySelected = false;
    let timer = null;

    const stopAutoSwitch = () => {
      manuallySelected = true;
      clearInterval(timer);
      timer = null;
    };

    const resetVariantVideos = (variant) => {
      panels
        .filter(
          (panel) =>
            panel.dataset.listenPanel === variant
        )
        .forEach((panel) => {
          $$(
            '[data-progressive-video]',
            panel
          ).forEach((wrap) => {
            if (!$('iframe', wrap)) return;

            wrap.innerHTML =
              originalVideoMarkup.get(wrap) || '';

            initProgressiveVideo(wrap);
          });
        });
    };

    const setActive = (
      next,
      userInitiated = false
    ) => {
      if (next === active) {
        if (userInitiated) {
          stopAutoSwitch();
        }

        return;
      }

      resetVariantVideos(active);

      active = next;

      controls.forEach((button) => {
        const selected =
          button.dataset.listenSelect === active;

        button.classList.toggle(
          'is-active',
          selected
        );

        button.setAttribute(
          'aria-pressed',
          String(selected)
        );
      });

      panels.forEach((panel) => {
        panel.hidden =
          panel.dataset.listenPanel !== active;
      });

      if (userInitiated) {
        stopAutoSwitch();
      }
    };

    const isPaused = () =>
      switcher.matches(':hover') ||
      switcher.contains(document.activeElement) ||
      Boolean($('iframe', switcher));

    const canAutoSwitch = () =>
      controls.length > 1 &&
      !manuallySelected &&
      desktopPointer.matches &&
      !reducedMotion.matches;

    const startTimer = () => {
      clearInterval(timer);
      timer = null;

      if (!canAutoSwitch()) return;

      timer = setInterval(() => {
        if (isPaused()) return;

        const currentIndex =
          controls.findIndex(
            (button) =>
              button.dataset.listenSelect === active
          );

        const nextButton =
          controls[
            (currentIndex + 1) % controls.length
          ];

        if (nextButton) {
          setActive(
            nextButton.dataset.listenSelect
          );
        }
      }, 7000);
    };

    controls.forEach((button) => {
      button.addEventListener('click', () => {
        setActive(
          button.dataset.listenSelect,
          true
        );
      });
    });

    reducedMotion.addEventListener?.(
      'change',
      startTimer
    );

    desktopPointer.addEventListener?.(
      'change',
      startTimer
    );

    startTimer();
  });

  const gate = $('[data-freebie-gate]');
  let pendingFreebie = null;
  const openGate = (variant, name, trigger) => {
    if (!gate) return; pendingFreebie = { id: Number(variant), quantity: 1 }; sessionStorage.setItem('inlet-pending-freebie', JSON.stringify(pendingFreebie));
    $$('[data-freebie-name], [data-freebie-submit-name]', gate).forEach((node) => { node.textContent = name; }); openLayer(gate, trigger);
  };
  $$('[data-freebie-close]', gate || document).forEach((button) => button.addEventListener('click', () => closeLayer(gate)));
  gate?.addEventListener('mousedown', (event) => { if (event.target === gate) closeLayer(gate); });
  gate?.addEventListener('keydown', (event) => trap(event, gate));
  const freebieProductButtons = $$('[data-freebie-product-add]');

freebieProductButtons.forEach((button) => {
  const label = $('span', button);

  button.dataset.originalDisabled = String(button.disabled);
  button.dataset.defaultLabel =
    label?.textContent || 'add to bag · free';

  const showInBagAction = () => {
    if (button.dataset.inBag !== 'true' || !label) return;
    label.textContent = 'view bag';
  };

  const showInBagStatus = () => {
    if (button.dataset.inBag !== 'true' || !label) return;
    label.textContent = 'already in bag';
  };

  button.addEventListener('mouseenter', showInBagAction);
  button.addEventListener('mouseleave', showInBagStatus);
  button.addEventListener('focus', showInBagAction);
  button.addEventListener('blur', showInBagStatus);
});

const setFreebieButtons = (state) => {
  freebieProductButtons.forEach((button) => {
    const label = $('span', button);
    const unavailable =
      button.dataset.originalDisabled === 'true';

    if (!label) return;

    if (unavailable) {
      label.textContent = button.dataset.defaultLabel;
      button.disabled = true;
      return;
    }

    const alreadyInBag = state === 'added';

    button.dataset.inBag = String(alreadyInBag);

    label.textContent =
      state === 'just-added'
        ? 'yay, added to bag'
        : state === 'added'
          ? 'already in bag'
          : state === 'unlocked'
            ? 'add to bag · free'
            : `unlock + add ${button.dataset.productName || ''} · free`;

    button.disabled =
      state === 'just-added';

    if (state === 'added') {
      button.setAttribute(
        'aria-label',
        'Already in bag. View bag'
      );
    } else {
      button.removeAttribute('aria-label');
    }
  });

  $$('[data-freebie-view-bag]').forEach((link) => {
    link.hidden =
      state !== 'added' && state !== 'just-added';
  });
};

const syncFreebieButtonsWithCart = (cart) => {
  if (!freebieProductButtons.length) return;

  const inBag = freebieProductButtons.some(
    (button) =>
      getCartQuantity(button.dataset.variantId, cart) > 0
  );

  setFreebieButtons(
    inBag
      ? 'added'
      : localStorage.getItem(unlockKey) === 'true'
        ? 'unlocked'
        : 'locked'
  );
};

if (freebieProductButtons.length) {
  const refreshFreebieButtonState = () => {
    updateCount()
      .then(syncFreebieButtonsWithCart)
      .catch(() => {});
  };

  refreshFreebieButtonState();
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refreshFreebieButtonState();
  });
}
  $$('[data-freebie-product-add]').forEach((button) => button.addEventListener('click', async () => {
    if (button.dataset.inBag === 'true') {
      window.location.href = `${storefrontRoot}cart`;
      return;
    }

    if (localStorage.getItem(unlockKey) === 'true') {
      try {
        const result = await addItems([{ id: Number(button.dataset.variantId), quantity: 1 }]);
        setFreebieButtons(
          result?.alreadyInBag
            ? 'added'
            : 'just-added'
        );
      } catch (error) {
        const status = $('.product-form-status', button.closest('.product-form'));

        if (status) {
          status.textContent = error.message;
          status.hidden = false;
        }
      }
    }
    else openGate(button.dataset.variantId, button.dataset.productName, button);
  }));
  const gateError = gate ? $('.freebie-unlock-form .errors', gate) : null;
  if (gateError) {
    gateError.setAttribute('role', 'alert'); gateError.setAttribute('tabindex', '-1');
    gate.hidden = false; document.body.classList.add('overlay-open');
    requestAnimationFrame(() => { gateError.focus(); if (document.activeElement !== gateError) $('input[type="email"]', gate)?.focus(); });
  }
  const captured = $('[data-freebie-captured]');
  if (captured && !gateError) {
    localStorage.setItem(unlockKey, 'true');
    try { pendingFreebie = JSON.parse(sessionStorage.getItem('inlet-pending-freebie')) || { id: Number(captured.dataset.variantId), quantity: 1 }; } catch (_) { pendingFreebie = null; }
    setFreebieButtons('unlocked');
    if (pendingFreebie?.id) addItems([pendingFreebie]).then((result) => { sessionStorage.removeItem('inlet-pending-freebie'); captured.textContent = 'Yay, your freebie is in the bag.'; setFreebieButtons(result?.alreadyInBag ? 'added' : 'just-added'); }).catch((error) => { captured.textContent = error.message; });
  }

  const shop = $('[data-shop-section]');
  if (shop) {
    let view = 'libraries';
let instrument = 'all';
let role = 'all';
let query = '';

const shopViews = [
  'libraries',
  'bundles',
  'freebies'
];

const headings = {
  libraries: [
    'instruments',
    'Choose by instrument.'
  ],
  bundles: [
    'bundles',
    'Choose how you want to build your palette.'
  ],
  freebies: [
    'freebies',
    'Start here, for free.'
  ]
};

const viewButtons = $$(
  '[data-shop-view]',
  shop
);

const originalViewCounts = Object.fromEntries(
  viewButtons.map((button) => [
    button.dataset.shopView,
    $('strong', button)?.textContent || '0'
  ])
);

const matchesSearch = (card) => {
  if (!query) return true;

  const searchText =
    card.dataset.search || '';

  return query
    .split(' ')
    .every((term) =>
      searchText.includes(term)
    );
};

const getSearchCounts = () =>
  Object.fromEntries(
    shopViews.map((shopView) => [
      shopView,
      $$(
        `[data-product-grid="${shopView}"] [data-product-card]`,
        shop
      ).filter(matchesSearch).length
    ])
  );

const render = () => {
  const typedSearch =
    searchInput?.value.trim();

  const searchCounts =
    query ? getSearchCounts() : null;

  viewButtons.forEach((button) => {
    const selected =
      button.dataset.shopView === view;

    button.classList.toggle(
      'selected',
      selected
    );

    button.setAttribute(
      'aria-pressed',
      String(selected)
    );

    const count = $('strong', button);

    if (count) {
      count.textContent = query
        ? searchCounts[
            button.dataset.shopView
          ]
        : originalViewCounts[
            button.dataset.shopView
          ];
    }
  });

  $$(
    '[data-instrument-filter]',
    shop
  ).forEach((button) => {
    const selected =
      button.dataset.instrumentFilter ===
      instrument;

    button.classList.toggle(
      'selected',
      selected
    );

    button.setAttribute(
      'aria-pressed',
      String(selected)
    );
  });

  $$(
    '[data-role-filter]',
    shop
  ).forEach((button) => {
    const selected =
      button.dataset.roleFilter === role;

    button.classList.toggle(
      'selected',
      selected
    );

    button.setAttribute(
      'aria-pressed',
      String(selected)
    );
  });

  $$('[data-product-grid]', shop).forEach(
    (grid) => {
      grid.hidden =
        grid.dataset.productGrid !== view;
    }
  );

  const libraryFilters = $(
    '[data-library-filters]',
    shop
  );

  if (libraryFilters) {
    libraryFilters.hidden =
      view !== 'libraries';
  }

  const libraryBundlePrompt = $(
    '[data-library-byob-prompt]',
    shop
  );

  if (libraryBundlePrompt) {
    libraryBundlePrompt.hidden =
      view !== 'libraries' ||
      Boolean(query);
  }

  const bundleNudge = $(
    '[data-bundle-nudge]',
    shop
  );

  if (bundleNudge) {
    bundleNudge.hidden =
      view !== 'bundles' ||
      Boolean(query);
  }

  $('[data-view-label]', shop).textContent =
    headings[view][0];

  $('[data-view-heading]', shop).textContent =
    query
      ? `Results for “${
          typedSearch || query
        }”.`
      : headings[view][1];

  let shown = 0;

  $$(
    `[data-product-grid="${view}"] [data-product-card]`,
    shop
  ).forEach((card) => {
    const matchesFilters =
      view !== 'libraries' ||
      (
        (
          instrument === 'all' ||
          card.dataset.instrument ===
            instrument
        ) &&
        (
          role === 'all' ||
          card.dataset.role === role
        )
      );

    const match = query
      ? matchesSearch(card)
      : matchesFilters;

    card.hidden = !match;

    if (match) shown += 1;
  });

  const emptyState = $(
    '[data-empty-state]',
    shop
  );

  emptyState.hidden = shown > 0;

  if (!shown) {
    const emptyMessage = $(
      'p',
      emptyState
    );

    emptyMessage.textContent = query
      ? `no ${headings[view][0]} match “${
          typedSearch || query
        }”.`
      : 'no instruments match those filters.';
  }
};

const applySearch = (value) => {
  query = String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');

  instrument = role = 'all';

  if (!query) return;

  const counts = getSearchCounts();

  if (counts[view] > 0) return;

  const firstMatchingView =
    shopViews.find(
      (shopView) =>
        counts[shopView] > 0
    );

  if (firstMatchingView) {
    view = firstMatchingView;
  }
};

const clearSearch = () => {
  query = '';

  if (searchInput) {
    searchInput.value = '';
  }
};

viewButtons.forEach((button) => {
  button.addEventListener(
    'click',
    () => {
      view = button.dataset.shopView;
      instrument = role = 'all';

      render();

      $('#shop-views')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  );
});

$$(
  '[data-instrument-filter]',
  shop
).forEach((button) => {
  button.addEventListener(
    'click',
    () => {
      clearSearch();
      view = 'libraries';
      instrument =
        button.dataset.instrumentFilter;

      render();
    }
  );
});

$$(
  '[data-role-filter]',
  shop
).forEach((button) => {
  button.addEventListener(
    'click',
    () => {
      clearSearch();
      view = 'libraries';
      role = button.dataset.roleFilter;

      render();
    }
  );
});

$('[data-more-filters]', shop)
  ?.addEventListener(
    'click',
    (event) => {
      const row = $(
        '[data-role-filters]',
        shop
      );

      row.hidden = !row.hidden;

      event.currentTarget.setAttribute(
        'aria-expanded',
        String(!row.hidden)
      );

      event.currentTarget
        .querySelector('span')
        .textContent =
          row.hidden ? '+' : '−';
    }
  );

$('[data-clear-filters]', shop)
  ?.addEventListener(
    'click',
    () => {
      instrument = role = 'all';

      clearSearch();
      render();
    }
  );

searchInput?.addEventListener(
  'input',
  () => {
    applySearch(searchInput.value);
    render();

    if (query) {
      $('#shop-views')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }
);

searchPanel?.addEventListener(
  'submit',
  (event) => {
    event.preventDefault();

    applySearch(searchInput.value);
    render();
    setSearch(false);

    $('#shop-views')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
);

const params =
  new URLSearchParams(
    location.search
  );

if (
  ['bundles', 'freebies'].includes(
    params.get('view')
  )
) {
  view = params.get('view');
}

if (params.get('instrument')) {
  view = 'libraries';
  instrument =
    params
      .get('instrument')
      .toLowerCase();
}

if (params.get('search')) {
  if (searchInput) {
    searchInput.value =
      params.get('search');
  }

  applySearch(
    params.get('search')
  );
}

render();

        const modal = $('[data-quick-modal]', shop);
        let modalProduct = null;

        const restockSource =
          $('[data-quick-restock-source][data-restock-product-id]');

        const quickRestockLink = document.createElement('a');
        quickRestockLink.className = 'modal-restock-link';
        quickRestockLink.dataset.quickRestockLink = '';
        quickRestockLink.hidden = true;
        quickRestockLink.append('notify me when available');

        const restockArrow = $('[data-modal-link] svg', modal);

        if (restockArrow) {
          quickRestockLink.append(restockArrow.cloneNode(true));
        }

        $('.modal-actions', modal)?.before(quickRestockLink);

    $$('[data-quick-view]', shop).forEach(
      (button) =>
        button.addEventListener('click', async () => {
          const template = document.getElementById(
            button.dataset.quickView
          );
const node =
  template.content.firstElementChild.cloneNode(true);

modalProduct = node.dataset;

const productCard =
  button.closest('[data-product-card]');

const isEarlyAccessProduct =
  earlyAccess.state === 'active' &&
  String(productCard?.dataset.productId) ===
    String(earlyAccess.product?.id);

const isConfirmedActiveSubscriber =
  isEarlyAccessProduct &&
  earlyAccess.customerEmailSubscribed === true &&
  Number(earlyAccess.subscriberSavingPercentage) >
    Number(earlyAccess.savingPercentage) &&
  Number(earlyAccess.subscriberPrice) > 0;

      modal.dataset.productKind = modalProduct.kind || '';
      $('[data-modal-title]', modal).textContent = modalProduct.title; $('[data-modal-descriptor]', modal).textContent = modalProduct.descriptor; $('[data-modal-description]', modal).textContent = modalProduct.description; $('[data-modal-link]', modal).href = modalProduct.productUrl;
$('[data-modal-error]', modal).hidden = true;

const modalViewBag = $('[data-modal-view-bag]', modal);
if (modalViewBag) modalViewBag.hidden = true;
      const note = $('[data-modal-note]', modal);
      note.textContent = modalProduct.note || '';
      note.hidden = !modalProduct.note;

      const kontaktCompatibility =
        $('[data-modal-kontakt-compatibility]', modal);

      const isNativeAccess =
        modalProduct.deliveryMethod === 'native_access';

      if (kontaktCompatibility) {
        kontaktCompatibility.hidden = !isNativeAccess;

        const kontaktFormat =
          $('[data-modal-kontakt-format]', kontaktCompatibility);

        if (kontaktFormat) {
          kontaktFormat.textContent =
            `${modalProduct.format || 'Kontakt Player'} · NKS compatible`;
        }
      }

      const eaSummary =
        $('[data-modal-ea-summary]', modal);

      if (eaSummary) {
        eaSummary.hidden =
          !isEarlyAccessProduct;
        eaSummary.dataset.confirmedSubscriber =
          String(isConfirmedActiveSubscriber);
      }

      const subscriberCheckoutNote =
        $('[data-modal-ea-checkout-note]', modal);

      if (subscriberCheckoutNote) {
        subscriberCheckoutNote.hidden = true;
        subscriberCheckoutNote.textContent = '';
      }

      modal.dataset.earlyAccess =
        String(isEarlyAccessProduct);

      if (isEarlyAccessProduct) {
        const modalStatusLabel =
          $(
            '.pdp-ea-status span:first-child',
            eaSummary
          );

        if (modalStatusLabel) {
          modalStatusLabel.textContent =
            earlyAccess.product?.isNew
              ? 'new · intro offer'
              : 'intro offer';
        }

        const publicSaving =
          Number(
            earlyAccess.savingPercentage
          ) || 0;

        const subscriberSaving =
          Number(
            earlyAccess.subscriberSavingPercentage
          ) || 0;

        const subscriberPrice =
          Number(
            earlyAccess.subscriberPrice
          ) || 0;

        $('[data-modal-ea-price]', modal)
          .textContent =
            money(earlyAccess.publicPrice);

        const eaCompare =
          $('[data-modal-ea-compare]', modal);

        if (publicSaving > 0) {
          eaCompare.textContent =
            money(earlyAccess.rrp);

          eaCompare.hidden = false;
        } else {
          eaCompare.hidden = true;
        }

        $('[data-modal-ea-saving]', modal)
          .textContent =
            `${publicSaving}% off`;

        $('[data-modal-ea-time]', modal)
          .textContent =
            formatEarlyAccessTime(
              earlyAccess.endUnix
            );

        const subscriberOffer =
          $('[data-modal-ea-subscriber]', modal);

        const hasSubscriberOffer =
          subscriberSaving > publicSaving &&
          subscriberPrice > 0;

        subscriberOffer.hidden =
          !hasSubscriberOffer;

        const publicPriceOption =
          $('.ea-quick-price-option:not(.ea-quick-price-option--subscriber)', eaSummary);

        if (publicPriceOption) {
          publicPriceOption.hidden =
            isConfirmedActiveSubscriber;
        }

        const subscriberLabel =
          $('.ea-quick-price-label', subscriberOffer);

        if (subscriberLabel) {
          subscriberLabel.textContent =
            isConfirmedActiveSubscriber
              ? 'your subscriber intro price'
              : 'subscriber intro price';
        }

        const subscriberLink =
          $('[data-modal-ea-subscriber-link]', subscriberOffer);

        if (subscriberLink) {
          subscriberLink.hidden =
            isConfirmedActiveSubscriber;
        }

        if (subscriberCheckoutNote && isConfirmedActiveSubscriber) {
          subscriberCheckoutNote.textContent =
            `If you’re not subscribed, the public intro offer is ${publicSaving}% off (${money(earlyAccess.publicPrice)}).`;

          const joinLink = document.createElement('a');
          joinLink.href =
            `${storefrontRoot}pages/join-the-list`;
          joinLink.textContent = 'Join the list';

          subscriberCheckoutNote.append(' ', joinLink);
          subscriberCheckoutNote.hidden = false;
        }

        if (hasSubscriberOffer) {
          $('[data-modal-ea-subscriber-price]', modal)
            .textContent =
              money(subscriberPrice);

          $('[data-modal-ea-subscriber-saving]', modal)
            .textContent =
              `${subscriberSaving}% off`;

          const subscriberUrl =
            new URL(
              modalProduct.productUrl,
              window.location.origin
            );

          subscriberUrl.searchParams.set(
            'subscriber_offer',
            '1'
          );

          $('[data-modal-ea-subscriber-link]', modal)
            .href =
              `${subscriberUrl.pathname}${subscriberUrl.search}`;
        }
      }

      const ui = $('.quick-ui-source', node); $('[data-modal-ui]', modal).replaceChildren(...[...ui.childNodes].map((n) => n.cloneNode(true)));
      const visual = $('[data-modal-visual]', modal);visual.style.setProperty(
  '--modal-accent',
  modalProduct.accent || '#77746f',
);
visual.style.setProperty(
  '--modal-deep',
  modalProduct.deep || '#1c1a18',
); const modalAccentColour =
  modalProduct.accent || '#77746f';

modal.style.setProperty(
  '--modal-accent',
  modalAccentColour,
);

modal.style.setProperty(
  '--modal-accent-text',
  getReadableTextColour(
    modalAccentColour
  ),
);

modal.style.setProperty(
  '--modal-deep',
  modalProduct.deep || '#1c1a18',
);
modal.style.setProperty(
  '--modal-soft',
  modalProduct.soft || '#c7b1ff',
);const mood = $('.quick-mood-source img', node); $('.modal-mood-source', visual)?.remove(); if (mood) { const clone = mood.cloneNode(true); clone.className = 'modal-mood-source'; visual.prepend(clone); visual.classList.add('has-mood-image'); $('.mood-placeholder', visual).hidden = true; } else { visual.classList.remove('has-mood-image'); $('.mood-placeholder', visual).hidden = false; }
      const value = $('[data-modal-value]', modal); value.hidden = modalProduct.kind !== 'bundle'; if (modalProduct.kind === 'bundle') { $('[data-modal-compare]', modal).textContent = modalProduct.compare || '-'; $('[data-modal-price]', modal).textContent = modalProduct.price; $('[data-modal-saving]', modal).textContent = modalProduct.saving ? `${modalProduct.discount} · save ${modalProduct.saving}` : ''; }
      const audio = $('[data-modal-audio]', modal); audio.replaceChildren(); audio.hidden = modalProduct.kind === 'freebie'; const audioSource = $('.quick-audio-source', node); if (modalProduct.kind !== 'freebie') { audio.innerHTML = '<div class="audio-heading"><span>audio demos</span><small>listen</small></div><div class="audio-track-list"></div><audio preload="metadata"></audio>'; const list = $('.audio-track-list', audio); [...audioSource.children].forEach((track) => list.append(track.cloneNode(true))); initAudio(audio); }
            const video = $('[data-modal-video]', modal); const facts = $('[data-modal-facts]', modal); video.replaceChildren();
video.hidden = true;
facts.hidden = true; if (modalProduct.kind === 'freebie') {
  $('[data-modal-preview-title]', facts).textContent = `inside ${modalProduct.title}`;
  const list = $('ul', facts);
  list.replaceChildren(...$$('.quick-facts-source li', node).map((item) => item.cloneNode(true)));
  if (!list.children.length) [modalProduct.includedSummary, modalProduct.compatibility].filter(Boolean).forEach((text) => { const item = document.createElement('li'); item.textContent = text; list.append(item); });
  facts.hidden = false;

  const source = $('.quick-video-source', node);
  if (source?.firstElementChild) {
    const preview = source.firstElementChild.cloneNode(true);
    video.append(preview);
    video.hidden = false;
    preview.addEventListener('click', () => { const host = preview.dataset.videoType === 'vimeo' ? `https://player.vimeo.com/video/${preview.dataset.videoId}?autoplay=1` : `https://www.youtube-nocookie.com/embed/${preview.dataset.videoId}?rel=0&autoplay=1`; const frame = document.createElement('iframe'); frame.src = host; frame.title = `${modalProduct.title} articulation playthrough`; frame.allow = 'autoplay; encrypted-media; picture-in-picture'; frame.allowFullscreen = true; video.replaceChildren(frame); });
  }
} else if (modalProduct.kind === 'bundle') { $('[data-modal-preview-title]', facts).textContent = 'included + compatibility'; const list = $('ul', facts); list.replaceChildren(); [modalProduct.includedSummary, modalProduct.compatibility].filter(Boolean).forEach((text) => { const item = document.createElement('li'); item.textContent = text; list.append(item); }); facts.hidden = false; }
      const add = $('[data-modal-add]', modal);
const unlocked = localStorage.getItem(unlockKey) === 'true';
let quickCart = cartSnapshot;

try {
  quickCart = await updateCount();
} catch (_) {}

const inBag =
  getCartQuantity(modalProduct.variantId, quickCart) > 0;

if (modalViewBag) modalViewBag.hidden = true;

add.dataset.inBag = String(inBag);

add.hidden = false;

const isPreLaunchQuickView =
  String(productCard?.dataset.productId) ===
    String(earlyAccess.product?.id) &&
  (
    earlyAccess.state === 'pre' ||
    (earlyAccess.state === 'none' && earlyAccess.pdpPreviewMode === true)
  );

const restockProductId =
  restockSource?.dataset.restockProductId ||
  (
    earlyAccess.state === 'active'
      ? earlyAccess.product?.id
      : null
  );

const isRestockQuickView =
  !isPreLaunchQuickView &&
  Boolean(restockProductId) &&
  String(productCard?.dataset.productId) ===
    String(restockProductId) &&
  (
    modalProduct.available !== 'true' ||
    restockSource?.dataset.restockPreview === 'true' ||
    shop.dataset.restockPreview === 'true'
  );

modal.dataset.restockQuickView =
  String(isRestockQuickView);

quickRestockLink.hidden = !isRestockQuickView;

if (isRestockQuickView) {
  const url = new URL(
    modalProduct.productUrl,
    window.location.origin
  );

  url.searchParams.set('open_restock', '1');

  const themePreview = new URLSearchParams(
    window.location.search
  ).get('preview_theme_id');

  if (themePreview) {
    url.searchParams.set('preview_theme_id', themePreview);
  }

  quickRestockLink.href =
    `${url.pathname}${url.search}${url.hash}`;
} else {
  quickRestockLink.removeAttribute('href');
}

add.dataset.restockAction = 'false';
add.dataset.restockRedirect = 'false';

add.removeAttribute('aria-expanded');
add.removeAttribute('aria-controls');

add.disabled =
  isRestockQuickView ||
  modalProduct.available !== 'true';

const modalAddPrice =
  isEarlyAccessProduct
    ? money(earlyAccess.publicPrice)
    : modalProduct.price;

add.textContent =
  isRestockQuickView
    ? 'sold out'
    : modalProduct.available !== 'true'
      ? 'unavailable'
      : inBag
      ? 'already in bag · view bag'
      : modalProduct.kind === 'freebie'
        ? unlocked
          ? 'add to bag · free'
          : `unlock + add ${modalProduct.title} · free`
        : isConfirmedActiveSubscriber
          ? 'add to bag'
          : `add to bag · ${modalAddPrice}`;

const returnFocus =
  button._inletReturnFocus || button;

button._inletReturnFocus = null;

openLayer(modal, returnFocus);
    }));

    const stopQuickViewMedia = () => {
      const player = $('audio', modal);

      if (player) {
        player.pause();

        try {
          player.currentTime = 0;
        } catch (_) {}

        player.removeAttribute('src');
        player.load();
      }

      $$('.pdp-track', modal).forEach((row) => {
        row.classList.remove('active');
        row.style.setProperty('--track-progress', '0%');
        $('.play-symbol', row)?.classList.remove('pause-symbol');

        const time = $('.pdp-track-time', row);

        if (time) {
          time.textContent =
            time.dataset.audioDuration || '-';
        }
      });

      const video = $('[data-modal-video]', modal);

      if (video?.querySelector('iframe')) {
        video.replaceChildren();
      }
    };

    const closeQuickView = () => {
      stopQuickViewMedia();
      closeLayer(modal);
    };

    $('[data-modal-close]', modal)?.addEventListener(
      'click',
      closeQuickView
    );

    modal?.addEventListener('mousedown', (event) => {
      if (event.target === modal) closeQuickView();
    });

    modal?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeQuickView();
        return;
      }

      trap(event, modal);
    });
    $('[data-modal-add]', modal)?.addEventListener(
  'click',
  async (event) => {
    if (!modalProduct) return;

    const button = event.currentTarget;
    const trigger = lastFocus;

    if (button.dataset.inBag === 'true') {
      window.location.href = `${storefrontRoot}cart`;
      return;
    }

    if (
      modalProduct.kind === 'freebie' &&
      localStorage.getItem(unlockKey) !== 'true'
    ) {
      closeQuickView();
      openGate(
        modalProduct.variantId,
        modalProduct.title,
        trigger
      );
      return;
    }

    const originalLabel = button.textContent;

    button.disabled = true;
    button.textContent = 'adding to bag…';

    try {
      const result = await addItems([
        {
          id: Number(modalProduct.variantId),
          quantity: 1
        }
      ]);

      button.dataset.inBag = 'true';

      button.textContent =
        result?.alreadyInBag
          ? 'already in bag · view bag'
          : 'yay, added to bag';

      button.disabled = !result?.alreadyInBag;

const modalViewBag = $('[data-modal-view-bag]', modal);
if (modalViewBag) modalViewBag.hidden = false;
    } catch (error) {
      const status = $('[data-modal-error]', modal);

      status.textContent = error.message;
      status.hidden = false;

      button.disabled = false;
      button.textContent = originalLabel;
    }
  }
);

 const builder = $('[data-bundle-modal]', shop);

let selected = [];
let bagLibraries = [];
let builderCartSignature = null;
let touchedBundleProducts = new Set();
let builderJustUpdated = false;
let builderDisplayOrder = [];
let builderPromotedDuplicateIds = new Set();
let lastRenderedBundleTier = null;
let bundleTierAnimationTimer = null;

const bundleSlots = $('[data-bundle-slots]', builder);
const bundleSlotsPrev = $('[data-bundle-slots-prev]', builder);
const bundleSlotsNext = $('[data-bundle-slots-next]', builder);

const getBundleSlotScrollStep = () => {
  if (!bundleSlots) return 0;

  const firstSlot = $('.bundle-slot', bundleSlots);

  if (!firstSlot) return 0;

  const styles = getComputedStyle(bundleSlots);
  const gap =
    Number.parseFloat(styles.columnGap || styles.gap) || 0;

  const slotWidth =
    firstSlot.getBoundingClientRect().width;

  return Math.max(
    slotWidth + gap,
    bundleSlots.clientWidth - slotWidth - gap
  );
};

const updateBundleSlotNavigation = () => {
  if (!bundleSlots) return;

  const maxScroll = Math.max(
    0,
    bundleSlots.scrollWidth - bundleSlots.clientWidth
  );

  const hasOverflow = maxScroll > 2;

  if (bundleSlotsPrev) {
    bundleSlotsPrev.hidden =
      !hasOverflow || bundleSlots.scrollLeft <= 2;
  }

  if (bundleSlotsNext) {
    bundleSlotsNext.hidden =
      !hasOverflow ||
      bundleSlots.scrollLeft >= maxScroll - 2;
  }
};

const scrollBundleSlots = (direction) => {
  if (!bundleSlots) return;

  const step = getBundleSlotScrollStep();

  if (!step) return;

  bundleSlots.scrollBy({
    left: step * direction,
    behavior: window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches
      ? 'auto'
      : 'smooth'
  });
};

bundleSlotsPrev?.addEventListener('click', () => {
  scrollBundleSlots(-1);
});

bundleSlotsNext?.addEventListener('click', () => {
  scrollBundleSlots(1);
});

bundleSlots?.addEventListener('scroll', () => {
  updateBundleSlotNavigation();
});

bundleSlots?.addEventListener('keydown', (event) => {
  if (
    event.key !== 'ArrowLeft' &&
    event.key !== 'ArrowRight'
  ) {
    return;
  }

  event.preventDefault();
  scrollBundleSlots(event.key === 'ArrowRight' ? 1 : -1);
});

window.addEventListener('resize', () => {
  updateBundleSlotNavigation();
});

    const getBundleTier = (count) =>
      count >= 5
        ? 20
        : count >= 3
          ? 15
          : count >= 2
            ? 10
            : 0;

    const animateBundleTierIncrease = (tier) => {
      const reward = $('[data-bundle-reward]', builder);

      if (
        !reward ||
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
      ) {
        return;
      }

      if (bundleTierAnimationTimer) {
        window.clearTimeout(bundleTierAnimationTimer);
      }

      reward.classList.remove(
        'is-tier-up',
        'is-tier-max'
      );

      void reward.offsetWidth;

      reward.classList.add('is-tier-up');

      if (tier === 20) {
        reward.classList.add('is-tier-max');
      }

      bundleTierAnimationTimer = window.setTimeout(
        () => {
          reward.classList.remove(
            'is-tier-up',
            'is-tier-max'
          );

          bundleTierAnimationTimer = null;
        },
        620
      );
    };

    const getBundlePickerHeading = (count) => {
      if (count === 0) return 'choose a library.';
      if (count === 1) return 'add 1 more for 10% off.';
      if (count === 2) return 'add 1 more for 15% off.';
      if (count === 3) return 'add 2 more for 20% off.';
      if (count === 4) return 'add 1 more for 20% off.';
      return '20% unlocked on every library.';
    };

    const getBundleProduct = (button) => ({
  id: Number(button.dataset.variantId),
  price: Number(button.dataset.price),
  name: button.dataset.name,
  image: button.dataset.image || '',
  secondaryImage: button.dataset.secondaryImage || '',
  available:
    button.dataset.available !== 'false' &&
    !button.hasAttribute('disabled'),
  inBag: false,
  quantity: 1
});

    const getBuilderProducts = () =>
      $$('[data-bundle-product]', builder)
        .map(getBundleProduct);

    const setBuilderError = (message = '') => {
      const status = $('[data-bundle-error]', builder);

      if (!status) return;

      status.textContent = message;
      status.hidden = !message;
    };

    const syncBuilderCart = async () => {
      const cart = await updateCount();

      const productsByVariant = new Map(
        getBuilderProducts().map((product) => [
          product.id,
          product
        ])
      );

      const bagByVariant = new Map();

      (cart.items || []).forEach((item) => {
        const product = productsByVariant.get(
          Number(item.variant_id || item.id)
        );

        if (!product) return;

        const current = bagByVariant.get(product.id) || {
          ...product,
          inBag: true,
          quantity: 0
        };

        current.quantity += Number(item.quantity) || 0;
        bagByVariant.set(product.id, current);
      });

      const nextBagLibraries = [...bagByVariant.values()];

      const nextSignature = nextBagLibraries
        .map((item) => `${item.id}:${item.quantity}`)
        .sort()
        .join('|');

      const shouldResetDraft =
        builderCartSignature === null ||
        nextSignature !== builderCartSignature;

      bagLibraries = nextBagLibraries;

      if (shouldResetDraft) {
        const selectedIds = new Set(
          selected.map((item) => item.id)
        );

        const preservedSelection = selected
          .filter((item) => bagByVariant.has(item.id))
          .map((item) => ({
            ...bagByVariant.get(item.id),
            inBag: false
          }));

        const newBagLibraries = nextBagLibraries
          .filter((item) => !selectedIds.has(item.id))
          .map((item) => ({
            ...item,
            inBag: false
          }));

        selected = [
          ...preservedSelection,
          ...newBagLibraries
        ];

        touchedBundleProducts = new Set();
      }

      builderCartSignature = nextSignature;
    };

    const getBundleChanges = () => {
  const bagByVariant = new Map(
    bagLibraries.map((item) => [item.id, item])
  );

  const selectedByVariant = new Map(
    selected.map((item) => [item.id, item])
  );

  return {
    toAdd: selected.filter(
      (item) => !bagByVariant.has(item.id)
    ),
    quantityUpdates: bagLibraries
      .map((item) => {
        const selectedItem =
          selectedByVariant.get(item.id);

        return {
          id: item.id,
          from: Number(item.quantity) || 0,
          to: selectedItem
            ? Math.max(
                1,
                Number(selectedItem.quantity) || 1
              )
            : 0
        };
      })
      .filter((change) => change.to !== change.from)
  };
};

const updateBundleQuantities = async (changes) => {
  if (!changes.length) return;

  const cart = await updateCount();
  const updates = {};

  changes.forEach((change) => {
    const matchingLines = (cart.items || []).filter(
      (item) =>
        Number(item.variant_id || item.id) ===
        Number(change.id)
    );

    matchingLines.forEach((item, index) => {
      if (!item.key) return;

      updates[item.key] =
        index === 0 ? change.to : 0;
    });
  });

  if (!Object.keys(updates).length) return;

  const response = await fetch(
    `${storefrontRoot}cart/update.js`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates })
    }
  );

  const result = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(
      result.description ||
      result.message ||
      'Unable to update the bag. Please try again.'
    );
  }
};

    const renderBuilder = () => {
  const allLibraries = selected;

  const currentLibraryIds = new Set(
    allLibraries.map((item) => item.id)
  );

  builderDisplayOrder = builderDisplayOrder.filter(
    (id) =>
      currentLibraryIds.has(id) ||
      builderPromotedDuplicateIds.has(id)
  );

  allLibraries.forEach((item) => {
    if (!builderDisplayOrder.includes(item.id)) {
      builderDisplayOrder.push(item.id);
    }
  });

  const newlyPromotedIds = allLibraries
    .filter((item) => {
      const quantity = Math.max(
        1,
        Number(item.quantity) || 1
      );

      return (
        quantity > 1 &&
        !builderPromotedDuplicateIds.has(item.id)
      );
    })
    .map((item) => item.id);

  newlyPromotedIds.forEach((id) => {
    builderPromotedDuplicateIds.add(id);
  });

  if (newlyPromotedIds.length) {
    const promotedIds = builderDisplayOrder.filter(
      (id) => builderPromotedDuplicateIds.has(id)
    );

    const regularIds = builderDisplayOrder.filter(
      (id) => !builderPromotedDuplicateIds.has(id)
    );

    builderDisplayOrder = [
      ...promotedIds,
      ...regularIds
    ];
  }

  const displayRank = new Map(
    builderDisplayOrder.map((id, index) => [
      id,
      index
    ])
  );

  const displayLibraries = allLibraries
    .map((item, selectedIndex) => ({
      item,
      selectedIndex
    }))
    .sort((a, b) => {
      const aRank = displayRank.get(a.item.id);
      const bRank = displayRank.get(b.item.id);

      if (
        aRank !== undefined &&
        bRank !== undefined
      ) {
        return aRank - bRank;
      }

      if (aRank !== undefined) return -1;
      if (bRank !== undefined) return 1;

      return a.selectedIndex - b.selectedIndex;
    })
    .map(({ item }) => item);

  const expandedLibraries = displayLibraries.flatMap((item) => {
    const quantity = Math.max(
      1,
      Number(item.quantity) || 1
    );

    return Array.from(
      { length: quantity },
      (_, unitIndex) => ({
        ...item,
        unitIndex,
        totalQuantity: quantity
      })
    );
  });

  const count = expandedLibraries.length;
  const tier = getBundleTier(count);

  const previousTier = lastRenderedBundleTier;
  const shouldAnimateTierIncrease =
    previousTier !== null &&
    tier > previousTier;

  lastRenderedBundleTier = tier;

  const subtotal = allLibraries.reduce(
    (sum, item) =>
      sum +
      item.price * Math.max(1, Number(item.quantity) || 1),
    0
  );

      const saving = Math.round(
        subtotal * tier / 100
      );

      const slotLabels = [
        'library 1',
        'library 2',
        'library 3',
        'library 4',
        'library 5+'
      ];

      const slotDetails = [
        'choose below',
        '10% off',
        '15% off',
        '15% off',
        '20% off'
      ];

      const slots = $('[data-bundle-slots]', builder);
      const minimumSlotCount = 5;
      const slotCount = Math.max(minimumSlotCount, count);

      slots.classList.toggle(
        'has-overflow',
        count > minimumSlotCount
      );

      slots.replaceChildren();

      for (let index = 0; index < slotCount; index += 1) {
        const item = expandedLibraries[index];

        const slot = document.createElement('div');

        const isEarlyAccessSlot =
          item &&
          earlyAccess.state === 'active' &&
          Number(item.id) ===
            Number(earlyAccess.product?.variantId);

        slot.className = [
          'bundle-slot',
          item ? 'filled' : '',
          isEarlyAccessSlot
            ? 'is-early-access'
            : '',
          !item && index === count
            ? 'is-next-slot'
            : ''
        ]
          .filter(Boolean)
          .join(' ');

        if (item?.image) {
          const art = document.createElement('span');

          art.className = [
            'bundle-slot-art',
            item.secondaryImage ? 'is-dual' : ''
          ]
            .filter(Boolean)
            .join(' ');

          const image = document.createElement('img');

          image.className = 'bundle-slot-image';
          image.src = item.image;
          image.alt = '';

          art.append(image);

          if (item.secondaryImage) {
            const secondaryImage = document.createElement('img');

            secondaryImage.className = 'bundle-slot-image';
            secondaryImage.src = item.secondaryImage;
            secondaryImage.alt = '';

            art.append(secondaryImage);
          }

          slot.append(art);
        }

        const copy = document.createElement('div');
        copy.className = 'bundle-slot-copy';

        const title = document.createElement('strong');
        title.className = 'bundle-slot-title';

        title.textContent = item
          ? item.name
          : slotLabels[index];

        copy.append(title);

        const detailText = item
  ? index === 0
    ? ''
    : slotDetails[
        Math.min(index, slotDetails.length - 1)
      ]
  : slotDetails[
      Math.min(index, slotDetails.length - 1)
    ];

const meta = document.createElement('span');
meta.className = 'bundle-slot-meta';

if (detailText) {
  const detail = document.createElement('span');

  detail.className = 'bundle-slot-offer';
  detail.textContent = detailText;

  meta.append(detail);
}

if (
  item &&
  item.totalQuantity > 1 &&
  item.unitIndex === 1
) {
  const quantity = document.createElement('span');

  quantity.className = 'bundle-slot-quantity';
  quantity.textContent =
    `in bag ×${item.totalQuantity}`;

  meta.append(quantity);
}

if (meta.childNodes.length) {
  copy.append(meta);
}

slot.append(copy);

if (item) {
  const remove = document.createElement('button');

  remove.type = 'button';
  remove.className = 'bundle-slot-remove';
  remove.setAttribute(
    'aria-label',
    `Remove one ${item.name} license`
  );
  remove.textContent = '×';

  remove.addEventListener('click', () => {
    builderJustUpdated = false;
    touchedBundleProducts.add(item.id);

    selected = selected
      .map((product) => {
        if (product.id !== item.id) {
          return product;
        }

        const quantity = Math.max(
          1,
          Number(product.quantity) || 1
        );

        return {
          ...product,
          quantity: quantity - 1
        };
      })
      .filter(
        (product) =>
          product.id !== item.id ||
          Number(product.quantity) > 0
      );

    renderBuilder();
  });

  slot.append(remove);
}

        slots.append(slot);
      }

      if (
        count <= minimumSlotCount ||
        newlyPromotedIds.length
      ) {
        slots.scrollLeft = 0;
      }

      requestAnimationFrame(
        updateBundleSlotNavigation
      );

      $('[data-bundle-reward]', builder).textContent =
        tier
          ? `${tier}% unlocked`
          : 'no saving yet';

      if (shouldAnimateTierIncrease) {
        animateBundleTierIncrease(tier);
      }

      $('[data-bundle-subtotal]', builder).textContent =
        money(subtotal);

      $('[data-bundle-saving]', builder).textContent =
        `−${money(saving)}`;

      $('[data-bundle-total]', builder).textContent =
        money(subtotal - saving);

      const savingRow = $(
        '[data-bundle-saving-row]',
        builder
      );

      savingRow.hidden = tier === 0;

      if (tier > 0) {
        $('[data-bundle-discount]', builder).textContent =
          `saving · ${tier}%`;
      }

      $('[data-bundle-picker-heading]', builder)
  .textContent = getBundlePickerHeading(count);

const clearButton = $('[data-bundle-clear]', builder);

if (clearButton) {
  clearButton.hidden = selected.length === 0;
}

const addButton = $('[data-add-bundle]', builder);
      const changes = getBundleChanges();
      const hasChanges =
  changes.toAdd.length > 0 ||
  changes.quantityUpdates.length > 0;

      addButton.disabled =
        !hasChanges && bagLibraries.length === 0;

addButton.textContent =
  hasChanges
    ? bagLibraries.length > 0
      ? 'update bag'
      : `add ${selected.length} ${
          selected.length === 1
            ? 'library'
            : 'libraries'
        } to bag`
    : bagLibraries.length > 0
      ? builderJustUpdated
        ? 'bag updated · view bag'
        : 'view bag'
      : 'add libraries to bag';

      $$('[data-bundle-product]', builder).forEach(
        (button) => {
          const product = getBundleProduct(button);

          const isEarlyAccessProduct =
            earlyAccess.state === 'active' &&
            Number(product.id) ===
              Number(earlyAccess.product?.variantId);

          button.classList.toggle(
            'is-early-access',
            isEarlyAccessProduct
          );

          const bagQuantity =
            bagLibraries.find(
              (item) => item.id === product.id
            )?.quantity || 0;

          const isSelected = selected.some(
            (item) => item.id === product.id
          );

          button.classList.toggle(
            'selected',
            isSelected
          );

          button.setAttribute(
  'aria-pressed',
  String(isSelected)
);

const selectedItem = selected.find(
  (item) => item.id === product.id
);

const selectedQuantity =
  Number(selectedItem?.quantity) || 0;

const matchesBag =
  bagQuantity > 0 &&
  selectedQuantity === bagQuantity;

button.classList.toggle(
  'is-in-bag',
  matchesBag
);

button.disabled =
  !product.available;

$('i', button).textContent =
  !product.available
    ? 'unavailable'
    : matchesBag
      ? `in bag${
          bagQuantity > 1
            ? ` ×${bagQuantity}`
            : ''
        }`
      : bagQuantity > 0
        ? `restore${
            bagQuantity > 1
              ? ` ×${bagQuantity}`
              : ''
          }`
        : isSelected
          ? 'remove'
          : 'add +';
        }
      );
    };

    const openBuilder = async (
      trigger,
      prefillHandles = [],
      legacyPrefillName = ''
    ) => {
      setBuilderError('');
builderJustUpdated = false;
builderDisplayOrder = [];
builderPromotedDuplicateIds = new Set();

try {
        await syncBuilderCart();
      } catch (error) {
        setBuilderError(error.message);
      }

      const addPrefillProduct = (match) => {
        if (!match || !getBundleProduct(match).available) {
          return;
        }

        const product = getBundleProduct(match);

        const alreadySelected = selected.some(
          (item) => item.id === product.id
        );

        if (!alreadySelected) {
          touchedBundleProducts.add(product.id);
          selected = [...selected, product];
        }
      };

      prefillHandles.forEach((handle) => {
        const match = $$(
          '[data-bundle-product]',
          builder
        ).find(
          (button) =>
            button.dataset.handle.toLowerCase() ===
            handle.toLowerCase()
        );

        addPrefillProduct(match);
      });

      if (
        prefillHandles.length === 0 &&
        legacyPrefillName
      ) {
        const legacyMatch = $$(
          '[data-bundle-product]',
          builder
        ).find(
          (button) =>
            button.dataset.name.toLowerCase() ===
            legacyPrefillName.toLowerCase()
        );

        addPrefillProduct(legacyMatch);
      }

      renderBuilder();
      openLayer(builder, trigger);
    };

    $$('[data-open-builder]', shop).forEach(
      (button) =>
        button.addEventListener('click', () => {
          openBuilder(button);
        })
    );

    $('[data-builder-close]', builder)
  ?.addEventListener('click', () => {
    closeLayer(builder);
  });

$('[data-bundle-clear]', builder)
  ?.addEventListener('click', () => {
    setBuilderError('');
    builderJustUpdated = false;
    builderDisplayOrder = [];
    builderPromotedDuplicateIds = new Set();

    selected.forEach((item) => {
      touchedBundleProducts.add(item.id);
    });

    selected = [];
    renderBuilder();
  });

builder?.addEventListener(
      'mousedown',
      (event) => {
        if (event.target === builder) {
          closeLayer(builder);
        }
      }
    );

    builder?.addEventListener(
      'keydown',
      (event) => trap(event, builder)
    );

    $$('[data-bundle-product]', builder).forEach(
      (button) =>
        button.addEventListener('click', () => {
  setBuilderError('');
  builderJustUpdated = false;

  const item = getBundleProduct(button);

          if (!item.available) return;

          const bagItem = bagLibraries.find(
  (product) => product.id === item.id
);

const selectedItem = selected.find(
  (product) => product.id === item.id
);

if (bagItem) {
  const bagQuantity =
    Number(bagItem.quantity) || 1;

  const selectedQuantity =
    Number(selectedItem?.quantity) || 0;

  touchedBundleProducts.add(item.id);

  if (selectedQuantity === bagQuantity) {
    selected = selected.filter(
      (product) => product.id !== item.id
    );

    renderBuilder();
    return;
  }

  selected = [
    ...selected.filter(
      (product) => product.id !== item.id
    ),
    {
      ...bagItem,
      inBag: false
    }
  ];

  renderBuilder();
  return;
}

touchedBundleProducts.add(item.id);

selected = selectedItem
  ? selected.filter(
      (product) => product.id !== item.id
    )
  : [
      ...selected,
      {
        ...item,
        quantity: 1
      }
    ];

renderBuilder();
        })
    );

    $('[data-add-bundle]', builder)
      ?.addEventListener(
        'click',
        async (event) => {
          const changes = getBundleChanges();
          const hasChanges =
  changes.toAdd.length > 0 ||
  changes.quantityUpdates.length > 0;

          if (!hasChanges) {
            if (bagLibraries.length > 0) {
              window.location.href =
                `${storefrontRoot}cart`;
            }

            return;
          }

          const button = event.currentTarget;

          setBuilderError('');
          button.disabled = true;
          button.textContent = 'updating bag…';

          try {
            if (changes.toAdd.length > 0) {
              await addItems(
                changes.toAdd.map((item) => ({
                  id: item.id,
                  quantity: 1
                }))
              );
            }

            if (changes.quantityUpdates.length > 0) {
  await updateBundleQuantities(
    changes.quantityUpdates
  );
}

            await syncBuilderCart();
builderJustUpdated = true;
renderBuilder();
          } catch (error) {
            try {
              await syncBuilderCart();
            } catch (_) {}

            setBuilderError(error.message);
            renderBuilder();
          }
        }
      );

    const builderPrefillHandles = params
      .getAll('add')
      .flatMap((value) => value.split(','))
      .map((value) => value.trim())
      .filter(Boolean);

    if (
      params.get('builder') === 'true' ||
      builderPrefillHandles.length > 0 ||
      params.get('bundle')
    ) {
      openBuilder(
        null,
        builderPrefillHandles,
        params.get('bundle') || ''
      );
    }
  }

  $$('[data-hotspot]').forEach((button) => { const canvas = button.closest('[data-interface-canvas]'); const tooltip = $('[data-hotspot-tooltip]', canvas); const caption = $('[data-hotspot-caption]', button.closest('.pdp-interface-explorer')); const show = () => { tooltip.hidden = false; tooltip.style.setProperty('--tooltip-x', `${button.dataset.tooltipX}%`); tooltip.style.setProperty('--tooltip-y', `${button.dataset.tooltipY}%`); $('strong', tooltip).textContent = button.dataset.label; $('span', tooltip).textContent = button.dataset.description; if (caption) { caption.hidden = false; $('strong', caption).textContent = button.dataset.label; $('span', caption).textContent = button.dataset.description; } }; button.addEventListener('mouseenter', show); button.addEventListener('focus', show); button.addEventListener('click', (event) => { event.preventDefault(); show(); button.setAttribute('aria-expanded', 'true'); }); button.addEventListener('mouseleave', () => { if (!matchMedia('(hover: none)').matches) tooltip.hidden = true; }); button.addEventListener('blur', () => { if (!matchMedia('(hover: none)').matches) tooltip.hidden = true; }); });
  $$('[data-interface-switcher]').forEach((switcher) => {
    const controls = $$('[data-interface-select]', switcher);
    const panels = $$('[data-interface-panel]', switcher);
    const canvas = $('[data-interface-canvas]', switcher);
    const tooltip = $('[data-hotspot-tooltip]', canvas);

    const reducedMotion = matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

    const desktopPointer = matchMedia(
      '(hover: hover) and (pointer: fine) and (min-width: 750px)'
    );

    let active =
      controls.find(
        (button) =>
          button.getAttribute('aria-pressed') === 'true'
      )?.dataset.interfaceSelect ||
      controls[0]?.dataset.interfaceSelect;

    let manuallySelected = false;
    let timer = null;

    const closeHotspot = () => {
      if (tooltip) tooltip.hidden = true;

      $$('[data-hotspot]', canvas).forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });
    };

    const setActive = (next, userInitiated = false) => {
      if (next === active) {
        if (userInitiated) {
          manuallySelected = true;
          clearInterval(timer);
          timer = null;
        }

        return;
      }

      if (userInitiated) closeHotspot();

      active = next;

      controls.forEach((button) => {
        const selected =
          button.dataset.interfaceSelect === active;

        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', String(selected));
      });

      panels.forEach((panel) => {
        const selected =
          panel.dataset.interfacePanel === active;

        panel.classList.toggle('is-active', selected);
        panel.setAttribute('aria-hidden', String(!selected));
      });

      if (userInitiated) {
        manuallySelected = true;
        clearInterval(timer);
        timer = null;
      }
    };

    const isPaused = () =>
      switcher.matches(':hover') ||
      switcher.contains(document.activeElement) ||
      (tooltip && !tooltip.hidden);

    const canAutoSwitch = () =>
      controls.length > 1 &&
      !manuallySelected &&
      desktopPointer.matches &&
      !reducedMotion.matches;

    const startTimer = () => {
      clearInterval(timer);
      timer = null;

      if (!canAutoSwitch()) return;

      timer = setInterval(() => {
        if (!isPaused()) {
          const currentIndex = controls.findIndex(
            (button) =>
              button.dataset.interfaceSelect === active
          );

          const nextButton =
            controls[
              (currentIndex + 1) % controls.length
            ];

          if (nextButton) {
            setActive(
              nextButton.dataset.interfaceSelect
            );
          }
        }
      }, 7000);
    };

    controls.forEach((button) => {
      button.addEventListener('click', () => {
        setActive(
          button.dataset.interfaceSelect,
          true
        );
      });
    });

    reducedMotion.addEventListener?.('change', startTimer);
    desktopPointer.addEventListener?.('change', startTimer);

    startTimer();
  });
  const productPage = $('[data-product-page]');

  if (productPage) {
    const pageProductId =
      productPage.dataset.productId;

    const isCampaignProductPage =
      String(pageProductId) ===
        String(earlyAccess.product?.id);

    const isPdpPreviewPage =
      earlyAccess.state === 'none' &&
      earlyAccess.pdpPreviewMode === true &&
      isCampaignProductPage;

    const isPreEarlyAccessPage =
      (
        earlyAccess.state === 'pre' ||
        isPdpPreviewPage
      ) &&
      isCampaignProductPage;

    const isEarlyAccessPage =
      earlyAccess.state === 'active' &&
      isCampaignProductPage;

    const preLaunchDescriptor =
      $('.product-descriptor', productPage);

    if (
      isPreEarlyAccessPage &&
      earlyAccess.preLaunchSlogan &&
      preLaunchDescriptor
    ) {
      preLaunchDescriptor.textContent =
        earlyAccess.preLaunchSlogan;
    }

    if (isEarlyAccessPage && earlyAccess.product?.isNew) {
      const titleBlock =
        $('.pdp-title-block', productPage);

      if (titleBlock) {
        const badge = document.createElement('span');
        badge.className = 'product-badge pdp-new-pill';
        badge.innerHTML = '<span>NEW</span>';
        titleBlock.prepend(badge);
      }
    }

    const isRestockPage =
      !isPreEarlyAccessPage &&
      Boolean($('[data-inlet-restock-section]')) &&
      (
        productPage.dataset.variantAvailable === 'false' ||
        productPage.dataset.restockPreview === 'true'
      );

    const returnedFromSuccessfulSignup =
      isEarlyAccessPage &&
      (
        Boolean($('.home-pre-ea-signup-success', productPage)) ||
        (
          sessionStorage.getItem('inlet-pdp-prelaunch-signup-pending') === 'true' &&
          window.location.hash === '#PdpPreLaunchSignupForm' &&
          !$('.footer-signup-errors', productPage)
        )
      );

    if (returnedFromSuccessfulSignup && earlyAccess.browserUnlockKey) {
      try {
        localStorage.setItem(earlyAccess.browserUnlockKey, 'true');
        earlyAccess.unlocked = true;
      } catch (_) {}
    }

    const isConfirmedActiveSubscriber =
      isEarlyAccessPage &&
      (
        earlyAccess.customerEmailSubscribed === true ||
        earlyAccess.unlocked === true ||
        isSubscriberEmailVisitor
      );

    const isRecognisedActiveVisitor =
      isEarlyAccessPage &&
      (isSubscriberEmailVisitor || isConfirmedActiveSubscriber);

    const subscriberOfferRequested =
      isEarlyAccessPage &&
      new URLSearchParams(
        window.location.search
      ).get('subscriber_offer') === '1';

    const eaStatus =
      $('[data-pdp-ea-status]', productPage);

    const eaPriceRow =
      $('[data-pdp-ea-price-row]', productPage);

    const preLaunchOfferLabel =
      $('[data-pdp-prelaunch-offer-label]', productPage);

    const eaPrice =
      $('[data-pdp-ea-price]', productPage);

    const eaCompare =
      $('[data-pdp-ea-compare]', productPage);

    const eaSaving =
      $('[data-pdp-ea-saving]', productPage);

    const activeIntroPricing =
      $('[data-pdp-active-intro-pricing]', productPage);

    const activeSubscriberCheckoutNote =
      $('[data-pdp-active-subscriber-checkout-note]', productPage);

    const eaTime =
      $('[data-pdp-ea-time]', productPage);

    const standardPrice =
      $('[data-pdp-standard-price]', productPage);

    const bundleShortcut =
      $('.pdp-bundle-shortcut', productPage);

    const purchaseAssurance =
      $('.pdp-purchase-assurance', productPage);

    const eaUnlockButtons =
      $$('[data-pdp-ea-unlock]', productPage);

    const preLaunchSignup =
      $('[data-pdp-prelaunch-signup]', productPage);

    const subscriberOfferHeading =
      $('[data-pdp-subscriber-offer-heading]', productPage);

    const preLaunchSubscriberNote =
      $('[data-pdp-prelaunch-subscriber-note]', productPage);

    const heroProductForm =
      $('#HeroProductForm', productPage);

    const stickyProductForm =
      $('#StickyProductForm', productPage);

    const sticky =
      $('[data-sticky-buy]', productPage);

    const stickyPrice =
      $('[data-pdp-sticky-price]', productPage);

    const stickyCompare =
      $('[data-pdp-sticky-compare]', productPage);

    const stickySaveMore =
      $('[data-pdp-sticky-save-more]', productPage);

    const footer =
      $('[data-site-footer]');

    let purchaseLocked =
      isPdpPreviewPage ||
      isPreEarlyAccessPage;

    const applyEarlyAccessPageState = () => {
      purchaseLocked =
        isPdpPreviewPage ||
        isPreEarlyAccessPage;

      if (eaStatus) {
        eaStatus.hidden =
          !isPdpPreviewPage &&
          !isPreEarlyAccessPage &&
          !isEarlyAccessPage;

        const statusLabel =
          $('span:first-child', eaStatus);

        const statusSeparator =
          $('span[aria-hidden="true"]', eaStatus);

        if (statusLabel) {
          statusLabel.textContent =
            isPdpPreviewPage ||
            isPreEarlyAccessPage
              ? 'coming soon'
              : 'intro offer';
        }

        if (statusSeparator) {
          statusSeparator.hidden = false;
        }

        if (eaTime) {
          eaTime.hidden = false;

          if (
            isPdpPreviewPage ||
            isPreEarlyAccessPage
          ) {
            const launchDate =
              new Date(
                Number(
                  earlyAccess.startUnix
                ) * 1000
              );

            const now =
              new Date();

            const remaining =
              launchDate.getTime() -
              now.getTime();

            const day =
              24 * 60 * 60 * 1000;

            const hour =
              60 * 60 * 1000;

            if (remaining > 7 * day) {
              eaTime.textContent =
                new Intl.DateTimeFormat(
                  'en-GB',
                  {
                    day: 'numeric',
                    month: 'long'
                  }
                ).format(launchDate);
            } else if (remaining >= day) {
              const days =
                Math.ceil(
                  remaining / day
                );

              eaTime.textContent =
                `${days} ${
                  days === 1
                    ? 'day'
                    : 'days'
                } to launch`;
            } else if (remaining > 0) {
              const hours =
                Math.max(
                  1,
                  Math.ceil(
                    remaining / hour
                  )
                );

              eaTime.textContent =
                `${hours} ${
                  hours === 1
                    ? 'hour'
                    : 'hours'
                } to launch`;
            } else {
              eaTime.textContent = '';
              statusSeparator.hidden = true;
            }
          }
        }
      }

      if (preLaunchOfferLabel) {
        preLaunchOfferLabel.hidden =
          !isPreEarlyAccessPage;
      }

      if (eaPriceRow) {
        eaPriceRow.hidden =
          !isPreEarlyAccessPage;
      }

      if (activeIntroPricing) {
        activeIntroPricing.hidden =
          !isEarlyAccessPage;
      }

      if (standardPrice) {
        standardPrice.hidden =
          isPreEarlyAccessPage ||
          isEarlyAccessPage;
      }

      if (isPreEarlyAccessPage) {
        const publicSaving =
          Number(
            earlyAccess.savingPercentage
          ) || 0;

        const subscriberSaving =
          Number(
            earlyAccess.subscriberSavingPercentage
          ) || 0;

        if (eaCompare) {
          eaCompare.hidden = true;
        }

        if (eaPrice) {
          eaPrice.textContent =
            subscriberSaving
              ? `${subscriberSaving}% off at launch`
              : 'subscriber intro offer';
        }

        if (eaSaving) {
          const offerEndDate =
            new Date(
              Number(earlyAccess.endUnix) *
              1000
            );

          const offerEndLabel =
            new Intl.DateTimeFormat(
              'en-GB',
              {
                day: 'numeric',
                month: 'short'
              }
            ).format(offerEndDate);

          eaSaving.hidden = false;

          eaSaving.textContent =
            publicSaving
              ? `public intro: ${publicSaving}% off · offers end ${offerEndLabel}`
              : `subscriber offer ends ${offerEndLabel}`;
        }
      }

      if (bundleShortcut) {
        bundleShortcut.hidden =
          isPdpPreviewPage ||
          isPreEarlyAccessPage ||
          isEarlyAccessPage;
      }

      if (purchaseAssurance) {
        purchaseAssurance.hidden =
          isPdpPreviewPage ||
          isPreEarlyAccessPage;
      }

      productPage.classList.toggle(
        'is-pre-early-access-product',
        isPreEarlyAccessPage
      );

      productPage.classList.toggle(
        'is-early-access-product',
        isEarlyAccessPage
      );

      productPage.classList.toggle(
        'is-confirmed-active-subscriber',
        isConfirmedActiveSubscriber
      );

      if (
        isConfirmedActiveSubscriber &&
        heroProductForm &&
        purchaseAssurance
      ) {
        heroProductForm.append(purchaseAssurance);
      }

      if (isPreEarlyAccessPage) {
        if (stickyPrice) {
          stickyPrice.hidden = true;
        }

        if (stickyCompare) {
          stickyCompare.hidden = true;
        }

        if (stickySaveMore) {
          stickySaveMore.hidden = true;
        }
      }

      if (isEarlyAccessPage) {
        if (eaTime) {
          const remaining =
            Number(earlyAccess.endUnix) * 1000 -
            Date.now();

          const day =
            24 * 60 * 60 * 1000;

          const hour =
            60 * 60 * 1000;

          if (remaining > 2 * day) {
            const days =
              Math.ceil(remaining / day);

            eaTime.textContent =
              `${days} ${
                days === 1 ? 'day' : 'days'
              } left`;
          } else {
            const hours =
              Math.max(
                1,
                Math.ceil(remaining / hour)
              );

            eaTime.textContent =
              `${hours} ${
                hours === 1 ? 'hour' : 'hours'
              } left`;
          }
        }

        const publicSaving =
          Number(
            earlyAccess.savingPercentage
          ) || 0;

        const subscriberSaving =
          Number(
            earlyAccess.subscriberSavingPercentage
          ) || 0;

        if (
          activeIntroPricing &&
          !$('.ia-active-price', activeIntroPricing)
        ) {
          activeIntroPricing.innerHTML =
            activePriceMarkup('button');
        }

        if (activeSubscriberCheckoutNote) {
          const hasSubscriberIntroOffer =
            subscriberSaving > publicSaving &&
            Number(earlyAccess.subscriberPrice) > 0;

          activeSubscriberCheckoutNote.hidden = !hasSubscriberIntroOffer;

          if (hasSubscriberIntroOffer) {
            const subscriberMessage = document.createElement('span');
const subscriberHeadline = document.createElement('strong');

subscriberHeadline.textContent =
  'Your 30% subscriber discount applies automatically at checkout.';

subscriberMessage.append(
  subscriberHeadline,
  ' Just enter the email you subscribed with.'
);

activeSubscriberCheckoutNote.replaceChildren(subscriberMessage);
          }
        }

        if (stickyPrice) {
          stickyPrice.hidden = false;

          stickyPrice.textContent =
            money(
              isConfirmedActiveSubscriber
                ? earlyAccess.subscriberPrice
                : earlyAccess.publicPrice
            );
        }

        if (stickyCompare) {
          const hasSaving =
            isConfirmedActiveSubscriber
              ? subscriberSaving > 0
              : publicSaving > 0;

          stickyCompare.hidden = !hasSaving;

          if (hasSaving) {
            stickyCompare.textContent =
              money(earlyAccess.rrp);
          }
        }

        if (stickySaveMore) {
          stickySaveMore.hidden = isRecognisedActiveVisitor;
        }
      }

      if (
        !isPreEarlyAccessPage &&
        !isEarlyAccessPage &&
        stickyPrice
      ) {
        stickyPrice.hidden = false;

        if (stickyCompare) {
          stickyCompare.hidden = true;
        }

        if (stickySaveMore) {
          stickySaveMore.hidden = true;
        }
      }

      if (heroProductForm) {
        heroProductForm.hidden =
          purchaseLocked;
      }

      if (stickyProductForm) {
        stickyProductForm.hidden =
          purchaseLocked;
      }

      eaUnlockButtons.forEach(
        (button) => {
          button.hidden =
            !purchaseLocked;

          const label =
            $('span', button);

          if (label) {
            label.textContent =
              isPreEarlyAccessPage
                ? 'get the subscriber offer'
                : 'add to bag';
          }
        }
      );
    };

    applyEarlyAccessPageState();

    productPage.classList.toggle(
      'is-restock-unavailable',
      isRestockPage
    );

    if (isRestockPage) {
      const restockSlot =
        $('[data-pdp-restock-slot]', productPage);

      const restockPanel =
        $('[data-pdp-restock-panel]', productPage);

      const restockTrigger =
        $('[data-pdp-restock-trigger]', productPage);

      const restockSection =
        $('[data-inlet-restock-section]');

      const fallback = restockPanel
        ? $('.pdp-restock-fallback', restockPanel)
        : null;

      const heroAddButton = heroProductForm
        ? $('.product-add[type="submit"]', heroProductForm)
        : null;

      // Preserve the regular purchase button,
      // but make its unavailable state explicit.
      if (heroAddButton) {
        heroAddButton.disabled = true;

        const label = $('span', heroAddButton);
        if (label) label.textContent = 'sold out';
      }

      if (restockSlot && restockPanel && restockTrigger) {
        restockSlot.hidden = false;

        restockTrigger.addEventListener('click', () => {
          const open = restockPanel.hidden;

          if (open) {
            if (
              restockSection &&
              Number(restockSection.dataset.appBlockCount) > 0
            ) {
              restockSection.hidden = false;
              restockPanel.append(restockSection);
            } else if (fallback) {
              fallback.hidden = false;
            }
          }

          restockPanel.hidden = !open;

          restockTrigger.setAttribute(
            'aria-expanded',
            String(open)
          );

          const label = $(
            '[data-pdp-restock-trigger-label]',
            restockTrigger
          );

          if (label) {
            label.textContent = open
              ? 'hide restock form'
              : 'notify me when available';
          }

          productPage.classList.toggle(
            'is-restock-form-open',
            open
          );
        });

        if (
          new URLSearchParams(window.location.search)
            .get('open_restock') === '1'
        ) {
          restockTrigger.click();

          requestAnimationFrame(() => {
            restockTrigger.scrollIntoView({
              behavior: 'auto',
              block: 'center'
            });
          });
        }
      }
    }

    let downloadLaunchReminder = null;

    if (
      isPreEarlyAccessPage &&
      isSubscriberEmailVisitor
    ) {
      const launchTime =
        Number(earlyAccess.startUnix) * 1000;

      if (
        Number.isFinite(launchTime) &&
        launchTime > Date.now()
      ) {
        const calendarDate = (date) =>
          date.toISOString()
            .replace(/[-:]/g, '')
            .replace(/\.\d{3}/, '');

        const calendarText = (value) =>
          String(value)
            .replace(/\\/g, '\\\\')
            .replace(/\r?\n/g, '\\n')
            .replace(/,/g, '\\,')
            .replace(/;/g, '\\;');

        downloadLaunchReminder = () => {
          const title =
            earlyAccess.product.title;

          const productUrl =
            window.location.origin +
            window.location.pathname;

          const calendar = [
            'BEGIN:VCALENDAR',
            'VERSION:2.0',
            'PRODID:-//Inlet Audio//Launch Reminder//EN',
            'CALSCALE:GREGORIAN',
            'BEGIN:VEVENT',
            `UID:inlet-${earlyAccess.product.id}-${earlyAccess.startUnix}@inletaudio.com`,
            `DTSTAMP:${calendarDate(new Date())}`,
            `DTSTART:${calendarDate(new Date(launchTime))}`,
            `DTEND:${calendarDate(new Date(launchTime + 900000))}`,
            `SUMMARY:${calendarText(title + ' launches — Inlet Audio')}`,
            `DESCRIPTION:${calendarText('Visit ' + productUrl)}`,
            `URL:${productUrl}`,
            'BEGIN:VALARM',
            'TRIGGER:-PT15M',
            'ACTION:DISPLAY',
            'DESCRIPTION:Launch reminder',
            'END:VALARM',
            'END:VEVENT',
            'END:VCALENDAR'
          ].join('\r\n') + '\r\n';

          const blob = new Blob(
            [calendar],
            { type: 'text/calendar;charset=utf-8' }
          );

          const url =
            URL.createObjectURL(blob);

          const link =
            document.createElement('a');

          link.href = url;
          link.download =
            'inlet-launch-reminder.ics';

          document.body.appendChild(link);
          link.click();
          link.remove();

          window.setTimeout(
            () => URL.revokeObjectURL(url),
            10000
          );
        };

        const saveCalendarFile =
          downloadLaunchReminder;

        downloadLaunchReminder = () => {
          const title =
            `${earlyAccess.product.title} launches — Inlet Audio`;

          const start =
            new Date(launchTime);

          const end =
            new Date(launchTime + 900000);

          const productUrl =
            window.location.origin +
            window.location.pathname;

          const googleParams =
            new URLSearchParams({
              action: 'TEMPLATE',
              text: title,
              dates:
                `${calendarDate(start)}/${calendarDate(end)}`,
              details:
                `Visit ${productUrl}`
            });

          const outlookParams =
            new URLSearchParams({
              path: '/calendar/action/compose',
              rru: 'addevent',
              allday: 'false',
              subject: title,
              startdt: start.toISOString(),
              enddt: end.toISOString(),
              body: `Visit ${productUrl}`
            });

          const dialog =
            document.createElement('dialog');

          dialog.className =
            'inlet-calendar-chooser';

          dialog.setAttribute(
            'aria-label',
            'Choose a calendar for the launch reminder'
          );

          const calendarIconMarkup = `
            <svg viewBox="0 0 24 24" width="20" height="20"
              fill="none" stroke="currentColor"
              stroke-width="1.8" stroke-linecap="round"
              stroke-linejoin="round" aria-hidden="true"
              style="display:block">
              <rect x="3" y="5" width="18" height="16" rx="2"></rect>
              <path d="M8 3v4M16 3v4M3 10h18"></path>
            </svg>
          `;

          dialog.innerHTML = `
            <div class="inlet-calendar-chooser__panel">
              <button type="button" class="inlet-calendar-chooser__close" aria-label="Close">×</button>
              <p class="inlet-calendar-chooser__eyebrow">launch reminder</p>
              <h2>Save the date.</h2>
              <p class="inlet-calendar-chooser__offer"></p>
              <p class="inlet-calendar-chooser__date"></p>
              <div class="inlet-calendar-chooser__choices">
                <a data-calendar-google target="_blank" rel="noopener noreferrer">Google Calendar <span aria-hidden="true">${calendarIconMarkup}</span></a>
                <a data-calendar-outlook target="_blank" rel="noopener noreferrer">Outlook Calendar <span aria-hidden="true">${calendarIconMarkup}</span></a>
                <button type="button" data-calendar-file>Apple Calendar / other <span aria-hidden="true"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="display:block"><path d="M12 3v12M7 10l5 5 5-5M4 17v4h16v-4"></path></svg></span></button>
              </div>
              <button type="button" class="inlet-calendar-chooser__copy" data-calendar-copy>Copy reminder details</button>
              <p class="inlet-calendar-chooser__note">Google and Outlook may ask you to sign in. Check your alert settings when saving.</p>
              <p class="inlet-calendar-chooser__feedback" role="status" aria-live="polite" hidden></p>
            </div>
          `;

          dialog.querySelector(
            '.inlet-calendar-chooser__eyebrow'
          ).textContent =
            `${earlyAccess.product.title} / launch reminder`;

          dialog.querySelector(
            '.inlet-calendar-chooser__panel h2'
          ).textContent =
            String(
              earlyAccess.reminderModalHeadline || ''
            ).trim() ||
            `${earlyAccess.product.title} is almost here.`;

          const subscriberSaving =
            Number(
              earlyAccess.subscriberSavingPercentage
            ) || 0;

          const launchDateAndTime =
            new Intl.DateTimeFormat('en-GB', {
              day: 'numeric',
              month: 'long',
              hour: '2-digit',
              minute: '2-digit',
              timeZone: 'Europe/Berlin',
              timeZoneName: 'short'
            }).format(start);

          dialog.querySelector(
            '.inlet-calendar-chooser__offer'
          ).textContent =
            subscriberSaving > 0
              ? `Your ${subscriberSaving}% discount starts ${launchDateAndTime}.`
              : `${earlyAccess.product.title} launches ${launchDateAndTime}.`;

          dialog.querySelector(
            '.inlet-calendar-chooser__date'
          )?.remove();

          dialog.querySelector(
            '[data-calendar-google]'
          ).href =
            `https://calendar.google.com/calendar/render?${googleParams}`;

          dialog.querySelector(
            '[data-calendar-outlook]'
          ).href =
            `https://outlook.office.com/calendar/deeplink/compose?${outlookParams}`;

          dialog.querySelector(
            '.inlet-calendar-chooser__close'
          ).addEventListener(
            'click',
            () => dialog.close()
          );

          const calendarFeedback =
            dialog.querySelector('.inlet-calendar-chooser__feedback');

          dialog.querySelector(
            '[data-calendar-file]'
          ).addEventListener('click', () => {
            saveCalendarFile();

            calendarFeedback.textContent =
              'Open the downloaded file to add the event to your calendar.';

            calendarFeedback.hidden = false;
          });

          dialog.querySelector(
            '[data-calendar-copy]'
          ).addEventListener('click', async (event) => {
            const calendarDetails = [
              `${earlyAccess.product.title} launches — Inlet Audio`,
              new Intl.DateTimeFormat('en-GB', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                timeZone: 'Europe/Berlin',
                timeZoneName: 'short'
              }).format(start),
              'Suggested alert: 15 minutes before',
              productUrl
            ].join('\n');

            try {
              await navigator.clipboard.writeText(calendarDetails);

              event.currentTarget.textContent = 'Copied ✓';

              calendarFeedback.textContent =
                'Paste the details into a new calendar event.';
            } catch (_) {
              calendarFeedback.textContent =
                'Copying was blocked by your browser. Try the calendar file instead.';
            }

            calendarFeedback.hidden = false;
          });

          // Keep the chooser open for sign-in retries.

          dialog.addEventListener(
            'click',
            (event) => {
              if (event.target === dialog) {
                dialog.close();
              }
            }
          );

          dialog.addEventListener(
            'close',
            () => dialog.remove(),
            { once: true }
          );

          document.body.appendChild(dialog);
          dialog.showModal();
        };

        eaUnlockButtons.forEach((button) => {
          const label =
            $('span', button);

          if (label) {
            label.textContent =
              'set a reminder';
          }

          button.addEventListener(
            'click',
            (event) => {
              event.preventDefault();
              event.stopImmediatePropagation();
              downloadLaunchReminder();
            },
            true
          );
        });
      }
    }

    const preLaunchHeroMood =
      $('.pdp-hero-mood', productPage);

    if (
      isPreEarlyAccessPage &&
      preLaunchHeroMood &&
      earlyAccess.homepageImage
    ) {
      preLaunchHeroMood.removeAttribute(
        'srcset'
      );

      preLaunchHeroMood.removeAttribute(
        'sizes'
      );

      preLaunchHeroMood.src =
        earlyAccess.homepageImage;
    }

    const preLaunchFirstLook =
      $('[data-pdp-prelaunch-first-look]', productPage);

    const preLaunchFirstLookMedia =
      $('[data-pdp-prelaunch-first-look-media]', productPage);

    if (
      isPreEarlyAccessPage &&
      preLaunchFirstLook &&
      preLaunchFirstLookMedia &&
      earlyAccess.firstLookVideo
    ) {
      const getYouTubeId = (url) => {
        try {
          const parsed =
            new URL(url);

          if (
            parsed.hostname === 'youtu.be' ||
            parsed.hostname === 'www.youtu.be'
          ) {
            return parsed.pathname
              .replace('/', '')
              .split('/')[0];
          }

          if (
            parsed.hostname === 'youtube.com' ||
            parsed.hostname === 'www.youtube.com'
          ) {
            if (parsed.pathname === '/watch') {
              return parsed.searchParams.get('v');
            }

            const parts =
              parsed.pathname
                .split('/')
                .filter(Boolean);

            if (
              parts[0] === 'embed' ||
              parts[0] === 'shorts'
            ) {
              return parts[1];
            }
          }
        } catch (_) {}

        return null;
      };

      const youtubeId =
        getYouTubeId(
          earlyAccess.firstLookVideo
        );

      if (youtubeId) {
        const firstLookVideo =
          document.createElement('iframe');

        firstLookVideo.src =
          `https://www.youtube-nocookie.com/embed/${youtubeId}?rel=0`;

        firstLookVideo.title =
          `A first look at ${earlyAccess.product.title}`;

        firstLookVideo.allow =
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';

        firstLookVideo.allowFullscreen = true;

        preLaunchFirstLookMedia.replaceChildren(
          firstLookVideo
        );

        preLaunchFirstLook.hidden = false;
      }
    }

    const preLaunchBts =
      $('[data-pdp-prelaunch-bts]', productPage);

    const preLaunchBtsMedia =
      $('[data-pdp-prelaunch-bts-media]', productPage);

    if (
      isPreEarlyAccessPage &&
      preLaunchBts &&
      preLaunchBtsMedia &&
      earlyAccess.preLaunchBtsVideo
    ) {
      const getBtsYouTubeId = (url) => {
        try {
          const parsed =
            new URL(url);

          if (
            parsed.hostname === 'youtu.be' ||
            parsed.hostname === 'www.youtu.be'
          ) {
            return parsed.pathname
              .replace('/', '')
              .split('/')[0];
          }

          if (
            parsed.hostname === 'youtube.com' ||
            parsed.hostname === 'www.youtube.com'
          ) {
            if (parsed.pathname === '/watch') {
              return parsed.searchParams.get('v');
            }

            const parts =
              parsed.pathname
                .split('/')
                .filter(Boolean);

            if (
              parts[0] === 'embed' ||
              parts[0] === 'shorts'
            ) {
              return parts[1];
            }
          }
        } catch (_) {}

        return null;
      };

      const btsYouTubeId =
        getBtsYouTubeId(
          earlyAccess.preLaunchBtsVideo
        );

      if (btsYouTubeId) {
        const btsVideo =
          document.createElement('iframe');

        btsVideo.src =
          `https://www.youtube-nocookie.com/embed/${btsYouTubeId}?rel=0`;

        btsVideo.title =
          `Behind the sound of ${earlyAccess.product.title}`;

        btsVideo.allow =
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';

        btsVideo.allowFullscreen = true;

        preLaunchBtsMedia.replaceChildren(
          btsVideo
        );

        preLaunchBts.hidden = false;
      }
    }

    const getSocialProofEmbed = (rawUrl) => {
      try {
        const parsed =
          new URL(rawUrl);

        const hostname =
          parsed.hostname
            .replace(/^www\./, '')
            .toLowerCase();

        if (
          hostname === 'youtube.com' ||
          hostname === 'youtu.be'
        ) {
          let videoId = null;
          let isShort = false;

          if (hostname === 'youtu.be') {
            videoId =
              parsed.pathname
                .split('/')
                .filter(Boolean)[0];
          } else if (parsed.pathname === '/watch') {
            videoId =
              parsed.searchParams.get('v');
          } else {
            const parts =
              parsed.pathname
                .split('/')
                .filter(Boolean);

            if (
              parts[0] === 'shorts' ||
              parts[0] === 'embed'
            ) {
              videoId = parts[1];
              isShort = parts[0] === 'shorts';
            }
          }

          if (!videoId) return null;

          return {
            url:
              `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`,
            platform: 'youtube',
            portrait: isShort
          };
        }

        if (hostname === 'tiktok.com') {
          const match =
            parsed.pathname.match(
              /\/video\/(\d+)/
            );

          if (!match) return null;

          return {
            url:
              `https://www.tiktok.com/player/v1/${match[1]}?autoplay=1&description=1&music_info=1`,
            platform: 'tiktok',
            portrait: true
          };
        }

        if (hostname === 'instagram.com') {
          const path =
            parsed.pathname
              .replace(/\/+$/, '');

          if (
            !path.startsWith('/reel/') &&
            !path.startsWith('/p/') &&
            !path.startsWith('/tv/')
          ) {
            return null;
          }

          return {
            url:
              `https://www.instagram.com${path}/embed/`,
            platform: 'instagram',
            portrait: true
          };
        }
      } catch (_) {}

      return null;
    };

    let activeProofPlayer = null;

    const resetProofPlayer = () => {
      if (!activeProofPlayer) return;

      const { holder, thumbnailButton } = activeProofPlayer;
      const frame = $('iframe', holder);

      if (frame) frame.removeAttribute('src');

      holder.replaceWith(thumbnailButton);
      activeProofPlayer = null;
    };

    document.addEventListener('pointerdown', (event) => {
      if (
        activeProofPlayer &&
        !activeProofPlayer.holder.contains(event.target)
      ) {
        resetProofPlayer();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') resetProofPlayer();
    });

    $$(
      '[data-pdp-proof-video]',
      productPage
    ).forEach((button) => {
      button.addEventListener(
        'click',
        () => {
          const proofUrl =
            button.dataset.proofUrl;

          const embed =
            getSocialProofEmbed(
              proofUrl
            );

          if (!embed) {
            window.open(
              proofUrl,
              '_blank',
              'noopener,noreferrer'
            );

            return;
          }

          const thumbnail =
            $('img', button);

          const thumbnailWidth =
            thumbnail?.naturalWidth ||
            Number(
              thumbnail?.getAttribute(
                'width'
              )
            ) ||
            0;

          const thumbnailHeight =
            thumbnail?.naturalHeight ||
            Number(
              thumbnail?.getAttribute(
                'height'
              )
            ) ||
            0;

          const isPortrait =
            thumbnailWidth &&
            thumbnailHeight
              ? thumbnailHeight >
                thumbnailWidth
              : embed.portrait;

          const frame =
            document.createElement(
              'iframe'
            );

          frame.className =
            `pdp-prelaunch-proof-card__embed ${
              isPortrait
                ? 'pdp-prelaunch-proof-card__embed--portrait'
                : 'pdp-prelaunch-proof-card__embed--landscape'
            }`;

          frame.src =
            embed.url;

          frame.title =
            `Watch ${embed.platform} video`;

          frame.allow =
            'autoplay; encrypted-media; picture-in-picture; fullscreen';

          frame.allowFullscreen =
            true;

          const bounds = button.getBoundingClientRect();

          const holder = document.createElement('div');
          holder.className =
            'pdp-prelaunch-proof-card__player';

          holder.style.aspectRatio =
            bounds.width > 0 && bounds.height > 0
              ? `${bounds.width} / ${bounds.height}`
              : isPortrait ? '9 / 16' : '16 / 9';

          const close = document.createElement('button');
          close.type = 'button';
          close.className =
            'pdp-prelaunch-proof-card__player-close';
          close.textContent = '×';
          close.setAttribute('aria-label', 'Close video');
          close.addEventListener('click', resetProofPlayer);

          resetProofPlayer();

          holder.append(frame, close);
          button.replaceWith(holder);

          activeProofPlayer = {
            holder,
            thumbnailButton: button
          };
        }
      );
    });

    if (preLaunchSubscriberNote) {
      preLaunchSubscriberNote.hidden =
        !isPreEarlyAccessPage;

      preLaunchSubscriberNote.textContent =
        isSubscriberEmailVisitor
          ? earlyAccess.customerEmailSubscribed === true
            ? `You’re on the list. We’ll email you when ${earlyAccess.product.title} launches.`
            : `Subscribers will receive an email when ${earlyAccess.product.title} launches.`
          : `Already subscribed? You’re set. We’ll email you when ${earlyAccess.product.title} launches.`;
    }

    const preLaunchFinalCopy =
      $('[data-pdp-prelaunch-final-copy]', productPage);

    const preLaunchFinalFormHeading =
      $('.pdp-prelaunch-mini-signup__heading h3', productPage);

    if (
      isPreEarlyAccessPage &&
      preLaunchFinalCopy
    ) {
      const publicSaving =
        Number(
          earlyAccess.savingPercentage
        ) || 0;

      const subscriberSaving =
        Number(
          earlyAccess.subscriberSavingPercentage
        ) || 0;

      if (publicSaving > 0) {
        preLaunchFinalCopy.textContent =
          `Join the list for the subscriber price. Everyone else saves ${publicSaving}%.`;
      } else {
        preLaunchFinalCopy.textContent =
          'Join the list for the subscriber price.';
      }

      if (
        preLaunchFinalFormHeading &&
        subscriberSaving > 0
      ) {
        preLaunchFinalFormHeading.textContent =
          `Get ${subscriberSaving}% off.`;
      }
    }

    if (
      isPreEarlyAccessPage &&
      isSubscriberEmailVisitor &&
      downloadLaunchReminder
    ) {
      const finalCta =
        $('.pdp-prelaunch-final-cta', productPage);

      if (finalCta) {
        const finalTitle =
          $('.pdp-prelaunch-mini-signup__copy h2', finalCta);

        const finalLabel =
          $('.pdp-prelaunch-mini-signup__heading .section-label', finalCta);

        const finalAction =
          $('.pdp-prelaunch-mini-signup__form', finalCta);

        const finalForm =
          $('#PdpPreLaunchFinalSignupForm', finalCta);

        const formResult =
          $('.pdp-prelaunch-mini-signup__success, .pdp-prelaunch-mini-signup__errors', finalCta);

        if (finalTitle) {
          finalTitle.textContent =
            earlyAccess.customerEmailSubscribed === true
              ? 'You’re on the list.'
              : `${earlyAccess.product.title} is almost here.`;
        }

        if (preLaunchFinalCopy) {
          preLaunchFinalCopy.textContent =
            earlyAccess.customerEmailSubscribed === true
              ? `Your subscriber intro price is coming. We’ll email you when ${earlyAccess.product.title} launches.`
              : 'Subscribers get the intro offer at launch. Add a reminder so you don’t miss it.';
        }

        if (finalLabel) {
          finalLabel.textContent =
            'launch reminder';
        }

        if (preLaunchFinalFormHeading) {
          preLaunchFinalFormHeading.textContent =
            'Save the date.';
        }

        if (finalForm && !formResult) {
          const existingArrow =
            $('.pdp-prelaunch-mini-signup__submit .inline-arrow', finalForm);

          const reminderWrap =
            document.createElement('div');

          reminderWrap.className =
            'pdp-prelaunch-mini-signup__form-inner';

          const reminderButton =
            document.createElement('button');

          reminderButton.type = 'button';
          reminderButton.className =
            'pdp-prelaunch-mini-signup__submit';

          const reminderLabel =
            document.createElement('span');

          reminderLabel.textContent =
            'set a reminder';

          reminderButton.appendChild(
            reminderLabel
          );

          if (existingArrow) {
            reminderButton.appendChild(
              existingArrow.cloneNode(true)
            );
          }

          reminderButton.addEventListener(
            'click',
            downloadLaunchReminder
          );

          reminderWrap.appendChild(
            reminderButton
          );

          finalForm.replaceWith(
            reminderWrap
          );

          const finalNote =
            finalAction?.querySelector('small');

          if (finalNote) {
            finalNote.textContent =
              'Choose a calendar to add the launch date.';
          }
        }
      }
    }

    if (
      isPreEarlyAccessPage &&
      isSubscriberEmailVisitor &&
      downloadLaunchReminder
    ) {
      const offerLabel =
        $('[data-pdp-prelaunch-offer-label]', productPage);

      if (offerLabel) {
        offerLabel.textContent =
          earlyAccess.customerEmailSubscribed === true
            ? 'your subscriber offer'
            : 'subscriber offer';
      }

      $$(
        '[data-pdp-ea-unlock] .inline-arrow, ' +
        '.pdp-prelaunch-mini-signup__submit .inline-arrow',
        productPage
      ).forEach((icon) => {
        icon.setAttribute(
          'viewBox',
          '0 0 24 24'
        );

        icon.innerHTML =
          '<path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"></path>' +
          '<path d="M10 21h4"></path>';

        icon.closest('button')?.classList.add(
          'pdp-launch-reminder-button'
        );
      });
    }

    const preLaunchSignupForm =
      $('#PdpPreLaunchSignupForm', productPage);

    const subscriberOfferClose =
      $('[data-pdp-subscriber-offer-close]', productPage);

    const preLaunchSignupErrors =
      preLaunchSignup
        ? $('.footer-signup-errors', preLaunchSignup)
        : null;

    let preLaunchSignupSuccess =
      preLaunchSignup
        ? $('.home-pre-ea-signup-success', preLaunchSignup)
        : null;

    if (
      preLaunchSignupSuccess &&
      isEarlyAccessPage
    ) {
      const successHeading =
        $('strong', preLaunchSignupSuccess);

      const successCopy =
        $('[data-pdp-prelaunch-signup-success-copy]', preLaunchSignupSuccess);

      if (successHeading) {
        successHeading.textContent =
          'subscriber discount unlocked.';
      }

      if (successCopy) {
        successCopy.textContent =
          'Your extra discount is unlocked and will be applied automatically at checkout.';
      }
    }

    const preLaunchPendingKey =
      'inlet-pdp-prelaunch-signup-pending';

    const pendingPreLaunchSignup =
      sessionStorage.getItem(
        preLaunchPendingKey
      ) === 'true';

    const returnedFromPreLaunchSignup =
      window.location.hash ===
      '#PdpPreLaunchSignupForm';

    if (
      (
        isPreEarlyAccessPage ||
        isEarlyAccessPage
      ) &&
      pendingPreLaunchSignup &&
      returnedFromPreLaunchSignup &&
      !preLaunchSignupErrors &&
      !preLaunchSignupSuccess &&
      preLaunchSignup
    ) {
      const success =
        document.createElement('div');

      success.className =
        'home-pre-ea-signup-success';

      success.setAttribute(
        'role',
        'status'
      );

      const heading =
        document.createElement('strong');

      heading.textContent =
        isEarlyAccessPage
          ? 'subscriber discount unlocked.'
          : 'you’re on the list.';

      const copy =
        document.createElement('span');

      copy.textContent =
        isEarlyAccessPage
          ? 'Your extra discount is unlocked and will be applied automatically at checkout.'
          : `Your subscriber offer is secured. We’ll email you when ${earlyAccess.product.title} launches.`;

      success.append(
        heading,
        copy
      );

      preLaunchSignup.replaceChildren(
        success
      );

      preLaunchSignupSuccess =
        success;
    }

    if (
      pendingPreLaunchSignup &&
      returnedFromPreLaunchSignup
    ) {
      sessionStorage.removeItem(
        preLaunchPendingKey
      );
    }

    preLaunchSignupForm?.addEventListener(
      'submit',
      () => {
        sessionStorage.setItem(
          preLaunchPendingKey,
          'true'
        );
      }
    );

    subscriberOfferClose?.addEventListener(
      'click',
      () => {
        if (!preLaunchSignup) return;

        preLaunchSignup.hidden = true;

        preLaunchSignup.classList.remove(
          'is-subscriber-offer-focus'
        );

        if (subscriberOfferHeading) {
          subscriberOfferHeading.hidden = true;
        }

        if (isPreEarlyAccessPage) {
          const heroUnlockButton =
            $('.pdp-ea-unlock-trigger', productPage);

          if (heroUnlockButton) {
            heroUnlockButton.hidden = false;
          }
        }
      }
    );

    const openPreLaunchSignup = (
      focusEmail = true,
      highlight = false
    ) => {
      if (!preLaunchSignup) return;

      preLaunchSignup.hidden = false;

      const heroUnlockButton =
        $('.pdp-ea-unlock-trigger', productPage);

      if (heroUnlockButton) {
        heroUnlockButton.hidden = true;
      }

      if (
        isEarlyAccessPage &&
        subscriberOfferHeading
      ) {
        const subscriberSaving =
          Number(
            earlyAccess.subscriberSavingPercentage
          ) || 0;

        const heading =
          $('strong', subscriberOfferHeading);

        if (heading) {
          heading.textContent =
            subscriberSaving > 0
              ? `Get ${subscriberSaving}% off ${earlyAccess.product.title}.`
              : `Get the subscriber price for ${earlyAccess.product.title}.`;
        }

        subscriberOfferHeading.hidden = false;
      }

      if (highlight) {
        preLaunchSignup.classList.add(
          'is-subscriber-offer-focus'
        );

        window.setTimeout(() => {
          preLaunchSignup.classList.remove(
            'is-subscriber-offer-focus'
          );
        }, 2200);
      }

      if (focusEmail) {
        requestAnimationFrame(() => {
          $('#PdpPreLaunchSignupEmail', preLaunchSignup)
            ?.focus({
              preventScroll: true
            });
        });
      }
    };

    if (
      isPreEarlyAccessPage &&
      isSubscriberEmailVisitor &&
      earlyAccess.customerEmailSubscribed !== true &&
      preLaunchSubscriberNote &&
      preLaunchSignupForm &&
      !preLaunchSignupSuccess
    ) {
      const signupFallback = document.createElement('p');
      signupFallback.className =
        'pdp-prelaunch-subscriber-fallback';

      const joinLink = document.createElement('button');
      joinLink.type = 'button';
      joinLink.textContent = 'join the list';

      joinLink.addEventListener('click', () => {
        openPreLaunchSignup(true);
      });

      signupFallback.append('Not subscribed? ', joinLink);
      preLaunchSubscriberNote.after(signupFallback);
    }

           if (subscriberOfferRequested && !isRecognisedActiveVisitor) {
      const shouldFocusEmail =
        window.matchMedia(
          '(hover: hover) and (pointer: fine)'
        ).matches;

      openPreLaunchSignup(
        shouldFocusEmail,
        true
      );
    }

    if (
      (isPreEarlyAccessPage || isEarlyAccessPage) &&
      (
        preLaunchSignupErrors ||
        (preLaunchSignupSuccess && !isConfirmedActiveSubscriber)
      )
    ) {
      openPreLaunchSignup(false);
    }

    eaUnlockButtons.forEach(
      (button) => {
        button.addEventListener(
          'click',
          () => {
            if (!isPreEarlyAccessPage) return;

            openPreLaunchSignup(true);

            if (button.closest('[data-sticky-buy]')) {
              requestAnimationFrame(() => {
                window.scrollTo({
                  top: 0,
                  behavior: window.matchMedia(
                    '(prefers-reduced-motion: reduce)'
                  ).matches ? 'instant' : 'smooth'
                });
              });
            }
          }
        );
      }
    );

    activeIntroPricing?.addEventListener(
      'click',
      (event) => {
        if (
          !isEarlyAccessPage ||
          !event.target.closest('[data-pdp-active-subscriber-cta]')
        ) return;

        openPreLaunchSignup(true);
      }
    );

    stickySaveMore?.addEventListener(
      'click',
      () => {
        if (
          !isEarlyAccessPage ||
          !preLaunchSignup
        ) {
          return;
        }

        openPreLaunchSignup(
          true,
          true
        );

        const purchaseZone =
          $('.pdp-ea-purchase-zone', productPage);

        requestAnimationFrame(
          () => {
            (
              purchaseZone ||
              preLaunchSignup
            ).scrollIntoView({
              behavior:
                window.matchMedia(
                  '(prefers-reduced-motion: reduce)'
                ).matches
                  ? 'auto'
                  : 'smooth',
              block: 'start'
            });
          }
        );
      }
    );


    const heroButton =
      purchaseLocked
        ? $('[data-pdp-ea-unlock]', productPage)
        : $(
            '#HeroProductForm button, #BundleHeroForm button, [data-freebie-page] .product-purchase [data-freebie-product-add]'
          );

    const stickyProductButton =
      $('#StickyProductForm button', productPage);

    if (stickyProductButton?.disabled) {
      $$(
        '#HeroProductForm button, #StickyProductForm button',
        productPage
      ).forEach((button) => {
        button.disabled = true;
      });
    }

    if (
      heroButton &&
      sticky
    ) {
      const finalPreLaunchCta =
        $('.pdp-prelaunch-final-cta', productPage);

      const stickyVisibilityAnchor =
        isPreEarlyAccessPage
          ? $('.pdp-ea-purchase-zone', productPage)
          : heroButton;

      let heroHasPassed = false;
      let finalPreLaunchCtaReached = false;

      const updateStickyVisibility = () => {
        const visible =
          heroHasPassed &&
          !(
            isPreEarlyAccessPage &&
            finalPreLaunchCtaReached
          );

        sticky.classList.toggle(
          'visible',
          visible
        );

        sticky.setAttribute(
          'aria-hidden',
          String(!visible)
        );

        if (visible) {
          sticky.removeAttribute('inert');
        } else {
          sticky.setAttribute('inert', '');
        }
      };

      new IntersectionObserver(
        ([entry]) => {
          heroHasPassed =
            !entry.isIntersecting &&
            entry.boundingClientRect.bottom <= 0;

          updateStickyVisibility();
        },
        { threshold: 0.01 }
      ).observe(stickyVisibilityAnchor || heroButton);

      if (
        isPreEarlyAccessPage &&
        finalPreLaunchCta
      ) {
        new IntersectionObserver(
          ([entry]) => {
            finalPreLaunchCtaReached =
              entry.isIntersecting ||
              entry.boundingClientRect.top <= 0;

            updateStickyVisibility();
          },
          { threshold: 0.1 }
        ).observe(finalPreLaunchCta);
      }
    }

    const dock = () => {
      if (!sticky || !footer) return;

      const gutter =
        parseFloat(
          getComputedStyle(sticky)
            .getPropertyValue('--sticky-gutter')
        ) || 18;

      sticky.style.setProperty(
        '--sticky-footer-offset',
        `${Math.max(
          0,
          Math.ceil(
            innerHeight -
            footer.getBoundingClientRect().top -
            gutter
          )
        )}px`
      );
    };

    addEventListener(
      'scroll',
      dock,
      { passive: true }
    );

    addEventListener(
      'resize',
      dock
    );

    dock();

    const links =
      $$('[data-chapter-link]');

    const sections =
      links
        .map((a) =>
          document.getElementById(
            a.dataset.chapterLink
          )
        )
        .filter(Boolean);

    const chapter = () => {
      let active = '';

      sections.forEach((section) => {
        if (
          section.getBoundingClientRect().top <=
          innerHeight * .34
        ) {
          active = section.id;
        }
      });

      links.forEach((a) => {
        const current =
          a.dataset.chapterLink === active;

        a.classList.toggle(
          'section-active',
          current
        );

        if (current) {
          a.setAttribute(
            'aria-current',
            'location'
          );
        } else {
          a.removeAttribute(
            'aria-current'
          );
        }
      });
    };

    addEventListener(
      'scroll',
      chapter,
      { passive: true }
    );

    chapter();
  }

    const help = $('[data-help-page]');
  if (help) {
    let category = 'setup';

    const input = $('[data-help-search]', help);
    const searchForm = $('[data-help-search-form]', help);
    const answers = $('#answers', help);

    const renderHelp = () => {
      const query = input.value.trim().toLowerCase();
      let count = 0;

      $$('[data-faq-group]', help).forEach((group) => {
        let groupCount = 0;

        $$('details', group).forEach((item) => {
          const match =
            !query ||
            `${$('summary span', item).textContent} ${item.dataset.search}`
              .toLowerCase()
              .includes(query);

          item.hidden = !match;

          if (match) groupCount += 1;
        });

        group.hidden = query
          ? groupCount === 0
          : group.dataset.faqGroup !== category;

        count += query ? groupCount : 0;
      });

      $$('[data-help-category]', help).forEach((button) => {
        const selected =
          !query &&
          button.dataset.helpCategory === category;

        button.classList.toggle('selected', selected);
        button.setAttribute(
          'aria-pressed',
          String(selected)
        );
      });

      $('[data-help-clear]', help).hidden = !query;
      $('[data-help-empty]', help).hidden =
        !query || count > 0;

      const counter = $('[data-help-count]', help);
      counter.hidden = !query;

      if (query) {
        counter.textContent =
          `${count} ${count === 1 ? 'answer' : 'answers'} ` +
          `for “${input.value}”`;
      }
    };

    $$('[data-help-category]', help).forEach((button) => {
      button.addEventListener('click', () => {
        category = button.dataset.helpCategory;
        input.value = '';
        renderHelp();
      });
    });

    input.addEventListener('input', renderHelp);

    searchForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      renderHelp();

      if (!input.value.trim() || !answers) return;

      const categories = $('.help-categories', help);
      const categoryHeight =
        categories?.getBoundingClientRect().height || 0;
      const targetTop =
        window.scrollY +
        answers.getBoundingClientRect().top -
        70 -
        categoryHeight -
        16;

      window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
          ? 'auto'
          : 'smooth'
      });
    });

    $$('[data-help-clear]', help).forEach((button) => {
      button.addEventListener('click', () => {
        input.value = '';
        renderHelp();
        input.focus();
      });
    });

    renderHelp();
  }
  const cookieBanner = $('[data-cookie-banner]');
  const cookiePreferences = $('[data-cookie-preferences]');

  if (cookieBanner && cookiePreferences) {
    const cookieFeedback = $$('[data-cookie-feedback]');
    const cookieActionButtons = $$('[data-cookie-action]');

    const consentInputs = {
      preferences: $(
        '[data-cookie-consent="preferences"]',
        cookiePreferences
      ),
      analytics: $(
        '[data-cookie-consent="analytics"]',
        cookiePreferences
      ),
      marketing: $(
        '[data-cookie-consent="marketing"]',
        cookiePreferences
      ),
    };

        let privacyApi = null;
    let privacyReady = false;

        const cookiePreviewStorageKey =
      'inlet-cookie-choice-preview-v1';

    const isThemePreview = Boolean(
      window.Shopify?.designMode ||
      new URLSearchParams(
        window.location.search
      ).has('preview_theme_id')
    );

    const setCookieFeedback = (
      message = '',
      isError = false
    ) => {
      cookieFeedback.forEach((node) => {
        node.textContent = message;
        node.hidden = !message;
        node.classList.toggle('is-error', isError);
      });
    };

    const setCookieBusy = (busy) => {
      cookieActionButtons.forEach((button) => {
        button.disabled = busy;
      });
    };

    const populateCookiePreferences = () => {
      if (!privacyApi) return;

      const consent = privacyApi.currentVisitorConsent();

      Object.entries(consentInputs).forEach(([key, input]) => {
        if (input) input.checked = consent[key] === 'yes';
      });
    };

    const openCookiePreferences = (trigger) => {
      populateCookiePreferences();

      setCookieFeedback(
        privacyReady
          ? ''
          : 'privacy settings are still loading.'
      );

      openLayer(cookiePreferences, trigger);
    };

    const saveCookieConsent = (consent) =>
      new Promise((resolve, reject) => {
        if (!privacyApi) {
          reject(
            new Error(
              'privacy settings are not available yet. please try again.'
            )
          );

          return;
        }

        privacyApi.setTrackingConsent(
          consent,
          (result) => {
            if (result?.error) {
              const message = Array.isArray(result.error)
                ? result.error.join(' ')
                : String(result.error);

              reject(new Error(message));
              return;
            }

            resolve();
          }
        );
      });

    const applyCookieChoice = async (consent) => {
      setCookieBusy(true);
      setCookieFeedback('saving your choices…');

      try {
                await saveCookieConsent(consent);

        if (isThemePreview) {
          try {
            window.sessionStorage.setItem(
              cookiePreviewStorageKey,
              'saved'
            );
          } catch (error) {
            // Preview persistence is optional.
          }
        }

        cookieBanner.hidden = true;
        setCookieFeedback('choices saved.');

        if (!cookiePreferences.hidden) {
          closeLayer(cookiePreferences);
        }
      } catch (error) {
        setCookieFeedback(error.message, true);
      } finally {
        setCookieBusy(false);
      }
    };

    $$('[data-cookie-open-settings]').forEach(
      (button) => {
        button.addEventListener('click', () => {
          openCookiePreferences(button);
        });
      }
    );

        document.addEventListener('click', (event) => {
      const cookieSettingsLink =
        event.target.closest('[data-cookie-settings]');

      if (!cookieSettingsLink) return;

      event.preventDefault();
      openCookiePreferences(cookieSettingsLink);
    });

    $(
      '[data-cookie-preferences-close]',
      cookiePreferences
    )?.addEventListener('click', () => {
      closeLayer(cookiePreferences);
    });

    cookiePreferences.addEventListener(
      'mousedown',
      (event) => {
        if (event.target === cookiePreferences) {
          closeLayer(cookiePreferences);
        }
      }
    );

    cookiePreferences.addEventListener(
      'keydown',
      (event) => {
        trap(event, cookiePreferences);
      }
    );

    cookieActionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const action = button.dataset.cookieAction;

        if (action === 'accept') {
          applyCookieChoice({
            preferences: true,
            analytics: true,
            marketing: true,
          });

          return;
        }

        if (action === 'reject') {
          applyCookieChoice({
            preferences: false,
            analytics: false,
            marketing: false,
          });

          return;
        }

        if (action === 'save') {
          applyCookieChoice({
            preferences: Boolean(
              consentInputs.preferences?.checked
            ),
            analytics: Boolean(
              consentInputs.analytics?.checked
            ),
            marketing: Boolean(
              consentInputs.marketing?.checked
            ),
          });
        }
      });
    });

    const initialiseCustomerPrivacy = () => {
      if (!window.Shopify?.loadFeatures) {
        setCookieFeedback(
          'privacy settings are temporarily unavailable.',
          true
        );

        return;
      }

      window.Shopify.loadFeatures(
        [
          {
            name: 'consent-tracking-api',
            version: '0.1',
          },
        ],
        (error) => {
          if (
            error ||
            !window.Shopify.customerPrivacy
          ) {
            setCookieFeedback(
              'privacy settings are temporarily unavailable.',
              true
            );

            return;
          }

          privacyApi =
            window.Shopify.customerPrivacy;

          privacyReady = true;

          populateCookiePreferences();
          setCookieFeedback('');

                    const currentConsent =
            privacyApi.currentVisitorConsent();

          const hasRecordedConsent = [
            'preferences',
            'analytics',
            'marketing',
          ].some(
            (key) =>
              currentConsent[key] === 'yes' ||
              currentConsent[key] === 'no'
          );

          let previewChoiceSaved = false;

          if (isThemePreview) {
            try {
              previewChoiceSaved =
                window.sessionStorage.getItem(
                  cookiePreviewStorageKey
                ) === 'saved';
            } catch (error) {
              previewChoiceSaved = false;
            }
          }

          cookieBanner.hidden =
            hasRecordedConsent ||
            previewChoiceSaved ||
            !privacyApi.shouldShowBanner();
        }
      );
    };

    document.addEventListener(
      'visitorConsentCollected',
      () => {
        populateCookiePreferences();
      }
    );

    initialiseCustomerPrivacy();
  }
  const reviewFormSelector = '.jdgm-form-wrapper';
  const reviewObservers = new WeakMap();

  const reviewFormIsVisible = (form) => {
    if (!form || form.hidden) return false;

    return (
      form.getAttribute('aria-hidden') !== 'true' &&
      window.getComputedStyle(form).display !== 'none'
    );
  };

  const getReviewContext = (source) => {
    const reviewSection = source?.closest?.('.pdp-reviews');

    if (!reviewSection) return null;

    const widget = reviewSection.querySelector(
      '#judgeme_product_reviews'
    );

    return {
      reviewSection,
      widget,
      form: reviewSection.querySelector(reviewFormSelector),
      dynamicForms: [
        ...reviewSection.querySelectorAll(
          '.jdgm-form-dynamic-wrapper'
        ),
      ],
      customTrigger: reviewSection.querySelector(
        '[data-review-write-trigger]'
      ),
      judgeMeTrigger: reviewSection.querySelector(
        '.jdgm-write-rev-link'
      ),
    };
  };

  const syncReviewState = (context) => {
    const expanded = reviewFormIsVisible(context?.form);

    context?.customTrigger?.setAttribute(
      'aria-expanded',
      String(expanded)
    );

    context?.judgeMeTrigger?.setAttribute(
      'aria-expanded',
      String(expanded)
    );

    return expanded;
  };

  const clearJudgeMeHash = () => {
    if (window.location.hash !== '#judgeme_product_reviews') {
      return;
    }

    window.history.replaceState(
      window.history.state,
      '',
      `${window.location.pathname}${window.location.search}`
    );
  };

  const preserveReviewViewport = (position) => {
    const root = document.documentElement;
    const previousOverflowAnchor =
      root.style.overflowAnchor;

    let remainingFrames = 4;

    root.style.overflowAnchor = 'none';

    const holdPosition = () => {
      window.scrollTo({
        left: position.left,
        top: position.top,
        behavior: 'auto',
      });

      remainingFrames -= 1;

      if (remainingFrames > 0) {
        window.requestAnimationFrame(holdPosition);
        return;
      }

      root.style.overflowAnchor = previousOverflowAnchor;
    };

    holdPosition();
  };

  const focusReviewForm = (context) => {
    const form = context?.form;

    if (!reviewFormIsVisible(form)) return;

    const focusTarget =
      form.querySelector('.jdgm-form__title') ||
      form.querySelector(
        '[role="radio"], textarea, input:not([type="hidden"]), select, button, [href]'
      );

    if (!focusTarget) return;

    if (
      !focusTarget.matches(
        'input, textarea, select, button, [href], [tabindex]'
      )
    ) {
      focusTarget.setAttribute('tabindex', '-1');
    }

    focusTarget.focus({ preventScroll: true });
  };

  const reviewFormHasDraft = (form) =>
    form?.dataset.inletReviewDirty === 'true';

  const enhanceReviewForm = (context) => {
    const form = context?.form;

    if (!form) return;

    if (form.dataset.inletReviewDraftTracking !== 'true') {
      const markDirty = () => {
        form.dataset.inletReviewDirty = 'true';
      };

      form.addEventListener('input', markDirty);
      form.addEventListener('change', markDirty);
      form.dataset.inletReviewDraftTracking = 'true';
    }

    [
      {
        selector: 'input[name="review_title"]',
        fallbackMax: 100,
      },
      {
        selector: 'textarea[name="review_body"]',
        fallbackMax: 5000,
      },
    ].forEach(({ selector, fallbackMax }) => {
      const control = form.querySelector(selector);
      const fieldset = control?.closest('.jdgm-form__fieldset');

      if (!control || !fieldset) return;

      let counter = fieldset.querySelector(
        '.inlet-review-character-count'
      );

      if (!counter) {
        counter = document.createElement('span');
        counter.className = 'inlet-review-character-count';
        counter.setAttribute('aria-hidden', 'true');
        fieldset.append(counter);
      }

      const hideNativeCounters = () => {
        fieldset
          .querySelectorAll('span, small, p, div')
          .forEach((node) => {
            if (
              node === counter ||
              node.contains(control) ||
              node.contains(counter)
            ) {
              return;
            }

            const text = node.textContent?.trim() || '';

            if (
              node.dataset.inletNativeCounterHidden !== 'true' &&
                            /^(?:\(\d+\)|\d+\s*\/\s*\d+(?:\s*(?:characters?|chars?))?|\d+\s+of\s+\d+|\d+\s+(?:characters?|chars?)(?:\s+(?:remaining|left))?)$/i.test(
                text
              )
            ) {
              node.dataset.inletNativeCounterHidden = 'true';
              node.style.setProperty(
                'display',
                'none',
                'important'
              );
            }
          });
      };

      const updateCounter = () => {
        const max =
          Number(control.getAttribute('maxlength')) ||
          fallbackMax;
        const length = control.value.length;

        counter.textContent = `${length} / ${max}`;
        counter.classList.toggle(
          'is-visible',
          length > 0
        );

        hideNativeCounters();
        window.requestAnimationFrame(hideNativeCounters);
      };

      if (control.dataset.inletCharacterCount !== 'true') {
        control.addEventListener('input', updateCounter);
        control.dataset.inletCharacterCount = 'true';
      }

      updateCounter();
    });
  };

  const observeReviewForm = (context) => {
    if (
      !context?.widget ||
      reviewObservers.has(context.widget)
    ) {
      return;
    }

    const observer = new MutationObserver(() => {
      const refreshedContext = getReviewContext(
        context.reviewSection
      );

      if (refreshedContext) {
        syncReviewState(refreshedContext);
      }
    });

    observer.observe(context.widget, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: [
        'style',
        'hidden',
        'aria-hidden',
      ],
    });

    reviewObservers.set(context.widget, observer);
  };

  const openReviewForm = (context) => {
    if (!context?.form) return;

    observeReviewForm(context);

    if (reviewFormIsVisible(context.form)) {
      enhanceReviewForm(context);
      focusReviewForm(context);
      return;
    }

    const viewport = {
      left: window.scrollX,
      top: window.scrollY,
    };

    /*
     * Show Judge.me's existing form directly. Its validation,
     * submission and success handling remain untouched.
     */
    context.form.hidden = false;
    context.form.style.setProperty('display', 'block');
    context.form.setAttribute('aria-hidden', 'false');

    syncReviewState(context);
    clearJudgeMeHash();
    preserveReviewViewport(viewport);

    window.requestAnimationFrame(() => {
      const refreshedContext =
        getReviewContext(context.reviewSection) || context;

      enhanceReviewForm(refreshedContext);
      focusReviewForm(refreshedContext);
    });
  };

  const closeReviewForm = (context) => {
    if (!context?.form) return;

    const viewport = {
      left: window.scrollX,
      top: window.scrollY,
    };

    context.form.style.setProperty('display', 'none');
    context.form.setAttribute('aria-hidden', 'true');

    context.dynamicForms.forEach((form) => {
      form.style.setProperty('display', 'none');
      form.setAttribute('aria-hidden', 'true');
    });

    syncReviewState(context);
    clearJudgeMeHash();
    preserveReviewViewport(viewport);

    window.requestAnimationFrame(() => {
      context.customTrigger?.focus({
        preventScroll: true,
      });
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const openTrigger = event.target.closest(
        [
          '[data-review-write-trigger]',
          '.pdp-reviews .jdgm-write-rev-link',
        ].join(', ')
      );

      if (openTrigger) {
        const context = getReviewContext(openTrigger);

        if (!context?.form) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        if (reviewFormIsVisible(context.form)) {
          closeReviewForm(context);
        } else {
          openReviewForm(context);
        }

        return;
      }

      const cancelTrigger = event.target.closest(
        '.pdp-reviews .jdgm-cancel-rev'
      );

      if (cancelTrigger) {
        const context = getReviewContext(cancelTrigger);

        if (!context?.form) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        closeReviewForm(context);
      }
    },
    true
  );

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    if (
      event.target.closest(
        '.modal-backdrop, .bundle-overlay, .freebie-gate-backdrop'
      )
    ) {
      return;
    }

    $$('.pdp-reviews').forEach((reviewSection) => {
      const context = getReviewContext(reviewSection);

      if (
        !context?.form ||
        !reviewFormIsVisible(context.form) ||
        context.form.contains(event.target) ||
        reviewFormHasDraft(context.form)
      ) {
        return;
      }

      closeReviewForm(context);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    if (
      $(
        '.modal-backdrop:not([hidden]), .bundle-overlay:not([hidden]), .freebie-gate-backdrop:not([hidden])'
      )
    ) {
      return;
    }

    const reviewSection = $$('.pdp-reviews').find((section) => {
      const context = getReviewContext(section);
      return reviewFormIsVisible(context?.form);
    });

    if (!reviewSection) return;

    const context = getReviewContext(reviewSection);

    if (!context?.form) return;

    event.preventDefault();
    closeReviewForm(context);
  });

  const reviewDisclosureControllers = new WeakMap();
  const reviewInitialCount = 3;
  const reviewBatchSize = 6;
  const reviewApiPageSize = 30;
  const reviewSortMap = {
    'most-recent': ['created_at', 'desc'],
    'highest-rating': ['rating', 'desc'],
    'lowest-rating': ['rating', 'asc'],
    'with-pictures': ['with_pictures', ''],
    'pictures-first': ['pictures_first', ''],
    'videos-first': ['videos_first', ''],
    'most-helpful': ['most_helpful', ''],
    'verified-only': ['verified_only', ''],
  };

  const createReviewDisclosureArrow = () => {
    const namespace = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(namespace, 'svg');
    const path = document.createElementNS(namespace, 'path');

    svg.setAttribute('viewBox', '0 0 16 16');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    path.setAttribute('d', 'M4 12 12 4M6 4h6v6');

    svg.append(path);
    return svg;
  };

  const formatReviewDate = (timestamp) => {
    if (!timestamp) return;

    timestamp.classList.remove('jdgm-spinner');

    if (timestamp.textContent.trim()) return;

    const value =
      timestamp.getAttribute('datetime') || timestamp.dataset.content;
    const date = value ? new Date(value) : null;

    if (!date || Number.isNaN(date.getTime())) return;

    timestamp.textContent = new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date);
  };

  const normaliseReviewCard = (review) => {
    review
      .querySelectorAll(
        [
          '.jdgm-rev__reply',
          '.jdgm-rev__custom-form',
          '.jdgm-rev__pics',
          '.jdgm-rev__vids',
        ].join(', ')
      )
      .forEach((element) => {
        const containsUsefulContent =
          element.textContent.trim() ||
          element.querySelector(
            'img, video, iframe, a, button, input'
          );

        if (!containsUsefulContent) {
          element.remove();
        }
      });

    const header = review.querySelector('.jdgm-rev__header');

    if (!header || header.querySelector('.jdgm-row-rating')) {
      return review;
    }

    const rating = header.querySelector('.jdgm-rev__rating');
    const timestamp = header.querySelector('.jdgm-rev__timestamp');
    const icon = header.querySelector('.jdgm-rev__icon');
    const author = header.querySelector('.jdgm-rev__author-wrapper');
    const badge = header.querySelector(
      '.jdgm-rev__buyer-badge-wrapper'
    );
    const location = header.querySelector('.jdgm-rev__location');
    const ratingRow = document.createElement('div');
    const profileRow = document.createElement('div');
    const extraRow = document.createElement('div');

    review.classList.add('jdgm--done-setup');
    ratingRow.className = 'jdgm-row-rating';
    profileRow.className = 'jdgm-row-profile';
    extraRow.className = 'jdgm-row-extra';

    if (rating) ratingRow.append(rating);

    if (timestamp) {
      formatReviewDate(timestamp);
      ratingRow.append(timestamp);
    }

    if (icon) profileRow.append(icon);

    if (author) {
      if (badge && review.dataset.verifiedBuyer === 'true') {
        author.append(badge);
      } else {
        badge?.remove();
      }

      profileRow.append(author);
    }

    if (location) extraRow.append(location);

    header.prepend(ratingRow, profileRow, extraRow);

    return review;
  };

  const initialiseReviewDisclosure = (widget) => {
    if (reviewDisclosureControllers.has(widget)) return;
    if (!widget.classList.contains('jdgm--done-setup-widget')) return;

    const root = widget.querySelector('.jdgm-rev-widg');
    let list = widget.querySelector('.jdgm-rev-widg__reviews');
    let pagination = widget.querySelector('.jdgm-paginate');

    if (!root || !list || !pagination) return;

    let totalCount =
      Number(root.dataset.numberOfReviews) ||
      Number(
        widget
          .closest('.pdp-reviews')
          ?.querySelector('.pdp-review-score span')
          ?.textContent.match(/\d+/)?.[0]
      ) ||
      list.querySelectorAll(':scope > .jdgm-rev').length;

    let visibleCount = Math.min(reviewInitialCount, totalCount);
    let apiPage = 0;
    let loading = false;
    let sortResetTimer;
    let sortFirstCard;

    if (!list.id) {
      list.id = `${widget.id || 'judgeme'}-visible-reviews`;
    }

    const controls = document.createElement('div');
    const loadMore = document.createElement('button');
    const loadMoreLabel = document.createElement('span');
    const showFewer = document.createElement('button');
    const status = document.createElement('span');

    controls.className = 'pdp-review-disclosure';
    controls.dataset.reviewDisclosure = '';

    loadMore.type = 'button';
    loadMore.className =
      'pdp-review-disclosure-button pdp-review-disclosure-button--more';
    loadMore.setAttribute('aria-controls', list.id);
    loadMoreLabel.textContent = 'load more reviews';
    loadMore.append(
      loadMoreLabel,
      createReviewDisclosureArrow()
    );

    showFewer.type = 'button';
    showFewer.className =
      'pdp-review-disclosure-button pdp-review-disclosure-button--fewer';
    showFewer.setAttribute('aria-controls', list.id);
    showFewer.textContent = 'show fewer reviews';

    status.className = 'pdp-review-disclosure-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');

    controls.append(loadMore, showFewer, status);

    const placeControls = () => {
      const body = widget.querySelector('.jdgm-rev-widg__body');

      if (body && controls.previousElementSibling !== body) {
        body.insertAdjacentElement('afterend', controls);
      }
    };

    const getCards = () => [
      ...list.querySelectorAll(':scope > .jdgm-rev'),
    ];

    const readTotal = () => {
      const nextRoot = widget.querySelector('.jdgm-rev-widg');

      return (
        Number(nextRoot?.dataset.numberOfReviews) ||
        Number(
          widget
            .closest('.pdp-reviews')
            ?.querySelector('.pdp-review-score span')
            ?.textContent.match(/\d+/)?.[0]
        ) ||
        getCards().length
      );
    };

    const render = () => {
      const cards = getCards();

      cards.forEach((card, index) => {
        card.hidden = index >= visibleCount;
      });

      widget.dataset.reviewDisclosureReady = '';

      loadMore.hidden = visibleCount >= totalCount;
      loadMore.setAttribute(
        'aria-expanded',
        String(visibleCount > reviewInitialCount)
      );

      showFewer.hidden = visibleCount <= reviewInitialCount;
      controls.hidden = totalCount <= reviewInitialCount;

      status.textContent = `${Math.min(
        visibleCount,
        totalCount
      )} of ${totalCount} reviews shown`;
    };

    const getSort = () => {
      const selected =
        widget.querySelector('.jdgm-sort-dropdown')?.value ||
        'most-recent';

      return reviewSortMap[selected] || reviewSortMap['most-recent'];
    };

    const fetchReviewPage = async () => {
      const endpoint = pagination?.dataset.url;
      const productId =
        widget.dataset.productId || widget.dataset.id;

      if (!endpoint || !productId) {
        throw new Error(
          'Judge.me review endpoint is unavailable.'
        );
      }

      const url = new URL(endpoint, window.location.href);

      if (!/(^|\.)judge\.me$/i.test(url.hostname)) {
        throw new Error('Unexpected review endpoint.');
      }

      const [sortBy, sortDirection] = getSort();
      const nextPage = apiPage + 1;
      const shopDomain =
        window.Shopify?.shop || window.location.hostname;

      url.searchParams.set('shop_domain', shopDomain);
      url.searchParams.set('url', shopDomain);
      url.searchParams.set('platform', 'shopify');
      url.searchParams.set('product_id', productId);
      url.searchParams.set('page', String(nextPage));
      url.searchParams.set(
        'per_page',
        String(reviewApiPageSize)
      );
      url.searchParams.set('sort_by', sortBy);

      if (sortDirection) {
        url.searchParams.set('sort_dir', sortDirection);
      }

      const response = await fetch(url, {
        headers: {
          Accept: 'application/json',
        },
        credentials: 'omit',
      });

      if (!response.ok) {
        throw new Error(
          `Reviews could not be loaded: ${response.status}`
        );
      }

      const data = await response.json();
      const parsed = new DOMParser().parseFromString(
        data.html || '',
        'text/html'
      );

      const fetchedCards = [
        ...parsed.querySelectorAll(
          '.jdgm-rev-widg__reviews > .jdgm-rev'
        ),
      ].map(normaliseReviewCard);

      if (
        !fetchedCards.length &&
        Number(data.total_count) > 0
      ) {
        throw new Error(
          'Judge.me returned no review cards.'
        );
      }

      totalCount = Number(data.total_count) || totalCount;

      if (nextPage === 1) {
        list.replaceChildren(...fetchedCards);
      } else {
        const existingIds = new Set(
          getCards()
            .map((card) => card.dataset.reviewId)
            .filter(Boolean)
        );

        fetchedCards.forEach((card) => {
          const reviewId = card.dataset.reviewId;

          if (!reviewId || !existingIds.has(reviewId)) {
            list.append(card);
          }
        });
      }

      apiPage = nextPage;
      getCards().forEach(normaliseReviewCard);
    };

    const useNativePagination = () => {
      widget.removeAttribute(
        'data-review-disclosure-ready'
      );

      controls.hidden = true;

      getCards().forEach((card) => {
        card.hidden = false;
      });

      pagination?.removeAttribute('hidden');
      pagination?.style.removeProperty('display');
    };

    loadMore.addEventListener('click', async () => {
      if (loading) return;

      const targetCount = Math.min(
        visibleCount + reviewBatchSize,
        totalCount
      );

      loading = true;
      loadMore.disabled = true;
      loadMore.setAttribute('aria-busy', 'true');
      loadMoreLabel.textContent = 'loading reviews';

      try {
        if (
          apiPage === 0 ||
          targetCount > getCards().length
        ) {
          await fetchReviewPage();
        }

        visibleCount = Math.min(
          targetCount,
          getCards().length
        );

        render();
      } catch (error) {
        console.error(error);
        status.textContent =
          'More reviews could not be loaded.';
        useNativePagination();
      } finally {
        loading = false;
        loadMore.disabled = false;
        loadMore.removeAttribute('aria-busy');
        loadMoreLabel.textContent = 'load more reviews';
      }
    });

    showFewer.addEventListener('click', () => {
      const before =
        controls.getBoundingClientRect().top;

      visibleCount = Math.min(
        reviewInitialCount,
        totalCount
      );

      render();

      const after =
        controls.getBoundingClientRect().top;

      window.scrollBy({
        top: after - before,
        left: 0,
        behavior: 'auto',
      });

      loadMore.focus({ preventScroll: true });
    });

    const sortObserver = new MutationObserver(() => {
      if (!sortResetTimer) return;

      const nextList = widget.querySelector(
        '.jdgm-rev-widg__reviews'
      );

      if (
        !nextList ||
        (
          nextList === list &&
          nextList.querySelector(
            ':scope > .jdgm-rev'
          ) === sortFirstCard
        )
      ) {
        return;
      }

      window.clearTimeout(sortResetTimer);

      sortResetTimer = window.setTimeout(() => {
        const nextPagination =
          widget.querySelector('.jdgm-paginate');

        if (!nextList || !nextPagination) return;

        list = nextList;
        pagination = nextPagination;
        totalCount = readTotal();
        visibleCount = Math.min(
          reviewInitialCount,
          totalCount
        );
        apiPage = 0;

        if (!list.id) {
          list.id =
            `${widget.id || 'judgeme'}-visible-reviews`;
        }

        loadMore.setAttribute(
          'aria-controls',
          list.id
        );

        showFewer.setAttribute(
          'aria-controls',
          list.id
        );

        placeControls();
        render();

        sortResetTimer = undefined;
        sortFirstCard = undefined;
      }, 120);
    });

    sortObserver.observe(widget, {
      childList: true,
      subtree: true,
    });

    widget.addEventListener('change', (event) => {
      if (
        !(event.target instanceof Element) ||
        !event.target.matches('.jdgm-sort-dropdown')
      ) {
        return;
      }

      sortFirstCard = getCards()[0];

      sortResetTimer = window.setTimeout(() => {
        sortResetTimer = undefined;
        sortFirstCard = undefined;
      }, 8000);
    });

    placeControls();
    render();

    reviewDisclosureControllers.set(widget, true);
  };

  const initialiseReviewDisclosures = () => {
    document
      .querySelectorAll(
        '.pdp-reviews #judgeme_product_reviews.jdgm--done-setup-widget'
      )
      .forEach(initialiseReviewDisclosure);
  };

  initialiseReviewDisclosures();

  document
    .querySelectorAll('[data-review-grid]')
    .forEach((grid) => {
      const observer = new MutationObserver(
        initialiseReviewDisclosures
      );

      observer.observe(grid, {
        childList: true,
        subtree: true,
      });
    });


  const reviewDisclosureObservers = new WeakSet();
  let reviewDisclosureId = 0;

  const enhanceLongReview = (reviewBody) => {
    const reviewCard =
      reviewBody.closest('.jdgm-rev') ||
      (document.querySelector('.bundle-product-page--historical-reviews')
        ? reviewBody.closest('.jdgm-review-card')
        : null);

    if (!reviewCard) return;

    if (reviewCard.classList.contains('jdgm-review-card')) {
      reviewCard.removeAttribute('tabindex');
    }

    /*
     * Keep one existing disclosure and remove any duplicates
     * created during a Judge.me refresh.
     */
    const existingControls = [
      ...reviewCard.querySelectorAll(
        '.inlet-review-disclosure'
      ),
    ];

    if (existingControls.length) {
      existingControls
        .slice(1)
        .forEach((control) => control.remove());

      reviewBody.dataset.inletReviewDisclosure =
        'ready';

      return;
    }

    const disclosureState =
      reviewBody.dataset.inletReviewDisclosure;

    if (
      disclosureState === 'measuring' ||
      disclosureState === 'short'
    ) {
      return;
    }

    /*
     * Mark this review before measuring it so simultaneous
     * Judge.me mutations cannot schedule another button.
     */
    reviewBody.dataset.inletReviewDisclosure =
      'measuring';

    /*
     * Remove Judge.me's own truncated state before applying
     * the Inlet disclosure.
     */
    try {
      window.jdgm
        ?.$?.(reviewBody)
        ?.trigger?.('destroy.dot');
    } catch (error) {
      /* Judge.me may not have finished loading yet. */
    }

    reviewCard
      .querySelectorAll(
        '.jdgm-rev__body-read-more'
      )
      .forEach((control) => control.remove());

    reviewBody.classList.add(
      'inlet-review-copy--collapsed'
    );

    reviewBody.classList.remove(
      'inlet-review-copy--expanded'
    );

    const measureReview = (attempt = 0) => {
      if (!reviewBody.isConnected) return;

      if (
        reviewBody.getBoundingClientRect().width === 0
      ) {
        if (attempt < 8) {
          window.setTimeout(
            () => measureReview(attempt + 1),
            80
          );
        } else {
          delete reviewBody.dataset
            .inletReviewDisclosure;
        }

        return;
      }

      let needsDisclosure =
        reviewBody.scrollHeight >
        reviewBody.clientHeight + 2;

      // Measure Reviews Grid text against its actual line limit.
      if (reviewCard.classList.contains('jdgm-review-card')) {
        const computed = window.getComputedStyle(reviewBody);
        const lineCount = Number.parseInt(computed.webkitLineClamp, 10);
        const lineHeight = Number.parseFloat(computed.lineHeight);

        if (Number.isFinite(lineCount) && Number.isFinite(lineHeight)) {
          const previousStyle = reviewBody.getAttribute('style');

          reviewBody.style.setProperty('display', 'block', 'important');
          reviewBody.style.setProperty('-webkit-line-clamp', 'unset', 'important');
          reviewBody.style.setProperty('height', 'auto', 'important');
          reviewBody.style.setProperty('max-height', 'none', 'important');
          reviewBody.style.setProperty('overflow', 'visible', 'important');

          const fullHeight = reviewBody.getBoundingClientRect().height;

          if (previousStyle === null) {
            reviewBody.removeAttribute('style');
          } else {
            reviewBody.setAttribute('style', previousStyle);
          }

          needsDisclosure = fullHeight > lineHeight * lineCount + 2;
        }
      }

      if (!needsDisclosure) {
        reviewBody.classList.remove(
          'inlet-review-copy--collapsed'
        );

        reviewBody.dataset.inletReviewDisclosure =
          'short';

        return;
      }

      /*
       * Check again after measuring in case another process
       * completed first.
       */
      const existingControl =
        reviewCard.querySelector(
          '.inlet-review-disclosure'
        );

      if (existingControl) {
        reviewBody.dataset.inletReviewDisclosure =
          'ready';

        return;
      }

      if (!reviewBody.id) {
        reviewDisclosureId += 1;

        reviewBody.id =
          `InletReviewBody${reviewDisclosureId}`;
      }

      const button =
        document.createElement('button');

      button.type = 'button';

      button.className =
        'inlet-review-disclosure pdp-write-review-link';

      button.textContent = 'read full review';

      button.setAttribute(
        'aria-expanded',
        'false'
      );

      button.setAttribute(
        'aria-controls',
        reviewBody.id
      );

      reviewBody.insertAdjacentElement(
        'afterend',
        button
      );

      reviewBody.dataset.inletReviewDisclosure =
        'ready';

      button.addEventListener('click', (event) => {
        if (reviewCard.classList.contains('jdgm-review-card')) {
          event.stopPropagation();
        }

        const willExpand =
          button.getAttribute('aria-expanded') !==
          'true';

        const buttonPosition =
          button.getBoundingClientRect().top;

        reviewBody.classList.toggle(
          'inlet-review-copy--collapsed',
          !willExpand
        );

        reviewBody.classList.toggle(
          'inlet-review-copy--expanded',
          willExpand
        );

        reviewCard.classList.toggle(
          'inlet-review-card--expanded',
          willExpand
        );

        button.setAttribute(
          'aria-expanded',
          String(willExpand)
        );

        button.textContent = willExpand
          ? 'show less'
          : 'read full review';


        if (!willExpand) {
          const positionChange =
            button.getBoundingClientRect().top -
            buttonPosition;

          window.scrollBy(0, positionChange);

          button.focus({
            preventScroll: true,
          });
        }
      });
    };

    window.requestAnimationFrame(() => {
      measureReview();
    });
  };

  const initialiseLongReviews = (section) => {
    section
      .querySelectorAll('.jdgm-rev__body')
      .forEach(enhanceLongReview);
  };

  const observeLongReviews = (section) => {
    if (reviewDisclosureObservers.has(section)) {
      return;
    }

    initialiseLongReviews(section);

    const observer = new MutationObserver(() => {
      initialiseLongReviews(section);
    });

    observer.observe(section, {
      childList: true,
      subtree: true,
    });

    reviewDisclosureObservers.add(section);
  };

  document
    .querySelectorAll('.pdp-reviews')
    .forEach(observeLongReviews);

  const historicalReviewsContainer = document.querySelector(
    '.bundle-product-page--historical-reviews .pdp-review-grid'
  );

  if (historicalReviewsContainer) {
    const initialiseHistoricalReviews = () => {
      historicalReviewsContainer
        .querySelectorAll(
          '.jdgm-grid-body .jdgm-review-card__details-description'
        )
        .forEach(enhanceLongReview);
    };

    initialiseHistoricalReviews();

    const historicalObserver = new MutationObserver(
      initialiseHistoricalReviews
    );

    historicalObserver.observe(historicalReviewsContainer, {
      childList: true,
      subtree: true,
    });

    historicalReviewsContainer.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const card = event.target.closest(
        '.jdgm-grid-body .jdgm-review-card'
      );

      if (!card || event.target.closest('.inlet-review-disclosure')) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);

    historicalReviewsContainer.addEventListener('keydown', (event) => {
      if (
        event.target instanceof Element &&
        event.target.matches('.jdgm-grid-body .jdgm-review-card') &&
        (event.key === 'Enter' || event.key === ' ')
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const visibleForm = [
        ...document.querySelectorAll(
          `.pdp-reviews ${reviewFormSelector}`
        ),
      ].find(reviewFormIsVisible);

      if (visibleForm) {
        const context = getReviewContext(visibleForm);

        if (context) {
          event.preventDefault();
          closeReviewForm(context);
          return;
        }
      }

      if (searchPanel && !searchPanel.hidden) {
        setSearch(false);
      }
    }
  });
})();

